var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/components/AbstractLink.tsx
import { jsx } from "react/jsx-runtime";
function AbstractLink(_a) {
  var _b = _a, {
    children,
    linkid,
    to
  } = _b, linkProps = __objRest(_b, [
    "children",
    "linkid",
    "to"
  ]);
  return /* @__PURE__ */ jsx("a", __spreadProps(__spreadValues({ href: to }, linkProps), { "data-testid": `plain-link::${linkid}`, children }));
}

// ../../node_modules/@radix-ui/react-popover/dist/index.mjs
import * as React28 from "react";

// ../../node_modules/@radix-ui/primitive/dist/index.mjs
function composeEventHandlers(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = true } = {}) {
  return function handleEvent(event) {
    originalEventHandler == null ? void 0 : originalEventHandler(event);
    if (checkForDefaultPrevented === false || !event.defaultPrevented) {
      return ourEventHandler == null ? void 0 : ourEventHandler(event);
    }
  };
}

// ../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
import * as React from "react";
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref !== null && ref !== void 0) {
    ref.current = value;
  }
}
function composeRefs(...refs) {
  return (node) => refs.forEach((ref) => setRef(ref, node));
}
function useComposedRefs(...refs) {
  return React.useCallback(composeRefs(...refs), refs);
}

// ../../node_modules/@radix-ui/react-context/dist/index.mjs
import * as React2 from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
function createContextScope(scopeName, createContextScopeDeps = []) {
  let defaultContexts = [];
  function createContext32(rootComponentName, defaultContext) {
    const BaseContext = React2.createContext(defaultContext);
    const index2 = defaultContexts.length;
    defaultContexts = [...defaultContexts, defaultContext];
    function Provider2(props) {
      const _a = props, { scope, children } = _a, context = __objRest(_a, ["scope", "children"]);
      const Context = (scope == null ? void 0 : scope[scopeName][index2]) || BaseContext;
      const value = React2.useMemo(() => context, Object.values(context));
      return /* @__PURE__ */ jsx2(Context.Provider, { value, children });
    }
    function useContext22(consumerName, scope) {
      const Context = (scope == null ? void 0 : scope[scopeName][index2]) || BaseContext;
      const context = React2.useContext(Context);
      if (context)
        return context;
      if (defaultContext !== void 0)
        return defaultContext;
      throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider2.displayName = rootComponentName + "Provider";
    return [Provider2, useContext22];
  }
  const createScope = () => {
    const scopeContexts = defaultContexts.map((defaultContext) => {
      return React2.createContext(defaultContext);
    });
    return function useScope(scope) {
      const contexts = (scope == null ? void 0 : scope[scopeName]) || scopeContexts;
      return React2.useMemo(
        () => ({ [`__scope${scopeName}`]: __spreadProps(__spreadValues({}, scope), { [scopeName]: contexts }) }),
        [scope, contexts]
      );
    };
  };
  createScope.scopeName = scopeName;
  return [createContext32, composeContextScopes(createScope, ...createContextScopeDeps)];
}
function composeContextScopes(...scopes) {
  const baseScope = scopes[0];
  if (scopes.length === 1)
    return baseScope;
  const createScope = () => {
    const scopeHooks = scopes.map((createScope2) => ({
      useScope: createScope2(),
      scopeName: createScope2.scopeName
    }));
    return function useComposedScopes(overrideScopes) {
      const nextScopes = scopeHooks.reduce((nextScopes2, { useScope, scopeName }) => {
        const scopeProps = useScope(overrideScopes);
        const currentScope = scopeProps[`__scope${scopeName}`];
        return __spreadValues(__spreadValues({}, nextScopes2), currentScope);
      }, {});
      return React2.useMemo(() => ({ [`__scope${baseScope.scopeName}`]: nextScopes }), [nextScopes]);
    };
  };
  createScope.scopeName = baseScope.scopeName;
  return createScope;
}

// ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
import * as React7 from "react";

// ../../node_modules/@radix-ui/react-primitive/dist/index.mjs
import * as React4 from "react";
import * as ReactDOM from "react-dom";

// ../../node_modules/@radix-ui/react-primitive/node_modules/@radix-ui/react-slot/dist/index.mjs
import * as React3 from "react";
import { Fragment, jsx as jsx3 } from "react/jsx-runtime";
var Slot = React3.forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  const childrenArray = React3.Children.toArray(children);
  const slottable = childrenArray.find(isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (React3.Children.count(newElement) > 1)
          return React3.Children.only(null);
        return React3.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */ jsx3(SlotClone, __spreadProps(__spreadValues({}, slotProps), { ref: forwardedRef, children: React3.isValidElement(newElement) ? React3.cloneElement(newElement, void 0, newChildren) : null }));
  }
  return /* @__PURE__ */ jsx3(SlotClone, __spreadProps(__spreadValues({}, slotProps), { ref: forwardedRef, children }));
});
Slot.displayName = "Slot";
var SlotClone = React3.forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  if (React3.isValidElement(children)) {
    const childrenRef = getElementRef(children);
    return React3.cloneElement(children, __spreadProps(__spreadValues({}, mergeProps(slotProps, children.props)), {
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React3.Children.count(children) > 1 ? React3.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = ({ children }) => {
  return /* @__PURE__ */ jsx3(Fragment, { children });
};
function isSlottable(child) {
  return React3.isValidElement(child) && child.type === Slottable;
}
function mergeProps(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}
function getElementRef(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

// ../../node_modules/@radix-ui/react-primitive/dist/index.mjs
import { jsx as jsx4 } from "react/jsx-runtime";
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
];
var Primitive = NODES.reduce((primitive, node) => {
  const Node2 = React4.forwardRef((props, forwardedRef) => {
    const _a = props, { asChild } = _a, primitiveProps = __objRest(_a, ["asChild"]);
    const Comp = asChild ? Slot : node;
    if (typeof window !== "undefined") {
      window[Symbol.for("radix-ui")] = true;
    }
    return /* @__PURE__ */ jsx4(Comp, __spreadProps(__spreadValues({}, primitiveProps), { ref: forwardedRef }));
  });
  Node2.displayName = `Primitive.${node}`;
  return __spreadProps(__spreadValues({}, primitive), { [node]: Node2 });
}, {});
function dispatchDiscreteCustomEvent(target, event) {
  if (target)
    ReactDOM.flushSync(() => target.dispatchEvent(event));
}

// ../../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
import * as React5 from "react";
function useCallbackRef(callback) {
  const callbackRef = React5.useRef(callback);
  React5.useEffect(() => {
    callbackRef.current = callback;
  });
  return React5.useMemo(() => (...args) => {
    var _a;
    return (_a = callbackRef.current) == null ? void 0 : _a.call(callbackRef, ...args);
  }, []);
}

// ../../node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs
import * as React6 from "react";
function useEscapeKeydown(onEscapeKeyDownProp, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const onEscapeKeyDown = useCallbackRef(onEscapeKeyDownProp);
  React6.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onEscapeKeyDown(event);
      }
    };
    ownerDocument.addEventListener("keydown", handleKeyDown, { capture: true });
    return () => ownerDocument.removeEventListener("keydown", handleKeyDown, { capture: true });
  }, [onEscapeKeyDown, ownerDocument]);
}

// ../../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
import { jsx as jsx5 } from "react/jsx-runtime";
var DISMISSABLE_LAYER_NAME = "DismissableLayer";
var CONTEXT_UPDATE = "dismissableLayer.update";
var POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var originalBodyPointerEvents;
var DismissableLayerContext = React7.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
});
var DismissableLayer = React7.forwardRef(
  (props, forwardedRef) => {
    var _b;
    const _a = props, {
      disableOutsidePointerEvents = false,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside,
      onDismiss
    } = _a, layerProps = __objRest(_a, [
      "disableOutsidePointerEvents",
      "onEscapeKeyDown",
      "onPointerDownOutside",
      "onFocusOutside",
      "onInteractOutside",
      "onDismiss"
    ]);
    const context = React7.useContext(DismissableLayerContext);
    const [node, setNode] = React7.useState(null);
    const ownerDocument = (_b = node == null ? void 0 : node.ownerDocument) != null ? _b : globalThis == null ? void 0 : globalThis.document;
    const [, force] = React7.useState({});
    const composedRefs = useComposedRefs(forwardedRef, (node2) => setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [...context.layersWithOutsidePointerEventsDisabled].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index2 = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index2 >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = usePointerDownOutside((event) => {
      const target = event.target;
      const isPointerDownOnBranch = [...context.branches].some((branch) => branch.contains(target));
      if (!isPointerEventsEnabled || isPointerDownOnBranch)
        return;
      onPointerDownOutside == null ? void 0 : onPointerDownOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented)
        onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    const focusOutside = useFocusOutside((event) => {
      const target = event.target;
      const isFocusInBranch = [...context.branches].some((branch) => branch.contains(target));
      if (isFocusInBranch)
        return;
      onFocusOutside == null ? void 0 : onFocusOutside(event);
      onInteractOutside == null ? void 0 : onInteractOutside(event);
      if (!event.defaultPrevented)
        onDismiss == null ? void 0 : onDismiss();
    }, ownerDocument);
    useEscapeKeydown((event) => {
      const isHighestLayer = index2 === context.layers.size - 1;
      if (!isHighestLayer)
        return;
      onEscapeKeyDown == null ? void 0 : onEscapeKeyDown(event);
      if (!event.defaultPrevented && onDismiss) {
        event.preventDefault();
        onDismiss();
      }
    }, ownerDocument);
    React7.useEffect(() => {
      if (!node)
        return;
      if (disableOutsidePointerEvents) {
        if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
          originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
          ownerDocument.body.style.pointerEvents = "none";
        }
        context.layersWithOutsidePointerEventsDisabled.add(node);
      }
      context.layers.add(node);
      dispatchUpdate();
      return () => {
        if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) {
          ownerDocument.body.style.pointerEvents = originalBodyPointerEvents;
        }
      };
    }, [node, ownerDocument, disableOutsidePointerEvents, context]);
    React7.useEffect(() => {
      return () => {
        if (!node)
          return;
        context.layers.delete(node);
        context.layersWithOutsidePointerEventsDisabled.delete(node);
        dispatchUpdate();
      };
    }, [node, context]);
    React7.useEffect(() => {
      const handleUpdate = () => force({});
      document.addEventListener(CONTEXT_UPDATE, handleUpdate);
      return () => document.removeEventListener(CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ jsx5(
      Primitive.div,
      __spreadProps(__spreadValues({}, layerProps), {
        ref: composedRefs,
        style: __spreadValues({
          pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0
        }, props.style),
        onFocusCapture: composeEventHandlers(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: composeEventHandlers(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          props.onPointerDownCapture,
          pointerDownOutside.onPointerDownCapture
        )
      })
    );
  }
);
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch";
var DismissableLayerBranch = React7.forwardRef((props, forwardedRef) => {
  const context = React7.useContext(DismissableLayerContext);
  const ref = React7.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  React7.useEffect(() => {
    const node = ref.current;
    if (node) {
      context.branches.add(node);
      return () => {
        context.branches.delete(node);
      };
    }
  }, [context.branches]);
  return /* @__PURE__ */ jsx5(Primitive.div, __spreadProps(__spreadValues({}, props), { ref: composedRefs }));
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handlePointerDownOutside = useCallbackRef(onPointerDownOutside);
  const isPointerInsideReactTreeRef = React7.useRef(false);
  const handleClickRef = React7.useRef(() => {
  });
  React7.useEffect(() => {
    const handlePointerDown = (event) => {
      if (event.target && !isPointerInsideReactTreeRef.current) {
        let handleAndDispatchPointerDownOutsideEvent2 = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            handlePointerDownOutside,
            eventDetail,
            { discrete: true }
          );
        };
        var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
        const eventDetail = { originalEvent: event };
        if (event.pointerType === "touch") {
          ownerDocument.removeEventListener("click", handleClickRef.current);
          handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
          ownerDocument.addEventListener("click", handleClickRef.current, { once: true });
        } else {
          handleAndDispatchPointerDownOutsideEvent2();
        }
      } else {
        ownerDocument.removeEventListener("click", handleClickRef.current);
      }
      isPointerInsideReactTreeRef.current = false;
    };
    const timerId = window.setTimeout(() => {
      ownerDocument.addEventListener("pointerdown", handlePointerDown);
    }, 0);
    return () => {
      window.clearTimeout(timerId);
      ownerDocument.removeEventListener("pointerdown", handlePointerDown);
      ownerDocument.removeEventListener("click", handleClickRef.current);
    };
  }, [ownerDocument, handlePointerDownOutside]);
  return {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => isPointerInsideReactTreeRef.current = true
  };
}
function useFocusOutside(onFocusOutside, ownerDocument = globalThis == null ? void 0 : globalThis.document) {
  const handleFocusOutside = useCallbackRef(onFocusOutside);
  const isFocusInsideReactTreeRef = React7.useRef(false);
  React7.useEffect(() => {
    const handleFocus = (event) => {
      if (event.target && !isFocusInsideReactTreeRef.current) {
        const eventDetail = { originalEvent: event };
        handleAndDispatchCustomEvent(FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
          discrete: false
        });
      }
    };
    ownerDocument.addEventListener("focusin", handleFocus);
    return () => ownerDocument.removeEventListener("focusin", handleFocus);
  }, [ownerDocument, handleFocusOutside]);
  return {
    onFocusCapture: () => isFocusInsideReactTreeRef.current = true,
    onBlurCapture: () => isFocusInsideReactTreeRef.current = false
  };
}
function dispatchUpdate() {
  const event = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(event);
}
function handleAndDispatchCustomEvent(name, handler, detail, { discrete }) {
  const target = detail.originalEvent.target;
  const event = new CustomEvent(name, { bubbles: false, cancelable: true, detail });
  if (handler)
    target.addEventListener(name, handler, { once: true });
  if (discrete) {
    dispatchDiscreteCustomEvent(target, event);
  } else {
    target.dispatchEvent(event);
  }
}

// ../../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
import * as React8 from "react";
var count = 0;
function useFocusGuards() {
  React8.useEffect(() => {
    var _a, _b;
    const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement("afterbegin", (_a = edgeGuards[0]) != null ? _a : createFocusGuard());
    document.body.insertAdjacentElement("beforeend", (_b = edgeGuards[1]) != null ? _b : createFocusGuard());
    count++;
    return () => {
      if (count === 1) {
        document.querySelectorAll("[data-radix-focus-guard]").forEach((node) => node.remove());
      }
      count--;
    };
  }, []);
}
function createFocusGuard() {
  const element = document.createElement("span");
  element.setAttribute("data-radix-focus-guard", "");
  element.tabIndex = 0;
  element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
  return element;
}

// ../../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
import * as React9 from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var EVENT_OPTIONS = { bubbles: false, cancelable: true };
var FOCUS_SCOPE_NAME = "FocusScope";
var FocusScope = React9.forwardRef((props, forwardedRef) => {
  const _a = props, {
    loop = false,
    trapped = false,
    onMountAutoFocus: onMountAutoFocusProp,
    onUnmountAutoFocus: onUnmountAutoFocusProp
  } = _a, scopeProps = __objRest(_a, [
    "loop",
    "trapped",
    "onMountAutoFocus",
    "onUnmountAutoFocus"
  ]);
  const [container, setContainer] = React9.useState(null);
  const onMountAutoFocus = useCallbackRef(onMountAutoFocusProp);
  const onUnmountAutoFocus = useCallbackRef(onUnmountAutoFocusProp);
  const lastFocusedElementRef = React9.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, (node) => setContainer(node));
  const focusScope = React9.useRef({
    paused: false,
    pause() {
      this.paused = true;
    },
    resume() {
      this.paused = false;
    }
  }).current;
  React9.useEffect(() => {
    if (trapped) {
      let handleFocusIn2 = function(event) {
        if (focusScope.paused || !container)
          return;
        const target = event.target;
        if (container.contains(target)) {
          lastFocusedElementRef.current = target;
        } else {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleFocusOut2 = function(event) {
        if (focusScope.paused || !container)
          return;
        const relatedTarget = event.relatedTarget;
        if (relatedTarget === null)
          return;
        if (!container.contains(relatedTarget)) {
          focus(lastFocusedElementRef.current, { select: true });
        }
      }, handleMutations2 = function(mutations) {
        const focusedElement = document.activeElement;
        if (focusedElement !== document.body)
          return;
        for (const mutation of mutations) {
          if (mutation.removedNodes.length > 0)
            focus(container);
        }
      };
      var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
      document.addEventListener("focusin", handleFocusIn2);
      document.addEventListener("focusout", handleFocusOut2);
      const mutationObserver = new MutationObserver(handleMutations2);
      if (container)
        mutationObserver.observe(container, { childList: true, subtree: true });
      return () => {
        document.removeEventListener("focusin", handleFocusIn2);
        document.removeEventListener("focusout", handleFocusOut2);
        mutationObserver.disconnect();
      };
    }
  }, [trapped, container, focusScope.paused]);
  React9.useEffect(() => {
    if (container) {
      focusScopesStack.add(focusScope);
      const previouslyFocusedElement = document.activeElement;
      const hasFocusedCandidate = container.contains(previouslyFocusedElement);
      if (!hasFocusedCandidate) {
        const mountEvent = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        container.addEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        container.dispatchEvent(mountEvent);
        if (!mountEvent.defaultPrevented) {
          focusFirst(removeLinks(getTabbableCandidates(container)), { select: true });
          if (document.activeElement === previouslyFocusedElement) {
            focus(container);
          }
        }
      }
      return () => {
        container.removeEventListener(AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
        setTimeout(() => {
          const unmountEvent = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          container.addEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          container.dispatchEvent(unmountEvent);
          if (!unmountEvent.defaultPrevented) {
            focus(previouslyFocusedElement != null ? previouslyFocusedElement : document.body, { select: true });
          }
          container.removeEventListener(AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
          focusScopesStack.remove(focusScope);
        }, 0);
      };
    }
  }, [container, onMountAutoFocus, onUnmountAutoFocus, focusScope]);
  const handleKeyDown = React9.useCallback(
    (event) => {
      if (!loop && !trapped)
        return;
      if (focusScope.paused)
        return;
      const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
      const focusedElement = document.activeElement;
      if (isTabKey && focusedElement) {
        const container2 = event.currentTarget;
        const [first, last] = getTabbableEdges(container2);
        const hasTabbableElementsInside = first && last;
        if (!hasTabbableElementsInside) {
          if (focusedElement === container2)
            event.preventDefault();
        } else {
          if (!event.shiftKey && focusedElement === last) {
            event.preventDefault();
            if (loop)
              focus(first, { select: true });
          } else if (event.shiftKey && focusedElement === first) {
            event.preventDefault();
            if (loop)
              focus(last, { select: true });
          }
        }
      }
    },
    [loop, trapped, focusScope.paused]
  );
  return /* @__PURE__ */ jsx6(Primitive.div, __spreadProps(__spreadValues({ tabIndex: -1 }, scopeProps), { ref: composedRefs, onKeyDown: handleKeyDown }));
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(candidates, { select = false } = {}) {
  const previouslyFocusedElement = document.activeElement;
  for (const candidate of candidates) {
    focus(candidate, { select });
    if (document.activeElement !== previouslyFocusedElement)
      return;
  }
}
function getTabbableEdges(container) {
  const candidates = getTabbableCandidates(container);
  const first = findVisible(candidates, container);
  const last = findVisible(candidates.reverse(), container);
  return [first, last];
}
function getTabbableCandidates(container) {
  const nodes = [];
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (node) => {
      const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
      if (node.disabled || node.hidden || isHiddenInput)
        return NodeFilter.FILTER_SKIP;
      return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  while (walker.nextNode())
    nodes.push(walker.currentNode);
  return nodes;
}
function findVisible(elements, container) {
  for (const element of elements) {
    if (!isHidden(element, { upTo: container }))
      return element;
  }
}
function isHidden(node, { upTo }) {
  if (getComputedStyle(node).visibility === "hidden")
    return true;
  while (node) {
    if (upTo !== void 0 && node === upTo)
      return false;
    if (getComputedStyle(node).display === "none")
      return true;
    node = node.parentElement;
  }
  return false;
}
function isSelectableInput(element) {
  return element instanceof HTMLInputElement && "select" in element;
}
function focus(element, { select = false } = {}) {
  if (element && element.focus) {
    const previouslyFocusedElement = document.activeElement;
    element.focus({ preventScroll: true });
    if (element !== previouslyFocusedElement && isSelectableInput(element) && select)
      element.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let stack = [];
  return {
    add(focusScope) {
      const activeFocusScope = stack[0];
      if (focusScope !== activeFocusScope) {
        activeFocusScope == null ? void 0 : activeFocusScope.pause();
      }
      stack = arrayRemove(stack, focusScope);
      stack.unshift(focusScope);
    },
    remove(focusScope) {
      var _a;
      stack = arrayRemove(stack, focusScope);
      (_a = stack[0]) == null ? void 0 : _a.resume();
    }
  };
}
function arrayRemove(array, item) {
  const updatedArray = [...array];
  const index2 = updatedArray.indexOf(item);
  if (index2 !== -1) {
    updatedArray.splice(index2, 1);
  }
  return updatedArray;
}
function removeLinks(items) {
  return items.filter((item) => item.tagName !== "A");
}

// ../../node_modules/@radix-ui/react-id/dist/index.mjs
import * as React11 from "react";

// ../../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
import * as React10 from "react";
var useLayoutEffect2 = Boolean(globalThis == null ? void 0 : globalThis.document) ? React10.useLayoutEffect : () => {
};

// ../../node_modules/@radix-ui/react-id/dist/index.mjs
var useReactId = React11["useId".toString()] || (() => void 0);
var count2 = 0;
function useId(deterministicId) {
  const [id, setId] = React11.useState(useReactId());
  useLayoutEffect2(() => {
    if (!deterministicId)
      setId((reactId) => reactId != null ? reactId : String(count2++));
  }, [deterministicId]);
  return deterministicId || (id ? `radix-${id}` : "");
}

// ../../node_modules/@radix-ui/react-popper/dist/index.mjs
import * as React15 from "react";

// ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sides = ["top", "right", "bottom", "left"];
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl)
        return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return __spreadValues({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, padding);
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

// ../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
var computePosition = (reference, floating, config) => __async(void 0, null, function* () {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(floating);
  let rects = yield platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = yield fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = __spreadProps(__spreadValues({}, middlewareData), {
      [name]: __spreadValues(__spreadValues({}, middlewareData[name]), data)
    });
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? yield platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
});
function detectOverflow(state, options) {
  return __async(this, null, function* () {
    var _await$platform$isEle;
    if (options === void 0) {
      options = {};
    }
    const {
      x,
      y,
      platform: platform2,
      rects,
      elements,
      strategy
    } = state;
    const {
      boundary = "clippingAncestors",
      rootBoundary = "viewport",
      elementContext = "floating",
      altBoundary = false,
      padding = 0
    } = evaluate(options, state);
    const paddingObject = getPaddingObject(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = rectToClientRect(yield platform2.getClippingRect({
      element: ((_await$platform$isEle = yield platform2.isElement == null ? void 0 : platform2.isElement(element)) != null ? _await$platform$isEle : true) ? element : element.contextElement || (yield platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
      boundary,
      rootBoundary,
      strategy
    }));
    const rect = elementContext === "floating" ? {
      x,
      y,
      width: rects.floating.width,
      height: rects.floating.height
    } : rects.reference;
    const offsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating);
    const offsetScale = (yield platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? (yield platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    };
    const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? yield platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements,
      rect,
      offsetParent,
      strategy
    }) : rect);
    return {
      top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
      bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
      left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
      right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
  });
}
var arrow = (options) => ({
  name: "arrow",
  options,
  fn(state) {
    return __async(this, null, function* () {
      const {
        x,
        y,
        placement,
        rects,
        platform: platform2,
        elements,
        middlewareData
      } = state;
      const {
        element,
        padding = 0
      } = evaluate(options, state) || {};
      if (element == null) {
        return {};
      }
      const paddingObject = getPaddingObject(padding);
      const coords = {
        x,
        y
      };
      const axis = getAlignmentAxis(placement);
      const length = getAxisLength(axis);
      const arrowDimensions = yield platform2.getDimensions(element);
      const isYAxis = axis === "y";
      const minProp = isYAxis ? "top" : "left";
      const maxProp = isYAxis ? "bottom" : "right";
      const clientProp = isYAxis ? "clientHeight" : "clientWidth";
      const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
      const startDiff = coords[axis] - rects.reference[axis];
      const arrowOffsetParent = yield platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element);
      let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
      if (!clientSize || !(yield platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
        clientSize = elements.floating[clientProp] || rects.floating[length];
      }
      const centerToReference = endDiff / 2 - startDiff / 2;
      const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
      const minPadding = min(paddingObject[minProp], largestPossiblePadding);
      const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
      const min$1 = minPadding;
      const max2 = clientSize - arrowDimensions[length] - maxPadding;
      const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
      const offset4 = clamp(min$1, center, max2);
      const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset4 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
      const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
      return {
        [axis]: coords[axis] + alignmentOffset,
        data: __spreadValues({
          [axis]: offset4,
          centerOffset: center - offset4 - alignmentOffset
        }, shouldAddOffset && {
          alignmentOffset
        }),
        reset: shouldAddOffset
      };
    });
  }
});
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$arrow, _middlewareData$flip;
        const {
          placement,
          middlewareData,
          rects,
          initialPlacement,
          platform: platform2,
          elements
        } = state;
        const _a2 = evaluate(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = true,
          fallbackPlacements: specifiedFallbackPlacements,
          fallbackStrategy = "bestFit",
          fallbackAxisSideDirection = "none",
          flipAlignment = true
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "mainAxis",
          "crossAxis",
          "fallbackPlacements",
          "fallbackStrategy",
          "fallbackAxisSideDirection",
          "flipAlignment"
        ]);
        if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        const side = getSide(placement);
        const initialSideAxis = getSideAxis(initialPlacement);
        const isBasePlacement = getSide(initialPlacement) === initialPlacement;
        const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
        const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
        const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
        if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
          fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
        }
        const placements2 = [initialPlacement, ...fallbackPlacements];
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const overflows = [];
        let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
        if (checkMainAxis) {
          overflows.push(overflow[side]);
        }
        if (checkCrossAxis) {
          const sides2 = getAlignmentSides(placement, rects, rtl);
          overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
        }
        overflowsData = [...overflowsData, {
          placement,
          overflows
        }];
        if (!overflows.every((side2) => side2 <= 0)) {
          var _middlewareData$flip2, _overflowsData$filter;
          const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
          const nextPlacement = placements2[nextIndex];
          if (nextPlacement) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
          let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
          if (!resetPlacement) {
            switch (fallbackStrategy) {
              case "bestFit": {
                var _overflowsData$filter2;
                const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === "y";
                  }
                  return true;
                }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement2) {
                  resetPlacement = placement2;
                }
                break;
              }
              case "initialPlacement":
                resetPlacement = initialPlacement;
                break;
            }
          }
          if (placement !== resetPlacement) {
            return {
              reset: {
                placement: resetPlacement
              }
            };
          }
        }
        return {};
      });
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
var hide = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          rects
        } = state;
        const _a2 = evaluate(options, state), {
          strategy = "referenceHidden"
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "strategy"
        ]);
        switch (strategy) {
          case "referenceHidden": {
            const overflow = yield detectOverflow(state, __spreadProps(__spreadValues({}, detectOverflowOptions), {
              elementContext: "reference"
            }));
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
          case "escaped": {
            const overflow = yield detectOverflow(state, __spreadProps(__spreadValues({}, detectOverflowOptions), {
              altBoundary: true
            }));
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
          default: {
            return {};
          }
        }
      });
    }
  };
};
function convertValueToCoords(state, options) {
  return __async(this, null, function* () {
    const {
      placement,
      platform: platform2,
      elements
    } = state;
    const rtl = yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating);
    const side = getSide(placement);
    const alignment = getAlignment(placement);
    const isVertical = getSideAxis(placement) === "y";
    const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = evaluate(options, state);
    let {
      mainAxis,
      crossAxis,
      alignmentAxis
    } = typeof rawValue === "number" ? {
      mainAxis: rawValue,
      crossAxis: 0,
      alignmentAxis: null
    } : __spreadValues({
      mainAxis: 0,
      crossAxis: 0,
      alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === "number") {
      crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    }
    return isVertical ? {
      x: crossAxis * crossAxisMulti,
      y: mainAxis * mainAxisMulti
    } : {
      x: mainAxis * mainAxisMulti,
      y: crossAxis * crossAxisMulti
    };
  });
}
var offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    fn(state) {
      return __async(this, null, function* () {
        var _middlewareData$offse, _middlewareData$arrow;
        const {
          x,
          y,
          placement,
          middlewareData
        } = state;
        const diffCoords = yield convertValueToCoords(state, options);
        if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
          return {};
        }
        return {
          x: x + diffCoords.x,
          y: y + diffCoords.y,
          data: __spreadProps(__spreadValues({}, diffCoords), {
            placement
          })
        };
      });
    }
  };
};
var shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          x,
          y,
          placement
        } = state;
        const _a2 = evaluate(options, state), {
          mainAxis: checkMainAxis = true,
          crossAxis: checkCrossAxis = false,
          limiter = {
            fn: (_ref) => {
              let {
                x: x2,
                y: y2
              } = _ref;
              return {
                x: x2,
                y: y2
              };
            }
          }
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "mainAxis",
          "crossAxis",
          "limiter"
        ]);
        const coords = {
          x,
          y
        };
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const crossAxis = getSideAxis(getSide(placement));
        const mainAxis = getOppositeAxis(crossAxis);
        let mainAxisCoord = coords[mainAxis];
        let crossAxisCoord = coords[crossAxis];
        if (checkMainAxis) {
          const minSide = mainAxis === "y" ? "top" : "left";
          const maxSide = mainAxis === "y" ? "bottom" : "right";
          const min2 = mainAxisCoord + overflow[minSide];
          const max2 = mainAxisCoord - overflow[maxSide];
          mainAxisCoord = clamp(min2, mainAxisCoord, max2);
        }
        if (checkCrossAxis) {
          const minSide = crossAxis === "y" ? "top" : "left";
          const maxSide = crossAxis === "y" ? "bottom" : "right";
          const min2 = crossAxisCoord + overflow[minSide];
          const max2 = crossAxisCoord - overflow[maxSide];
          crossAxisCoord = clamp(min2, crossAxisCoord, max2);
        }
        const limitedCoords = limiter.fn(__spreadProps(__spreadValues({}, state), {
          [mainAxis]: mainAxisCoord,
          [crossAxis]: crossAxisCoord
        }));
        return __spreadProps(__spreadValues({}, limitedCoords), {
          data: {
            x: limitedCoords.x - x,
            y: limitedCoords.y - y
          }
        });
      });
    }
  };
};
var limitShift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset4 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset4, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : __spreadValues({
        mainAxis: 0,
        crossAxis: 0
      }, rawOffset);
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = ["top", "left"].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
var size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    fn(state) {
      return __async(this, null, function* () {
        const {
          placement,
          rects,
          platform: platform2,
          elements
        } = state;
        const _a2 = evaluate(options, state), {
          apply = () => {
          }
        } = _a2, detectOverflowOptions = __objRest(_a2, [
          "apply"
        ]);
        const overflow = yield detectOverflow(state, detectOverflowOptions);
        const side = getSide(placement);
        const alignment = getAlignment(placement);
        const isYAxis = getSideAxis(placement) === "y";
        const {
          width,
          height
        } = rects.floating;
        let heightSide;
        let widthSide;
        if (side === "top" || side === "bottom") {
          heightSide = side;
          widthSide = alignment === ((yield platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
        } else {
          widthSide = side;
          heightSide = alignment === "end" ? "top" : "bottom";
        }
        const maximumClippingHeight = height - overflow.top - overflow.bottom;
        const maximumClippingWidth = width - overflow.left - overflow.right;
        const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
        const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
        const noShift = !state.middlewareData.shift;
        let availableHeight = overflowAvailableHeight;
        let availableWidth = overflowAvailableWidth;
        if (isYAxis) {
          availableWidth = alignment || noShift ? min(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
        } else {
          availableHeight = alignment || noShift ? min(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
        }
        if (noShift && !alignment) {
          const xMin = max(overflow.left, 0);
          const xMax = max(overflow.right, 0);
          const yMin = max(overflow.top, 0);
          const yMax = max(overflow.bottom, 0);
          if (isYAxis) {
            availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
          } else {
            availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
          }
        }
        yield apply(__spreadProps(__spreadValues({}, state), {
          availableWidth,
          availableHeight
        }));
        const nextDimensions = yield platform2.getDimensions(elements.floating);
        if (width !== nextDimensions.width || height !== nextDimensions.height) {
          return {
            reset: {
              rects: true
            }
          };
        }
        return {};
      });
    }
  };
};

// ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle2(elementOrCss) : elementOrCss;
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports)
    return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css = getComputedStyle2(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = __spreadProps(__spreadValues({}, clippingAncestor), {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    });
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const x = rect.left + scroll.scrollLeft - offsets.x;
  const y = rect.top + scroll.scrollTop - offsets.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle2(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = function(data) {
  return __async(this, null, function* () {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = yield getDimensionsFn(data.floating);
    return {
      reference: getRectRelativeToOffsetParent(data.reference, yield getOffsetParentFn(data.floating), data.strategy),
      floating: {
        x: 0,
        y: 0,
        width: floatingDimensions.width,
        height: floatingDimensions.height
      }
    };
  });
};
function isRTL(element) {
  return getComputedStyle2(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, __spreadProps(__spreadValues({}, options), {
        // Handle <iframe>s
        root: root.ownerDocument
      }));
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var offset2 = offset;
var shift2 = shift;
var flip2 = flip;
var size2 = size;
var hide2 = hide;
var arrow2 = arrow;
var limitShift2 = limitShift;
var computePosition2 = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = __spreadValues({
    platform
  }, options);
  const platformWithCache = __spreadProps(__spreadValues({}, mergedOptions.platform), {
    _c: cache
  });
  return computePosition(reference, floating, __spreadProps(__spreadValues({}, mergedOptions), {
    platform: platformWithCache
  }));
};

// ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
import * as React12 from "react";
import { useLayoutEffect as useLayoutEffect3, useEffect as useEffect6 } from "react";
import * as ReactDOM2 from "react-dom";
var index = typeof document !== "undefined" ? useLayoutEffect3 : useEffect6;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i;
  let keys;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length)
        return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React12.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React12.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React12.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React12.useState(null);
  const [_floating, _setFloating] = React12.useState(null);
  const setReference = React12.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React12.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React12.useRef(null);
  const floatingRef = React12.useRef(null);
  const dataRef = React12.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const update = React12.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition2(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = __spreadProps(__spreadValues({}, data2), {
        isPositioned: true
      });
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM2.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => __spreadProps(__spreadValues({}, data2), {
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React12.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl)
      referenceRef.current = referenceEl;
    if (floatingEl)
      floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React12.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React12.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React12.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return __spreadValues(__spreadProps(__spreadValues({}, initialStyles), {
        transform: "translate(" + x + "px, " + y + "px)"
      }), getDPR(elements.floating) >= 1.5 && {
        willChange: "transform"
      });
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React12.useMemo(() => __spreadProps(__spreadValues({}, data), {
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
var arrow$1 = (options) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === "function" ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow2({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow2({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
var offset3 = (options, deps) => __spreadProps(__spreadValues({}, offset2(options)), {
  options: [options, deps]
});
var shift3 = (options, deps) => __spreadProps(__spreadValues({}, shift2(options)), {
  options: [options, deps]
});
var limitShift3 = (options, deps) => __spreadProps(__spreadValues({}, limitShift2(options)), {
  options: [options, deps]
});
var flip3 = (options, deps) => __spreadProps(__spreadValues({}, flip2(options)), {
  options: [options, deps]
});
var size3 = (options, deps) => __spreadProps(__spreadValues({}, size2(options)), {
  options: [options, deps]
});
var hide3 = (options, deps) => __spreadProps(__spreadValues({}, hide2(options)), {
  options: [options, deps]
});
var arrow3 = (options, deps) => __spreadProps(__spreadValues({}, arrow$1(options)), {
  options: [options, deps]
});

// ../../node_modules/@radix-ui/react-arrow/dist/index.mjs
import * as React13 from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var NAME = "Arrow";
var Arrow = React13.forwardRef((props, forwardedRef) => {
  const _a = props, { children, width = 10, height = 5 } = _a, arrowProps = __objRest(_a, ["children", "width", "height"]);
  return /* @__PURE__ */ jsx7(
    Primitive.svg,
    __spreadProps(__spreadValues({}, arrowProps), {
      ref: forwardedRef,
      width,
      height,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: props.asChild ? children : /* @__PURE__ */ jsx7("polygon", { points: "0,0 30,0 15,10" })
    })
  );
});
Arrow.displayName = NAME;
var Root = Arrow;

// ../../node_modules/@radix-ui/react-use-size/dist/index.mjs
import * as React14 from "react";
function useSize(element) {
  const [size4, setSize] = React14.useState(void 0);
  useLayoutEffect2(() => {
    if (element) {
      setSize({ width: element.offsetWidth, height: element.offsetHeight });
      const resizeObserver = new ResizeObserver((entries) => {
        if (!Array.isArray(entries)) {
          return;
        }
        if (!entries.length) {
          return;
        }
        const entry = entries[0];
        let width;
        let height;
        if ("borderBoxSize" in entry) {
          const borderSizeEntry = entry["borderBoxSize"];
          const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
          width = borderSize["inlineSize"];
          height = borderSize["blockSize"];
        } else {
          width = element.offsetWidth;
          height = element.offsetHeight;
        }
        setSize({ width, height });
      });
      resizeObserver.observe(element, { box: "border-box" });
      return () => resizeObserver.unobserve(element);
    } else {
      setSize(void 0);
    }
  }, [element]);
  return size4;
}

// ../../node_modules/@radix-ui/react-popper/dist/index.mjs
import { jsx as jsx8 } from "react/jsx-runtime";
var POPPER_NAME = "Popper";
var [createPopperContext, createPopperScope] = createContextScope(POPPER_NAME);
var [PopperProvider, usePopperContext] = createPopperContext(POPPER_NAME);
var Popper = (props) => {
  const { __scopePopper, children } = props;
  const [anchor, setAnchor] = React15.useState(null);
  return /* @__PURE__ */ jsx8(PopperProvider, { scope: __scopePopper, anchor, onAnchorChange: setAnchor, children });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = React15.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopePopper, virtualRef } = _a, anchorProps = __objRest(_a, ["__scopePopper", "virtualRef"]);
    const context = usePopperContext(ANCHOR_NAME, __scopePopper);
    const ref = React15.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref);
    React15.useEffect(() => {
      context.onAnchorChange((virtualRef == null ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ jsx8(Primitive.div, __spreadProps(__spreadValues({}, anchorProps), { ref: composedRefs }));
  }
);
PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME = "PopperContent";
var [PopperContentProvider, useContentContext] = createPopperContext(CONTENT_NAME);
var PopperContent = React15.forwardRef(
  (props, forwardedRef) => {
    var _b, _c, _d, _e, _f, _g, _h, _i;
    const _a = props, {
      __scopePopper,
      side = "bottom",
      sideOffset = 0,
      align = "center",
      alignOffset = 0,
      arrowPadding = 0,
      avoidCollisions = true,
      collisionBoundary = [],
      collisionPadding: collisionPaddingProp = 0,
      sticky = "partial",
      hideWhenDetached = false,
      updatePositionStrategy = "optimized",
      onPlaced
    } = _a, contentProps = __objRest(_a, [
      "__scopePopper",
      "side",
      "sideOffset",
      "align",
      "alignOffset",
      "arrowPadding",
      "avoidCollisions",
      "collisionBoundary",
      "collisionPadding",
      "sticky",
      "hideWhenDetached",
      "updatePositionStrategy",
      "onPlaced"
    ]);
    const context = usePopperContext(CONTENT_NAME, __scopePopper);
    const [content, setContent] = React15.useState(null);
    const composedRefs = useComposedRefs(forwardedRef, (node) => setContent(node));
    const [arrow4, setArrow] = React15.useState(null);
    const arrowSize = useSize(arrow4);
    const arrowWidth = (_b = arrowSize == null ? void 0 : arrowSize.width) != null ? _b : 0;
    const arrowHeight = (_c = arrowSize == null ? void 0 : arrowSize.height) != null ? _c : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : __spreadValues({ top: 0, right: 0, bottom: 0, left: 0 }, collisionPaddingProp);
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
      padding: collisionPadding,
      boundary: boundary.filter(isNotNull),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: hasExplicitBoundaries
    };
    const { refs, floatingStyles, placement, isPositioned, middlewareData } = useFloating({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: (...args) => {
        const cleanup = autoUpdate(...args, {
          animationFrame: updatePositionStrategy === "always"
        });
        return cleanup;
      },
      elements: {
        reference: context.anchor
      },
      middleware: [
        offset3({ mainAxis: sideOffset + arrowHeight, alignmentAxis: alignOffset }),
        avoidCollisions && shift3(__spreadValues({
          mainAxis: true,
          crossAxis: false,
          limiter: sticky === "partial" ? limitShift3() : void 0
        }, detectOverflowOptions)),
        avoidCollisions && flip3(__spreadValues({}, detectOverflowOptions)),
        size3(__spreadProps(__spreadValues({}, detectOverflowOptions), {
          apply: ({ elements, rects, availableWidth, availableHeight }) => {
            const { width: anchorWidth, height: anchorHeight } = rects.reference;
            const contentStyle = elements.floating.style;
            contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
            contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
            contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
            contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
          }
        })),
        arrow4 && arrow3({ element: arrow4, padding: arrowPadding }),
        transformOrigin({ arrowWidth, arrowHeight }),
        hideWhenDetached && hide3(__spreadValues({ strategy: "referenceHidden" }, detectOverflowOptions))
      ]
    });
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const handlePlaced = useCallbackRef(onPlaced);
    useLayoutEffect2(() => {
      if (isPositioned) {
        handlePlaced == null ? void 0 : handlePlaced();
      }
    }, [isPositioned, handlePlaced]);
    const arrowX = (_d = middlewareData.arrow) == null ? void 0 : _d.x;
    const arrowY = (_e = middlewareData.arrow) == null ? void 0 : _e.y;
    const cannotCenterArrow = ((_f = middlewareData.arrow) == null ? void 0 : _f.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = React15.useState();
    useLayoutEffect2(() => {
      if (content)
        setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [content]);
    return /* @__PURE__ */ jsx8(
      "div",
      {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: __spreadValues(__spreadProps(__spreadValues({}, floatingStyles), {
          transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: contentZIndex,
          ["--radix-popper-transform-origin"]: [
            (_g = middlewareData.transformOrigin) == null ? void 0 : _g.x,
            (_h = middlewareData.transformOrigin) == null ? void 0 : _h.y
          ].join(" ")
        }), ((_i = middlewareData.hide) == null ? void 0 : _i.referenceHidden) && {
          visibility: "hidden",
          pointerEvents: "none"
        }),
        dir: props.dir,
        children: /* @__PURE__ */ jsx8(
          PopperContentProvider,
          {
            scope: __scopePopper,
            placedSide,
            onArrowChange: setArrow,
            arrowX,
            arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ jsx8(
              Primitive.div,
              __spreadProps(__spreadValues({
                "data-side": placedSide,
                "data-align": placedAlign
              }, contentProps), {
                ref: composedRefs,
                style: __spreadProps(__spreadValues({}, contentProps.style), {
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: !isPositioned ? "none" : void 0
                })
              })
            )
          }
        )
      }
    );
  }
);
PopperContent.displayName = CONTENT_NAME;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var PopperArrow = React15.forwardRef(function PopperArrow2(props, forwardedRef) {
  const _a = props, { __scopePopper } = _a, arrowProps = __objRest(_a, ["__scopePopper"]);
  const contentContext = useContentContext(ARROW_NAME, __scopePopper);
  const baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ jsx8(
      "span",
      {
        ref: contentContext.onArrowChange,
        style: {
          position: "absolute",
          left: contentContext.arrowX,
          top: contentContext.arrowY,
          [baseSide]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[contentContext.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: `rotate(180deg)`,
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[contentContext.placedSide],
          visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ jsx8(
          Root,
          __spreadProps(__spreadValues({}, arrowProps), {
            ref: forwardedRef,
            style: __spreadProps(__spreadValues({}, arrowProps.style), {
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            })
          })
        )
      }
    )
  );
});
PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
  return value !== null;
}
var transformOrigin = (options) => ({
  name: "transformOrigin",
  options,
  fn(data) {
    var _a, _b, _c, _d, _e;
    const { placement, rects, middlewareData } = data;
    const cannotCenterArrow = ((_a = middlewareData.arrow) == null ? void 0 : _a.centerOffset) !== 0;
    const isArrowHidden = cannotCenterArrow;
    const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
    const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
    const [placedSide, placedAlign] = getSideAndAlignFromPlacement(placement);
    const noArrowAlign = { start: "0%", center: "50%", end: "100%" }[placedAlign];
    const arrowXCenter = ((_c = (_b = middlewareData.arrow) == null ? void 0 : _b.x) != null ? _c : 0) + arrowWidth / 2;
    const arrowYCenter = ((_e = (_d = middlewareData.arrow) == null ? void 0 : _d.y) != null ? _e : 0) + arrowHeight / 2;
    let x = "";
    let y = "";
    if (placedSide === "bottom") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${-arrowHeight}px`;
    } else if (placedSide === "top") {
      x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
      y = `${rects.floating.height + arrowHeight}px`;
    } else if (placedSide === "right") {
      x = `${-arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    } else if (placedSide === "left") {
      x = `${rects.floating.width + arrowHeight}px`;
      y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
    }
    return { data: { x, y } };
  }
});
function getSideAndAlignFromPlacement(placement) {
  const [side, align = "center"] = placement.split("-");
  return [side, align];
}
var Root2 = Popper;
var Anchor = PopperAnchor;
var Content = PopperContent;
var Arrow2 = PopperArrow;

// ../../node_modules/@radix-ui/react-portal/dist/index.mjs
import * as React16 from "react";
import ReactDOM3 from "react-dom";
import { jsx as jsx9 } from "react/jsx-runtime";
var PORTAL_NAME = "Portal";
var Portal = React16.forwardRef((props, forwardedRef) => {
  var _b;
  const _a = props, { container: containerProp } = _a, portalProps = __objRest(_a, ["container"]);
  const [mounted, setMounted] = React16.useState(false);
  useLayoutEffect2(() => setMounted(true), []);
  const container = containerProp || mounted && ((_b = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : _b.body);
  return container ? ReactDOM3.createPortal(/* @__PURE__ */ jsx9(Primitive.div, __spreadProps(__spreadValues({}, portalProps), { ref: forwardedRef })), container) : null;
});
Portal.displayName = PORTAL_NAME;

// ../../node_modules/@radix-ui/react-presence/dist/index.mjs
import * as React22 from "react";
import * as ReactDOM4 from "react-dom";
import * as React17 from "react";
function useStateMachine(initialState2, machine) {
  return React17.useReducer((state, event) => {
    const nextState = machine[state][event];
    return nextState != null ? nextState : state;
  }, initialState2);
}
var Presence = (props) => {
  const { present, children } = props;
  const presence = usePresence(present);
  const child = typeof children === "function" ? children({ present: presence.isPresent }) : React22.Children.only(children);
  const ref = useComposedRefs(presence.ref, getElementRef2(child));
  const forceMount = typeof children === "function";
  return forceMount || presence.isPresent ? React22.cloneElement(child, { ref }) : null;
};
Presence.displayName = "Presence";
function usePresence(present) {
  const [node, setNode] = React22.useState();
  const stylesRef = React22.useRef({});
  const prevPresentRef = React22.useRef(present);
  const prevAnimationNameRef = React22.useRef("none");
  const initialState2 = present ? "mounted" : "unmounted";
  const [state, send] = useStateMachine(initialState2, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  React22.useEffect(() => {
    const currentAnimationName = getAnimationName(stylesRef.current);
    prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
  }, [state]);
  useLayoutEffect2(() => {
    const styles = stylesRef.current;
    const wasPresent = prevPresentRef.current;
    const hasPresentChanged = wasPresent !== present;
    if (hasPresentChanged) {
      const prevAnimationName = prevAnimationNameRef.current;
      const currentAnimationName = getAnimationName(styles);
      if (present) {
        send("MOUNT");
      } else if (currentAnimationName === "none" || (styles == null ? void 0 : styles.display) === "none") {
        send("UNMOUNT");
      } else {
        const isAnimating = prevAnimationName !== currentAnimationName;
        if (wasPresent && isAnimating) {
          send("ANIMATION_OUT");
        } else {
          send("UNMOUNT");
        }
      }
      prevPresentRef.current = present;
    }
  }, [present, send]);
  useLayoutEffect2(() => {
    if (node) {
      const handleAnimationEnd = (event) => {
        const currentAnimationName = getAnimationName(stylesRef.current);
        const isCurrentAnimation = currentAnimationName.includes(event.animationName);
        if (event.target === node && isCurrentAnimation) {
          ReactDOM4.flushSync(() => send("ANIMATION_END"));
        }
      };
      const handleAnimationStart = (event) => {
        if (event.target === node) {
          prevAnimationNameRef.current = getAnimationName(stylesRef.current);
        }
      };
      node.addEventListener("animationstart", handleAnimationStart);
      node.addEventListener("animationcancel", handleAnimationEnd);
      node.addEventListener("animationend", handleAnimationEnd);
      return () => {
        node.removeEventListener("animationstart", handleAnimationStart);
        node.removeEventListener("animationcancel", handleAnimationEnd);
        node.removeEventListener("animationend", handleAnimationEnd);
      };
    } else {
      send("ANIMATION_END");
    }
  }, [node, send]);
  return {
    isPresent: ["mounted", "unmountSuspended"].includes(state),
    ref: React22.useCallback((node2) => {
      if (node2)
        stylesRef.current = getComputedStyle(node2);
      setNode(node2);
    }, [])
  };
}
function getAnimationName(styles) {
  return (styles == null ? void 0 : styles.animationName) || "none";
}
function getElementRef2(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

// ../../node_modules/@radix-ui/react-popover/node_modules/@radix-ui/react-slot/dist/index.mjs
import * as React18 from "react";
import { Fragment as Fragment2, jsx as jsx10 } from "react/jsx-runtime";
var Slot2 = React18.forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  const childrenArray = React18.Children.toArray(children);
  const slottable = childrenArray.find(isSlottable2);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (React18.Children.count(newElement) > 1)
          return React18.Children.only(null);
        return React18.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */ jsx10(SlotClone2, __spreadProps(__spreadValues({}, slotProps), { ref: forwardedRef, children: React18.isValidElement(newElement) ? React18.cloneElement(newElement, void 0, newChildren) : null }));
  }
  return /* @__PURE__ */ jsx10(SlotClone2, __spreadProps(__spreadValues({}, slotProps), { ref: forwardedRef, children }));
});
Slot2.displayName = "Slot";
var SlotClone2 = React18.forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  if (React18.isValidElement(children)) {
    const childrenRef = getElementRef3(children);
    return React18.cloneElement(children, __spreadProps(__spreadValues({}, mergeProps2(slotProps, children.props)), {
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React18.Children.count(children) > 1 ? React18.Children.only(null) : null;
});
SlotClone2.displayName = "SlotClone";
var Slottable2 = ({ children }) => {
  return /* @__PURE__ */ jsx10(Fragment2, { children });
};
function isSlottable2(child) {
  return React18.isValidElement(child) && child.type === Slottable2;
}
function mergeProps2(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}
function getElementRef3(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

// ../../node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
import * as React19 from "react";
function useControllableState({
  prop,
  defaultProp,
  onChange = () => {
  }
}) {
  const [uncontrolledProp, setUncontrolledProp] = useUncontrolledState({ defaultProp, onChange });
  const isControlled = prop !== void 0;
  const value = isControlled ? prop : uncontrolledProp;
  const handleChange = useCallbackRef(onChange);
  const setValue = React19.useCallback(
    (nextValue) => {
      if (isControlled) {
        const setter = nextValue;
        const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
        if (value2 !== prop)
          handleChange(value2);
      } else {
        setUncontrolledProp(nextValue);
      }
    },
    [isControlled, prop, setUncontrolledProp, handleChange]
  );
  return [value, setValue];
}
function useUncontrolledState({
  defaultProp,
  onChange
}) {
  const uncontrolledState = React19.useState(defaultProp);
  const [value] = uncontrolledState;
  const prevValueRef = React19.useRef(value);
  const handleChange = useCallbackRef(onChange);
  React19.useEffect(() => {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}

// ../../node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x) {
    return Boolean(x);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        try {
          var attr = node.getAttribute(controlAttribute);
          var alreadyHidden = attr !== null && attr !== "false";
          var counterValue = (counterMap.get(node) || 0) + 1;
          var markerValue = (markerCounter.get(node) || 0) + 1;
          counterMap.set(node, counterValue);
          markerCounter.set(node, markerValue);
          hiddenNodes.push(node);
          if (counterValue === 1 && alreadyHidden) {
            uncontrolledNodes.set(node, true);
          }
          if (markerValue === 1) {
            node.setAttribute(markerName, "true");
          }
          if (!alreadyHidden) {
            node.setAttribute(controlAttribute, "true");
          }
        } catch (e) {
          console.error("aria-hidden: cannot operate on ", node, e);
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};

// ../../node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i);
        ar[i] = from[i];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}

// ../../node_modules/react-remove-scroll/dist/es2015/Combination.js
import * as React27 from "react";

// ../../node_modules/react-remove-scroll/dist/es2015/UI.js
import * as React23 from "react";

// ../../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = "right-scroll-bar-position";
var fullWidthClassName = "width-before-scroll-bar";
var noScrollbarsClassName = "with-scroll-bars-hidden";
var removedBarSizeVariable = "--removed-body-scroll-bar-size";

// ../../node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

// ../../node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as useState10 } from "react";
function useCallbackRef2(initialValue, callback) {
  var ref = useState10(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}

// ../../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
import * as React20 from "react";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React20.useLayoutEffect : React20.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef2(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

// ../../node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}

// ../../node_modules/use-sidecar/dist/es2015/exports.js
import * as React21 from "react";
var SideCar = function(_a) {
  var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error("Sidecar medium not found");
  }
  return React21.createElement(Target, __assign({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}

// ../../node_modules/react-remove-scroll/dist/es2015/medium.js
var effectCar = createSidecarMedium();

// ../../node_modules/react-remove-scroll/dist/es2015/UI.js
var nothing = function() {
  return;
};
var RemoveScroll = React23.forwardRef(function(props, parentRef) {
  var ref = React23.useRef(null);
  var _a = React23.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), callbacks = _a[0], setCallbacks = _a[1];
  var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar2 = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = __assign(__assign({}, rest), callbacks);
  return React23.createElement(
    React23.Fragment,
    null,
    enabled && React23.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode }),
    forwardProps ? React23.cloneElement(React23.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React23.createElement(Container, __assign({}, containerProps, { className, ref: containerRef }), children)
  );
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};

// ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
import * as React26 from "react";

// ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js
import * as React25 from "react";

// ../../node_modules/react-style-singleton/dist/es2015/hook.js
import * as React24 from "react";

// ../../node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var getNonce = function() {
  if (currentNonce) {
    return currentNonce;
  }
  if (typeof __webpack_nonce__ !== "undefined") {
    return __webpack_nonce__;
  }
  return void 0;
};

// ../../node_modules/react-style-singleton/dist/es2015/singleton.js
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function() {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function(style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function() {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};

// ../../node_modules/react-style-singleton/dist/es2015/hook.js
var styleHookSingleton = function() {
  var sheet = stylesheetSingleton();
  return function(styles, isDynamic) {
    React24.useEffect(function() {
      sheet.add(styles);
      return function() {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};

// ../../node_modules/react-style-singleton/dist/es2015/component.js
var styleSingleton = function() {
  var useStyle = styleHookSingleton();
  var Sheet = function(_a) {
    var styles = _a.styles, dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};

// ../../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function(x) {
  return parseInt(x || "", 10) || 0;
};
var getOffset = function(gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
  var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
  var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function(gapMode) {
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  if (typeof window === "undefined") {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};

// ../../node_modules/react-remove-scroll-bar/dist/es2015/component.js
var Style = styleSingleton();
var lockAttribute = "data-scroll-locked";
var getStyles = function(_a, allowRelative, gapMode, important) {
  var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = "margin";
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
    allowRelative && "position: relative ".concat(important, ";"),
    gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
    gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
  ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
var getCurrentUseCounter = function() {
  var counter = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(counter) ? counter : 0;
};
var useLockAttribute = function() {
  React25.useEffect(function() {
    document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
    return function() {
      var newCounter = getCurrentUseCounter() - 1;
      if (newCounter <= 0) {
        document.body.removeAttribute(lockAttribute);
      } else {
        document.body.setAttribute(lockAttribute, newCounter.toString());
      }
    };
  }, []);
};
var RemoveScrollBar = function(_a) {
  var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
  useLockAttribute();
  var gap = React25.useMemo(function() {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return React25.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
};

// ../../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== "undefined") {
  try {
    options = Object.defineProperty({}, "passive", {
      get: function() {
        passiveSupported = true;
        return true;
      }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var options;
var nonPassive = passiveSupported ? { passive: false } : false;

// ../../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function(node) {
  return node.tagName === "TEXTAREA";
};
var elementCanBeScrolled = function(node, overflow) {
  var styles = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === "visible")
  );
};
var elementCouldBeVScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowY");
};
var elementCouldBeHScrolled = function(node) {
  return elementCanBeScrolled(node, "overflowX");
};
var locationCouldBeScrolled = function(axis, node) {
  var ownerDocument = node.ownerDocument;
  var current = node;
  do {
    if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current), s = _a[1], d = _a[2];
      if (s > d) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function(_a) {
  var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
  return [
    scrollTop,
    scrollHeight,
    clientHeight
  ];
};
var getHScrollVariables = function(_a) {
  var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
  return [
    scrollLeft,
    scrollWidth,
    clientWidth
  ];
};
var elementCouldBeScrolled = function(axis, node) {
  return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function(axis, node) {
  return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function(axis, direction) {
  return axis === "h" && direction === "rtl" ? -1 : 1;
};
var handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    if (target instanceof ShadowRoot) {
      target = target.host;
    } else {
      target = target.parentNode;
    }
  } while (
    // portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target)
  );
  if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};

// ../../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
var getTouchXY = function(event) {
  return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function(event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var deltaCompare = function(x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function(id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = React26.useRef([]);
  var touchStartRef = React26.useRef([0, 0]);
  var activeAxis = React26.useRef();
  var id = React26.useState(idCounter++)[0];
  var Style2 = React26.useState(styleSingleton)[0];
  var lastProps = React26.useRef(props);
  React26.useEffect(function() {
    lastProps.current = props;
  }, [props]);
  React26.useEffect(function() {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = React26.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React26.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e) {
      return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React26.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should, shadowParent: getOutermostShadowParent(target) };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React26.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React26.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = React26.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  React26.useEffect(function() {
    lockStack.push(Style2);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar, inert = props.inert;
  return React26.createElement(
    React26.Fragment,
    null,
    inert ? React26.createElement(Style2, { styles: generateStyle(id) }) : null,
    removeScrollBar ? React26.createElement(RemoveScrollBar, { gapMode: props.gapMode }) : null
  );
}
function getOutermostShadowParent(node) {
  var shadowParent = null;
  while (node !== null) {
    if (node instanceof ShadowRoot) {
      shadowParent = node.host;
      node = node.host;
    }
    node = node.parentNode;
  }
  return shadowParent;
}

// ../../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var sidecar_default = exportSidecar(effectCar, RemoveScrollSideCar);

// ../../node_modules/react-remove-scroll/dist/es2015/Combination.js
var ReactRemoveScroll = React27.forwardRef(function(props, ref) {
  return React27.createElement(RemoveScroll, __assign({}, props, { ref, sideCar: sidecar_default }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var Combination_default = ReactRemoveScroll;

// ../../node_modules/@radix-ui/react-popover/dist/index.mjs
import { jsx as jsx11 } from "react/jsx-runtime";
var POPOVER_NAME = "Popover";
var [createPopoverContext, createPopoverScope] = createContextScope(POPOVER_NAME, [
  createPopperScope
]);
var usePopperScope = createPopperScope();
var [PopoverProvider, usePopoverContext] = createPopoverContext(POPOVER_NAME);
var Popover = (props) => {
  const {
    __scopePopover,
    children,
    open: openProp,
    defaultOpen,
    onOpenChange,
    modal = false
  } = props;
  const popperScope = usePopperScope(__scopePopover);
  const triggerRef = React28.useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = React28.useState(false);
  const [open = false, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: onOpenChange
  });
  return /* @__PURE__ */ jsx11(Root2, __spreadProps(__spreadValues({}, popperScope), { children: /* @__PURE__ */ jsx11(
    PopoverProvider,
    {
      scope: __scopePopover,
      contentId: useId(),
      triggerRef,
      open,
      onOpenChange: setOpen,
      onOpenToggle: React28.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
      hasCustomAnchor,
      onCustomAnchorAdd: React28.useCallback(() => setHasCustomAnchor(true), []),
      onCustomAnchorRemove: React28.useCallback(() => setHasCustomAnchor(false), []),
      modal,
      children
    }
  ) }));
};
Popover.displayName = POPOVER_NAME;
var ANCHOR_NAME2 = "PopoverAnchor";
var PopoverAnchor = React28.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopePopover } = _a, anchorProps = __objRest(_a, ["__scopePopover"]);
    const context = usePopoverContext(ANCHOR_NAME2, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const { onCustomAnchorAdd, onCustomAnchorRemove } = context;
    React28.useEffect(() => {
      onCustomAnchorAdd();
      return () => onCustomAnchorRemove();
    }, [onCustomAnchorAdd, onCustomAnchorRemove]);
    return /* @__PURE__ */ jsx11(Anchor, __spreadProps(__spreadValues(__spreadValues({}, popperScope), anchorProps), { ref: forwardedRef }));
  }
);
PopoverAnchor.displayName = ANCHOR_NAME2;
var TRIGGER_NAME = "PopoverTrigger";
var PopoverTrigger = React28.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopePopover } = _a, triggerProps = __objRest(_a, ["__scopePopover"]);
    const context = usePopoverContext(TRIGGER_NAME, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    const composedTriggerRef = useComposedRefs(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ jsx11(
      Primitive.button,
      __spreadProps(__spreadValues({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": getState(context.open)
      }, triggerProps), {
        ref: composedTriggerRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      })
    );
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ jsx11(Anchor, __spreadProps(__spreadValues({ asChild: true }, popperScope), { children: trigger }));
  }
);
PopoverTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME2 = "PopoverPortal";
var [PortalProvider, usePortalContext] = createPopoverContext(PORTAL_NAME2, {
  forceMount: void 0
});
var PopoverPortal = (props) => {
  const { __scopePopover, forceMount, children, container } = props;
  const context = usePopoverContext(PORTAL_NAME2, __scopePopover);
  return /* @__PURE__ */ jsx11(PortalProvider, { scope: __scopePopover, forceMount, children: /* @__PURE__ */ jsx11(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx11(Portal, { asChild: true, container, children }) }) });
};
PopoverPortal.displayName = PORTAL_NAME2;
var CONTENT_NAME2 = "PopoverContent";
var PopoverContent = React28.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext(CONTENT_NAME2, props.__scopePopover);
    const _a = props, { forceMount = portalContext.forceMount } = _a, contentProps = __objRest(_a, ["forceMount"]);
    const context = usePopoverContext(CONTENT_NAME2, props.__scopePopover);
    return /* @__PURE__ */ jsx11(Presence, { present: forceMount || context.open, children: context.modal ? /* @__PURE__ */ jsx11(PopoverContentModal, __spreadProps(__spreadValues({}, contentProps), { ref: forwardedRef })) : /* @__PURE__ */ jsx11(PopoverContentNonModal, __spreadProps(__spreadValues({}, contentProps), { ref: forwardedRef })) });
  }
);
PopoverContent.displayName = CONTENT_NAME2;
var PopoverContentModal = React28.forwardRef(
  (props, forwardedRef) => {
    const context = usePopoverContext(CONTENT_NAME2, props.__scopePopover);
    const contentRef = React28.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, contentRef);
    const isRightClickOutsideRef = React28.useRef(false);
    React28.useEffect(() => {
      const content = contentRef.current;
      if (content)
        return hideOthers(content);
    }, []);
    return /* @__PURE__ */ jsx11(Combination_default, { as: Slot2, allowPinchZoom: true, children: /* @__PURE__ */ jsx11(
      PopoverContentImpl,
      __spreadProps(__spreadValues({}, props), {
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: composeEventHandlers(props.onCloseAutoFocus, (event) => {
          var _a;
          event.preventDefault();
          if (!isRightClickOutsideRef.current)
            (_a = context.triggerRef.current) == null ? void 0 : _a.focus();
        }),
        onPointerDownOutside: composeEventHandlers(
          props.onPointerDownOutside,
          (event) => {
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            isRightClickOutsideRef.current = isRightClick;
          },
          { checkForDefaultPrevented: false }
        ),
        onFocusOutside: composeEventHandlers(
          props.onFocusOutside,
          (event) => event.preventDefault(),
          { checkForDefaultPrevented: false }
        )
      })
    ) });
  }
);
var PopoverContentNonModal = React28.forwardRef(
  (props, forwardedRef) => {
    const context = usePopoverContext(CONTENT_NAME2, props.__scopePopover);
    const hasInteractedOutsideRef = React28.useRef(false);
    const hasPointerDownOutsideRef = React28.useRef(false);
    return /* @__PURE__ */ jsx11(
      PopoverContentImpl,
      __spreadProps(__spreadValues({}, props), {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event) => {
          var _a, _b;
          (_a = props.onCloseAutoFocus) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            if (!hasInteractedOutsideRef.current)
              (_b = context.triggerRef.current) == null ? void 0 : _b.focus();
            event.preventDefault();
          }
          hasInteractedOutsideRef.current = false;
          hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event) => {
          var _a, _b;
          (_a = props.onInteractOutside) == null ? void 0 : _a.call(props, event);
          if (!event.defaultPrevented) {
            hasInteractedOutsideRef.current = true;
            if (event.detail.originalEvent.type === "pointerdown") {
              hasPointerDownOutsideRef.current = true;
            }
          }
          const target = event.target;
          const targetIsTrigger = (_b = context.triggerRef.current) == null ? void 0 : _b.contains(target);
          if (targetIsTrigger)
            event.preventDefault();
          if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) {
            event.preventDefault();
          }
        }
      })
    );
  }
);
var PopoverContentImpl = React28.forwardRef(
  (props, forwardedRef) => {
    const _a = props, {
      __scopePopover,
      trapFocus,
      onOpenAutoFocus,
      onCloseAutoFocus,
      disableOutsidePointerEvents,
      onEscapeKeyDown,
      onPointerDownOutside,
      onFocusOutside,
      onInteractOutside
    } = _a, contentProps = __objRest(_a, [
      "__scopePopover",
      "trapFocus",
      "onOpenAutoFocus",
      "onCloseAutoFocus",
      "disableOutsidePointerEvents",
      "onEscapeKeyDown",
      "onPointerDownOutside",
      "onFocusOutside",
      "onInteractOutside"
    ]);
    const context = usePopoverContext(CONTENT_NAME2, __scopePopover);
    const popperScope = usePopperScope(__scopePopover);
    useFocusGuards();
    return /* @__PURE__ */ jsx11(
      FocusScope,
      {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ jsx11(
          DismissableLayer,
          {
            asChild: true,
            disableOutsidePointerEvents,
            onInteractOutside,
            onEscapeKeyDown,
            onPointerDownOutside,
            onFocusOutside,
            onDismiss: () => context.onOpenChange(false),
            children: /* @__PURE__ */ jsx11(
              Content,
              __spreadProps(__spreadValues(__spreadValues({
                "data-state": getState(context.open),
                role: "dialog",
                id: context.contentId
              }, popperScope), contentProps), {
                ref: forwardedRef,
                style: __spreadValues(__spreadValues({}, contentProps.style), {
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                })
              })
            )
          }
        )
      }
    );
  }
);
var CLOSE_NAME = "PopoverClose";
var PopoverClose = React28.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopePopover } = _a, closeProps = __objRest(_a, ["__scopePopover"]);
    const context = usePopoverContext(CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ jsx11(
      Primitive.button,
      __spreadProps(__spreadValues({
        type: "button"
      }, closeProps), {
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, () => context.onOpenChange(false))
      })
    );
  }
);
PopoverClose.displayName = CLOSE_NAME;
var ARROW_NAME2 = "PopoverArrow";
var PopoverArrow = React28.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopePopover } = _a, arrowProps = __objRest(_a, ["__scopePopover"]);
    const popperScope = usePopperScope(__scopePopover);
    return /* @__PURE__ */ jsx11(Arrow2, __spreadProps(__spreadValues(__spreadValues({}, popperScope), arrowProps), { ref: forwardedRef }));
  }
);
PopoverArrow.displayName = ARROW_NAME2;
function getState(open) {
  return open ? "open" : "closed";
}
var Root22 = Popover;
var Trigger = PopoverTrigger;
var Portal2 = PopoverPortal;
var Content2 = PopoverContent;
var Close = PopoverClose;

// ../../node_modules/clsx/dist/clsx.m.js
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; )
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m_default = clsx;

// src/components/AppSwitcher.tsx
import { useMemo as useMemo6 } from "react";

// ../../node_modules/@teamworksdev/react-icons/lib/iconBase.mjs
import React30 from "react";

// ../../node_modules/@teamworksdev/react-icons/lib/iconContext.mjs
import React29 from "react";
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React29.createContext && /* @__PURE__ */ React29.createContext(DefaultContext);

// ../../node_modules/@teamworksdev/react-icons/lib/iconBase.mjs
var _excluded = ["attr", "size", "title"];
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      if (excluded.indexOf(key) >= 0)
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(e, r2) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r2 && (o = o.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e, r3).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys(Object(t), true).forEach(function(r3) {
      _defineProperty(e, r3, t[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r3) {
      Object.defineProperty(e, r3, Object.getOwnPropertyDescriptor(t, r3));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r2) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r2 || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t);
}
function Tree2Element(tree) {
  return tree && tree.map((node, i) => /* @__PURE__ */ React30.createElement(node.tag, _objectSpread({
    key: i
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  return (props) => /* @__PURE__ */ React30.createElement(IconBase, _extends({
    attr: _objectSpread({}, data.attr)
  }, props), Tree2Element(data.child));
}
function IconBase(props) {
  var elem = (conf) => {
    var {
      attr,
      size: size4,
      title
    } = props, svgProps = _objectWithoutProperties(props, _excluded);
    var computedSize = size4 || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return /* @__PURE__ */ React30.createElement("svg", _extends({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread(_objectSpread({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /* @__PURE__ */ React30.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ React30.createElement(IconContext.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext);
}

// ../../node_modules/@teamworksdev/react-icons/md/index.mjs
function MdExpandMore(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z" }, "child": [] }] })(props);
}
function MdPeople(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" }, "child": [] }] })(props);
}
function MdPerson(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" }, "child": [] }] })(props);
}

// ../teamworks-icons/dist/index.mjs
import { jsx as jsx12, jsxs } from "react/jsx-runtime";
import { jsx as jsx22, jsxs as jsxs2 } from "react/jsx-runtime";
import { jsx as jsx32, jsxs as jsxs3 } from "react/jsx-runtime";
import { jsx as jsx42, jsxs as jsxs4 } from "react/jsx-runtime";
import { jsx as jsx52, jsxs as jsxs5 } from "react/jsx-runtime";
import { jsx as jsx62, jsxs as jsxs6 } from "react/jsx-runtime";
import { jsx as jsx72, jsxs as jsxs7 } from "react/jsx-runtime";
import { jsx as jsx82, jsxs as jsxs8 } from "react/jsx-runtime";
import { jsx as jsx92, jsxs as jsxs9 } from "react/jsx-runtime";
import { jsx as jsx102, jsxs as jsxs10 } from "react/jsx-runtime";
import { jsx as jsx112, jsxs as jsxs11 } from "react/jsx-runtime";
import { jsx as jsx122, jsxs as jsxs12 } from "react/jsx-runtime";
import { jsx as jsx13, jsxs as jsxs13 } from "react/jsx-runtime";
import { jsx as jsx14, jsxs as jsxs14 } from "react/jsx-runtime";
import { jsx as jsx15, jsxs as jsxs15 } from "react/jsx-runtime";
import { jsx as jsx16, jsxs as jsxs16 } from "react/jsx-runtime";
import { jsx as jsx17, jsxs as jsxs17 } from "react/jsx-runtime";
import { jsx as jsx18, jsxs as jsxs18 } from "react/jsx-runtime";
import { jsx as jsx19, jsxs as jsxs19 } from "react/jsx-runtime";
import { jsx as jsx20, jsxs as jsxs20 } from "react/jsx-runtime";
import { jsx as jsx21 } from "react/jsx-runtime";
import { jsx as jsx222, jsxs as jsxs21 } from "react/jsx-runtime";
import { jsx as jsx23, jsxs as jsxs22 } from "react/jsx-runtime";
import { jsx as jsx24, jsxs as jsxs23 } from "react/jsx-runtime";
var __defProp2 = Object.defineProperty;
var __defProps2 = Object.defineProperties;
var __getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp2.call(b, prop))
      __defNormalProp2(a, prop, b[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b)) {
      if (__propIsEnum2.call(b, prop))
        __defNormalProp2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps2 = (a, b) => __defProps2(a, __getOwnPropDescs2(b));
var __objRest2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var AppSwitcherIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.50771 7.30309C4.28433 7.17 4.00839 7.16929 3.78435 7.3012L2.02814 8.3353C1.80447 8.467 1.66663 8.71082 1.66663 8.97474V11.0146C1.66663 11.2781 1.80406 11.5216 2.02719 11.6535L3.7834 12.6912C4.00792 12.8239 4.2848 12.8232 4.50866 12.6893L6.24021 11.6541C6.46154 11.5217 6.59759 11.2793 6.59759 11.0171V8.97223C6.59759 8.70966 6.46112 8.46687 6.23925 8.33468L4.50771 7.30309Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.39583 2.18363C7.17245 2.05055 6.89651 2.04983 6.67247 2.18175L4.91625 3.21584C4.69259 3.34754 4.55474 3.59136 4.55474 3.85528V5.89514C4.55474 6.15865 4.69217 6.40217 4.9153 6.53401L6.67151 7.57175C6.89604 7.70442 7.17292 7.7037 7.39678 7.56986L9.12832 6.53462C9.34966 6.40229 9.4857 6.15981 9.4857 5.89764V3.85278C9.4857 3.5902 9.34924 3.34741 9.12737 3.21523L7.39583 2.18363Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.39583 12.4295C7.17245 12.2964 6.89651 12.2957 6.67247 12.4277L4.91625 13.4617C4.69259 13.5934 4.55474 13.8373 4.55474 14.1012V16.141C4.55474 16.4046 4.69217 16.6481 4.9153 16.7799L6.67151 17.8176C6.89604 17.9503 7.17292 17.9496 7.39678 17.8158L9.12832 16.7805C9.34966 16.6482 9.4857 16.4057 9.4857 16.1435V14.0987C9.4857 13.8361 9.34924 13.5933 9.12737 13.4611L7.39583 12.4295Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2637 2.18363C13.0403 2.05055 12.7644 2.04983 12.5404 2.18175L10.7842 3.21584C10.5605 3.34754 10.4226 3.59136 10.4226 3.85528V5.89514C10.4226 6.15865 10.5601 6.40217 10.7832 6.53401L12.5394 7.57175C12.7639 7.70442 13.0408 7.7037 13.2647 7.56986L14.9962 6.53462C15.2176 6.40229 15.3536 6.15981 15.3536 5.89764V3.85278C15.3536 3.5902 15.2171 3.34741 14.9953 3.21523L13.2637 2.18363Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2637 12.4295C13.0403 12.2964 12.7644 12.2957 12.5404 12.4277L10.7842 13.4617C10.5605 13.5934 10.4226 13.8373 10.4226 14.1012V16.141C10.4226 16.4046 10.5601 16.6481 10.7832 16.7799L12.5394 17.8176C12.7639 17.9503 13.0408 17.9496 13.2647 17.8158L14.9962 16.7805C15.2176 16.6482 15.3536 16.4057 15.3536 16.1435V14.0987C15.3536 13.8361 15.2171 13.5933 14.9953 13.4611L13.2637 12.4295Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.3755 7.30309C10.1521 7.17 9.8762 7.16929 9.65217 7.3012L7.89595 8.3353C7.67228 8.467 7.53444 8.71082 7.53444 8.97474V11.0146C7.53444 11.2781 7.67187 11.5216 7.895 11.6535L9.65121 12.6912C9.87573 12.8239 10.1526 12.8232 10.3765 12.6893L12.108 11.6541C12.3294 11.5217 12.4654 11.2793 12.4654 11.0171V8.97223C12.4654 8.70966 12.3289 8.46687 12.1071 8.33468L10.3755 7.30309Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx12(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M16.2434 7.30309C16.02 7.17 15.7441 7.16929 15.5201 7.3012L13.7638 8.3353C13.5402 8.467 13.4023 8.71082 13.4023 8.97474V11.0146C13.4023 11.2781 13.5398 11.5216 13.7629 11.6535L15.5191 12.6912C15.7436 12.8239 16.0205 12.8232 16.2444 12.6893L17.9759 11.6541C18.1972 11.5217 18.3333 11.2793 18.3333 11.0171V8.97223C18.3333 8.70966 18.1968 8.46687 17.975 8.33468L16.2434 7.30309Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var CloseMenuIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12("path", { fill: "none", d: "M0 0h24v24H0z" }),
      /* @__PURE__ */ jsx12("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" })
    ]
  })
);
var CheckIcon = (props) => /* @__PURE__ */ jsx12(
  "svg",
  __spreadProps2(__spreadValues2({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx12(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6805 7.8295C18.1065 8.26884 18.1065 8.98116 17.6805 9.4205L11.135 16.1705C10.709 16.6098 10.0183 16.6098 9.59225 16.1705L6.31952 12.7955C5.89349 12.3562 5.89349 11.6438 6.31952 11.2045C6.74555 10.7652 7.43627 10.7652 7.8623 11.2045L10.3636 13.784L16.1377 7.8295C16.5637 7.39017 17.2545 7.39017 17.6805 7.8295Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronRightIcon = (props) => /* @__PURE__ */ jsx12(
  "svg",
  __spreadProps2(__spreadValues2({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx12("polyline", { points: "9 18 15 12 9 6" })
  })
);
var DefaultIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 512 512",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12("path", { d: "M80 280h256v48H80zM80 184h320v48H80zM80 88h352v48H80z" }),
      /* @__PURE__ */ jsx12("g", { children: /* @__PURE__ */ jsx12("path", { d: "M80 376h288v48H80z" }) })
    ]
  })
);
var ExternalLinkIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12("path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" }),
      /* @__PURE__ */ jsx12("polyline", { points: "15 3 21 3 21 9" }),
      /* @__PURE__ */ jsx12("line", { x1: "10", y1: "14", x2: "21", y2: "3" })
    ]
  })
);
var LogoutIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12("path", { fill: "none", d: "M0 0h24v24H0z" }),
      /* @__PURE__ */ jsx12("path", { d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" })
    ]
  })
);
var OpenMenuIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12("path", { fill: "none", d: "M0 0h24v24H0z" }),
      /* @__PURE__ */ jsx12("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" })
    ]
  })
);
var SupportIcon = (props) => /* @__PURE__ */ jsx12(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx12("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z" })
  })
);
var SwitchIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps2(__spreadValues2({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx12("path", { fill: "none", d: "M0 0h24v24H0z" }),
      /* @__PURE__ */ jsx12("path", { d: "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" })
    ]
  })
);
var AMSLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs2(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21943L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21943C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#009657"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M13.6727 7.74915V12.8189C13.6727 13.0601 13.4769 13.2544 13.2372 13.2544H12.0308C11.7896 13.2544 11.5969 13.0586 11.5969 12.8189V11.4496C11.9823 11.3008 12.2564 10.9263 12.2564 10.4892C12.2564 10.2339 12.164 10.002 12.0105 9.82341L13.6743 7.74915H13.6727Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M13.6727 5.31457V5.7783C13.2858 5.92714 13.0116 6.30156 13.0116 6.73866C13.0116 6.93449 13.0664 7.11466 13.162 7.27133L11.5953 9.22497V5.31457C11.5953 5.0733 11.7896 4.87903 12.0293 4.87903H13.2356C13.4769 4.87903 13.6712 5.07487 13.6712 5.31457H13.6727Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M8.0312 6.67125V8.30841C7.6505 8.45881 7.38103 8.83168 7.38103 9.26565C7.38103 9.34555 7.39044 9.42389 7.40924 9.49909L6.15903 10.4172C6.0948 10.3749 6.02586 10.3388 5.9538 10.3122V6.67125C5.9538 6.42998 6.14963 6.23572 6.38933 6.23572H7.59566C7.83693 6.23572 8.0312 6.43155 8.0312 6.67125Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M8.0312 10.2213V12.8189C8.0312 13.0601 7.83536 13.2544 7.59566 13.2544H6.38933C6.14807 13.2544 5.9538 13.0586 5.9538 12.8189V12.2314C6.3392 12.0841 6.61493 11.7097 6.61493 11.2726C6.61493 11.1707 6.60083 11.0736 6.57106 10.9812L7.78993 10.0866C7.86357 10.143 7.94503 10.19 8.03277 10.2229L8.0312 10.2213Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M10.8575 7.70525V9.52884C10.6945 9.58994 10.5536 9.69335 10.4439 9.82182L9.43651 9.37062C9.43965 9.33615 9.44122 9.30011 9.44122 9.26565C9.44122 8.82855 9.16706 8.45255 8.78009 8.30528V7.70525C8.78009 7.46399 8.97592 7.26971 9.21562 7.26971H10.422C10.6617 7.26971 10.8559 7.46555 10.8559 7.70525H10.8575Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M10.8575 11.4496V12.8189C10.8575 13.0601 10.6616 13.2544 10.4235 13.2544H9.21715C8.97589 13.2544 8.78162 13.0586 8.78162 12.8189V10.226C8.91478 10.1775 9.03385 10.0991 9.13412 10.0004L10.1995 10.4783V10.4892C10.1995 10.9263 10.4736 11.3023 10.859 11.4496H10.8575Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx22(
          "path",
          {
            d: "M13.2842 14.8712H6.34075C6.09948 14.8712 5.90521 14.6754 5.90521 14.4357C5.90521 14.196 6.10105 14.0001 6.34075 14.0001H13.2842C13.5255 14.0001 13.7197 14.196 13.7197 14.4357C13.7197 14.6754 13.5239 14.8712 13.2842 14.8712Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var AcademicsLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs4(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21943L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21943C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#7B62D5"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M10.6993 8.67505V9.98008C10.4 9.92838 10.093 9.90175 9.77962 9.90175C9.46629 9.90175 9.15922 9.92838 8.85999 9.98008V8.67505H10.6993Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M8.11893 8.67505V10.1618C7.68027 10.3028 7.2651 10.4971 6.8844 10.7399V8.67505H8.11893Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M12.6764 8.67505V10.7399C12.2941 10.4986 11.8805 10.3028 11.4418 10.1618V8.67505H12.6764Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M13.0085 7.81805H6.58363C6.44346 7.81805 6.32983 7.93168 6.32983 8.07185V8.42122C6.32983 8.56139 6.44346 8.67502 6.58363 8.67502H13.0085C13.1487 8.67502 13.2623 8.56139 13.2623 8.42122V8.07185C13.2623 7.93168 13.1487 7.81805 13.0085 7.81805Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M13.5709 6.3219H6.02272C5.8566 6.3219 5.72192 6.45657 5.72192 6.6227V7.03473C5.72192 7.20086 5.8566 7.33553 6.02272 7.33553H13.5709C13.7371 7.33553 13.8717 7.20086 13.8717 7.03473V6.6227C13.8717 6.45657 13.7371 6.3219 13.5709 6.3219Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M10.7008 13.6664C10.7024 13.8325 10.5661 13.9672 10.4 13.9672H9.16235C8.99629 13.9672 8.86155 13.8325 8.86155 13.6664V10.4109L8.85999 9.98007C9.15922 9.92837 9.46629 9.90173 9.77962 9.90173C10.093 9.90173 10.4 9.92837 10.6993 9.98007V13.6664H10.7008Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M8.12052 13.3124C8.12052 13.4784 7.98579 13.6132 7.81972 13.6132H7.18679C7.02072 13.6132 6.88599 13.4784 6.88599 13.3124V10.7399C7.26512 10.4971 7.68029 10.3028 8.11895 10.1618V13.3124H8.12052Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx42(
          "path",
          {
            d: "M12.6764 10.7399V13.3124C12.6764 13.4784 12.5432 13.6132 12.3771 13.6132H11.7426C11.5766 13.6132 11.4434 13.4784 11.4434 13.3124V10.6537L11.4418 10.1618C11.8805 10.3028 12.2941 10.4986 12.6764 10.7399Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var CampsLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs5(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57035 17.6458 4.21942L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21942C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#1A6AFF"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M14.0644 5.48215C13.82 5.39128 13.5506 5.51662 13.4597 5.75945L13.3688 6.00698C13.2623 5.99445 13.1464 5.98035 13.0226 5.96625C11.799 5.82525 10.1227 5.62942 9.22812 5.98505C9.07459 6.04772 8.97119 6.19341 8.96336 6.35948C8.95082 6.63835 8.93672 6.91252 8.92732 7.18825C7.68339 7.63005 6.42536 7.94181 5.16889 8.11728C5.01692 8.13921 4.88689 8.24105 4.82892 8.38362C4.77096 8.52618 4.79289 8.69225 4.88689 8.81758C6.38306 10.8527 9.59002 11.4997 10.2653 11.4997C10.2731 11.4997 10.2809 11.4997 10.2888 11.4981H10.2919C10.4141 11.4981 10.53 11.4511 10.6178 11.365C10.7165 11.2678 10.7666 11.1347 10.7572 10.9984C10.74 10.7336 10.7306 10.4751 10.729 10.2276C11.0564 10.3999 11.3698 10.5863 11.6189 10.7399L10.0647 14.9432C9.97542 15.1876 10.0992 15.4571 10.342 15.548C10.3969 15.5683 10.4517 15.5777 10.505 15.5777C10.6961 15.5777 10.8763 15.4602 10.9468 15.2691L14.3417 6.08531C14.4326 5.84248 14.3073 5.57145 14.0644 5.48215ZM12.4555 8.47448L11.8946 9.99101C11.5562 9.78421 11.1567 9.55548 10.7541 9.36435C10.6272 9.30325 10.5003 9.24685 10.3734 9.19515C10.3499 9.18575 10.3264 9.17478 10.3029 9.16695C10.2606 9.14972 10.2183 9.13248 10.1775 9.11838C10.1149 9.09488 10.0522 9.07295 9.99109 9.05258C9.90336 9.02438 9.81719 8.99931 9.73259 8.97895C9.70282 8.58885 9.69342 8.22225 9.69499 7.85878C9.69499 7.81805 9.69499 7.77731 9.69499 7.73815C9.69656 7.59871 9.69969 7.46085 9.70439 7.32142V7.31515C9.70909 7.17415 9.71535 7.03158 9.72162 6.88745C9.72476 6.80911 9.72789 6.73078 9.73259 6.64931C9.90492 6.60858 10.107 6.58508 10.3311 6.57568C10.3765 6.57411 10.4219 6.57255 10.4674 6.57098C10.5003 6.56941 10.5332 6.56941 10.5676 6.56941C10.6005 6.56785 10.635 6.56785 10.6679 6.56785C10.8152 6.56785 10.9671 6.57255 11.1222 6.57881H11.1238C11.7583 6.60858 12.4273 6.68691 12.9302 6.74488C12.9834 6.75115 13.0367 6.75742 13.0868 6.76368L12.4539 8.47448H12.4555ZM5.90992 8.80818C5.90992 8.80818 5.90209 8.80035 5.89739 8.79565C5.98982 8.77998 6.08382 8.76275 6.17626 8.74395C6.25459 8.72985 6.33292 8.71418 6.41126 8.69851C6.61179 8.65778 6.81389 8.61392 7.01442 8.56535C7.14289 8.53558 7.27292 8.50425 7.40139 8.47135C7.52986 8.43845 7.65989 8.40398 7.78836 8.36952C8.16436 8.26455 8.53879 8.14862 8.91322 8.02172V8.02485L9.04796 9.43642C9.06832 9.46932 9.09026 9.50065 9.11532 9.52885C9.20149 9.62598 9.32056 9.69492 9.45372 9.71998C9.60569 9.74818 9.77332 9.80145 9.94879 9.86881C9.94252 10.1304 9.94565 10.4046 9.95662 10.6882C9.14665 10.5675 7.13819 10.0317 5.90992 8.80818Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M13.0884 6.7637L12.4555 8.4745C12.1891 8.39303 11.5468 8.18154 10.906 8.02957C10.776 7.9998 10.6475 7.97004 10.5206 7.94654C10.3875 7.9199 10.2574 7.89797 10.1352 7.8823C9.97231 7.8635 9.82191 7.8541 9.69501 7.8588C9.69501 7.81807 9.69501 7.77733 9.69501 7.73817C9.69657 7.59873 9.69971 7.46087 9.70441 7.32144V7.31517C9.70911 7.17417 9.71537 7.0316 9.72164 6.88747C9.72477 6.80913 9.72791 6.7308 9.73261 6.64934C9.90494 6.6086 10.107 6.5851 10.3311 6.5757C10.3765 6.57414 10.4219 6.57257 10.4674 6.571C10.5003 6.56944 10.5332 6.56943 10.5676 6.56943C10.6005 6.56787 10.635 6.56787 10.6679 6.56787C10.8152 6.56787 10.9671 6.57257 11.1222 6.57883H11.1238C11.7583 6.6086 12.4273 6.68693 12.9302 6.7449C12.9834 6.75117 13.0367 6.75744 13.0868 6.7637H13.0884Z",
            fill: "#34AFFF"
          }
        ),
        /* @__PURE__ */ jsx52(
          "path",
          {
            d: "M9.0479 9.43643C7.97317 9.15913 6.96267 8.98053 5.90987 8.80819C5.90517 8.80349 5.90204 8.80036 5.89734 8.79566C5.98977 8.77999 6.08377 8.76276 6.17621 8.74396C6.25454 8.72986 6.33287 8.71419 6.41121 8.69852C6.61174 8.65779 6.81384 8.61393 7.01437 8.56536C7.14284 8.5356 7.27287 8.50426 7.40134 8.47136C7.52981 8.43846 7.65984 8.404 7.78831 8.36953C8.16431 8.26456 8.53874 8.14863 8.91317 8.02173V8.02486L9.0479 9.43643Z",
            fill: "#34AFFF"
          }
        )
      ]
    })
  );
};
var CollectivesLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs6(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M18.6234 6.13205V13.2096C18.6234 14.1165 18.1393 14.9547 17.3544 15.4113L11.1348 19.0111C10.3467 19.4677 9.37697 19.4692 8.58893 19.0189L2.27997 15.4082C1.4888 14.9563 1 14.1134 1 13.2017V6.14143C1 5.22976 1.4888 4.3869 2.28467 3.93342L8.5905 0.335235C9.37853 -0.113561 10.3467 -0.111997 11.1301 0.34149L17.3497 3.93029C18.1378 4.38534 18.6219 5.22507 18.6219 6.13361L18.6234 6.13205Z",
            fill: "#2CC3F2"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M15.2739 12.6951L14.7491 13.2174C14.688 13.2784 14.5893 13.2784 14.5266 13.2174L11.7959 10.4933C11.7348 10.4324 11.6361 10.4324 11.5734 10.4933L11.5155 10.5496C11.4528 10.6106 11.4528 10.7107 11.5155 10.7733L13.8044 13.0579C13.867 13.1189 13.867 13.2174 13.8044 13.2799L13.2811 13.8022C13.22 13.8632 13.1197 13.8632 13.0586 13.8022L10.7682 11.516C10.7071 11.4551 10.6099 11.4551 10.5488 11.516L10.4893 11.5755C10.4282 11.6364 10.4266 11.7365 10.4893 11.7975L12.3348 13.6396C12.3959 13.7006 12.3959 13.8007 12.3348 13.8617L11.8116 14.384C11.7505 14.4465 11.6502 14.4465 11.5891 14.384L9.74199 12.5434C9.68089 12.4824 9.58219 12.4824 9.52109 12.5434L9.46313 12.5997C9.40046 12.6607 9.40046 12.7608 9.46313 12.8233L10.8669 14.2229C10.928 14.2839 10.928 14.384 10.8669 14.4449L10.342 14.9672C10.2809 15.0282 10.1822 15.0282 10.1196 14.9672L8.80356 13.6521L8.91323 13.5427C9.04796 13.4082 9.12159 13.2205 9.11219 13.0282C9.10436 12.8515 9.03073 12.6842 8.90383 12.5575L8.37899 12.0336V12.0133C8.46359 11.8929 8.51059 11.7428 8.50746 11.5911C8.50119 11.4113 8.42756 11.2408 8.29909 11.1126L7.77426 10.5872C7.63953 10.4543 7.46093 10.3792 7.27293 10.3792C7.13193 10.3792 6.99876 10.4214 6.88439 10.498L6.34703 9.96168C6.21543 9.83032 6.03839 9.75682 5.85039 9.75682C5.71879 9.75682 5.59189 9.79279 5.48223 9.86003C5.47753 9.85378 5.47126 9.84752 5.46499 9.84127L4.94016 9.31585C4.84616 9.22359 4.73023 9.15947 4.60333 9.13133L4.32446 8.49019C4.25866 8.3432 4.29156 8.17118 4.40593 8.05703L7.08649 5.3799C7.17736 5.28763 7.30739 5.24541 7.43586 5.26731L8.18316 5.40022L6.98309 6.61369C6.71206 6.8936 6.71206 7.3252 6.97526 7.59885L7.60506 8.25094C7.73353 8.38073 7.89646 8.45579 8.07193 8.46673C8.08603 8.46673 8.10013 8.46673 8.11423 8.46673C8.25836 8.46673 8.51686 8.34007 8.51686 8.34007L9.79056 7.74115C9.92999 7.67548 10.0961 7.69737 10.2136 7.79901L13.0054 10.2056L15.277 12.4731C15.3381 12.534 15.3381 12.6341 15.277 12.6951H15.2739Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M6.47546 11.097L6.35796 11.2142L5.5903 11.9789C5.55896 12.0118 5.51666 12.0274 5.47436 12.0274C5.44146 12.0274 5.40856 12.018 5.38036 11.9961C5.37566 11.993 5.3694 11.9883 5.3647 11.9836L4.83986 11.4598C4.83986 11.4598 4.8289 11.4488 4.82576 11.4426C4.78033 11.3816 4.78816 11.2909 4.84456 11.2346L5.72973 10.3511C5.76106 10.3198 5.80336 10.3026 5.84566 10.3026C5.88483 10.3026 5.924 10.3182 5.95376 10.3479L6.48016 10.8718C6.48016 10.8718 6.48016 10.8718 6.4833 10.8749C6.54126 10.9359 6.53656 11.0344 6.47546 11.097Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M7.91206 11.7115L6.60703 13.0141C6.57883 13.0422 6.54279 13.0563 6.50519 13.0563C6.47073 13.0563 6.43626 13.0454 6.40806 13.0219C6.40179 13.0172 6.39709 13.0125 6.39239 13.0078L5.86756 12.484C5.86756 12.484 5.85659 12.4715 5.85346 12.4652C5.80646 12.4042 5.80959 12.3214 5.86129 12.2697L6.63836 11.4941L7.06606 11.0672L7.16633 10.9671C7.19453 10.939 7.23056 10.9249 7.26816 10.9249C7.30889 10.9249 7.34963 10.9421 7.38096 10.9734L7.90579 11.4973C7.96689 11.5582 7.97003 11.6536 7.91206 11.7115Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M5.07174 10.4464L4.55944 10.9578C4.52967 10.9891 4.48894 11.0031 4.44978 11.0031C4.41688 11.0031 4.38398 10.9937 4.35734 10.9734C4.35108 10.9703 4.34481 10.964 4.33854 10.9578L3.81371 10.4339C3.75261 10.3729 3.75261 10.2744 3.81371 10.2134L4.32601 9.70209C4.35577 9.67081 4.39651 9.65674 4.43724 9.65674C4.47798 9.65674 4.51714 9.67081 4.54691 9.70209L5.07174 10.2259C5.07174 10.2259 5.07487 10.2291 5.07487 10.2306C5.13284 10.2916 5.13127 10.387 5.07174 10.4464Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M8.52002 13.1549L8.41193 13.2643L7.63173 14.0431C7.60509 14.0697 7.57063 14.0822 7.53459 14.0822C7.49386 14.0822 7.45156 14.065 7.41866 14.0337L6.89383 13.5098C6.89383 13.5098 6.88443 13.5005 6.88129 13.4942C6.83273 13.4348 6.83429 13.3488 6.88443 13.2972L7.66463 12.5184L7.77429 12.4105C7.80093 12.3839 7.83539 12.3714 7.87143 12.3714C7.91059 12.3714 7.95133 12.3855 7.98266 12.4168C7.98266 12.4168 7.9837 12.4178 7.98579 12.4199L8.51063 12.9438C8.57173 13.0047 8.57642 13.0986 8.52002 13.1549Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M14.9183 10.5809L14.7491 10.7795C14.7178 10.8155 14.6723 10.8343 14.6285 10.8343H14.6191C14.5815 10.8343 14.5407 10.8139 14.511 10.7827L10.5348 7.35492L10.2998 7.15164C10.1823 7.05156 10.0162 7.0281 9.87675 7.09378L8.32262 7.82561C8.17065 7.89755 7.99049 7.86314 7.87455 7.74273L7.36852 7.21888C7.30899 7.15789 7.31055 7.05938 7.37009 6.99683L8.83492 5.51596L9.31902 5.02651L9.38169 4.96239C9.53209 4.81071 9.73419 4.73096 9.94099 4.73096C9.95665 4.73096 9.97232 4.73096 9.98799 4.73096C10.0601 4.73565 10.1353 4.74816 10.2058 4.77474L13.3438 5.89595C13.5772 5.97883 13.7558 6.16804 13.8295 6.40417L14.9935 10.2119C15.0342 10.3386 15.0045 10.4777 14.9183 10.5794V10.5809Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx62(
          "path",
          {
            d: "M13.1276 10.3307L8.51373 8.34009L9.78743 7.74117C9.92687 7.67549 10.0929 7.69895 10.2104 7.79903L12.927 10.14L13.0022 10.2056L13.1276 10.3307Z",
            fill: "#74DFFF"
          }
        )
      ]
    })
  );
};
var CommunitiesLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs7(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M18.8508 14.0081V5.99191C18.8508 5.28264 18.4731 4.6289 17.8591 4.27347L10.9171 0.265381C10.303 -0.0884605 9.54774 -0.0884605 8.93367 0.265381L1.99171 4.27347C1.37764 4.62732 1 5.28264 1 5.99191V14.0081C1 14.7174 1.37764 15.3711 1.99171 15.7265L8.93367 19.7346C9.54774 20.0885 10.303 20.0885 10.9171 19.7346L17.8591 15.7265C18.4731 15.3727 18.8508 14.7174 18.8508 14.0081Z",
            fill: "#7B62D5"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M9.92534 4.40039C6.89785 4.40039 4.43524 6.863 4.43524 9.89049C4.43524 10.6966 4.60978 11.4614 4.92237 12.1516L5.30001 10.7045C5.25241 10.4411 5.22861 10.1682 5.22861 9.89049C5.22861 7.30094 7.33579 5.19376 9.92534 5.19376C12.5149 5.19376 14.6221 7.30094 14.6221 9.89049C14.6221 10.1666 14.5983 10.4363 14.5507 10.6997L14.9299 12.15C15.2409 11.4598 15.4154 10.695 15.4154 9.89049C15.4154 6.863 12.9528 4.40039 9.92534 4.40039Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M14.4682 12.8974L14.1937 11.8469L13.8335 10.4633C13.8161 10.3951 13.7844 10.3411 13.7447 10.3078C13.4432 10.5442 13.064 10.6839 12.6514 10.6839C12.4515 10.6839 12.2611 10.6505 12.0818 10.5902L12.7625 13.1068C12.7815 13.1766 12.7942 13.248 12.7974 13.321H14.2842C14.4111 13.321 14.5016 13.1401 14.4793 12.9545C14.4762 12.9354 14.473 12.9164 14.4682 12.8974Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M11.7707 9.63504C11.8834 9.7715 12.0278 9.88099 12.1928 9.95239C12.3324 10.0159 12.4879 10.0492 12.6514 10.0492C12.8148 10.0492 12.9703 10.0143 13.1115 9.95239C13.2766 9.88099 13.4209 9.7715 13.5336 9.63504C13.6986 9.43511 13.7986 9.17965 13.7986 8.90197C13.7986 8.26886 13.2861 7.75476 12.6514 7.75476C12.3689 7.75476 12.1103 7.85631 11.9104 8.02768C11.9453 8.17683 11.9643 8.33233 11.9643 8.49259C11.9643 8.86706 11.8628 9.21773 11.6866 9.51921C11.712 9.56047 11.739 9.59855 11.7707 9.63504Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M7.05499 13.321C7.05816 13.2496 7.07086 13.1782 7.0899 13.1068L7.76902 10.5902C7.58972 10.6505 7.39931 10.6839 7.19938 10.6839C6.78842 10.6839 6.40919 10.5442 6.10771 10.3094C6.06804 10.3411 6.03631 10.3951 6.01885 10.4633L5.65708 11.8485L5.38416 12.8974C5.3794 12.9164 5.37623 12.9354 5.37305 12.9561C5.35084 13.1417 5.44128 13.321 5.56822 13.321H7.05499Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M7.19939 7.75476C6.56629 7.75476 6.05219 8.26886 6.05219 8.90197C6.05219 9.17965 6.15215 9.43511 6.31717 9.63504C6.43141 9.7715 6.57581 9.88099 6.74083 9.95239C6.88046 10.0159 7.03596 10.0492 7.19939 10.0492C7.36283 10.0492 7.51833 10.0159 7.65796 9.95239C7.82298 9.88099 7.96737 9.7715 8.08162 9.63504C8.11177 9.59855 8.14033 9.56047 8.16413 9.51921C7.988 9.21773 7.88645 8.86706 7.88645 8.49259C7.88645 8.33233 7.90549 8.17683 7.9404 8.02768C7.74047 7.85631 7.48183 7.75476 7.19939 7.75476Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M8.42119 10.6141L7.7024 13.2735C7.69764 13.2893 7.69447 13.3052 7.69288 13.3211C7.67225 13.4369 7.69288 13.5527 7.73889 13.6384C7.78174 13.7209 7.84997 13.7749 7.92772 13.7749H11.9231C12.0009 13.7749 12.0691 13.7209 12.1119 13.6384C12.1595 13.5527 12.1786 13.4369 12.158 13.3211C12.1564 13.3052 12.1532 13.2893 12.1484 13.2735L11.4312 10.6141L11.3725 10.3951C11.3487 10.3047 11.3011 10.2333 11.2424 10.1968C11.2123 10.1777 11.1805 10.1666 11.1472 10.1666H11.0869C11.0139 10.219 10.9362 10.265 10.8552 10.3063C10.576 10.4507 10.2602 10.5316 9.92541 10.5316C9.59061 10.5316 9.27644 10.4507 8.99717 10.3063C8.91625 10.265 8.8385 10.219 8.76392 10.1666H8.70522C8.67189 10.1666 8.64016 10.1761 8.61001 10.1968C8.5513 10.2317 8.5037 10.3031 8.4799 10.3951L8.42119 10.6141Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M12.2737 13.9557H12.2642L12.2515 13.9684L12.2499 13.97C12.188 14.0065 12.1246 14.0398 12.0611 14.0716C11.7898 14.2112 11.5042 14.3255 11.2043 14.4096C10.7981 14.5254 10.3681 14.5873 9.92536 14.5873C9.48267 14.5873 9.05425 14.5254 8.64804 14.4096C8.34656 14.3255 8.05936 14.2112 7.78645 14.07C7.72456 14.0398 7.66268 14.0065 7.60238 13.97L7.5881 13.9557H6.23621C7.21205 14.8396 8.50682 15.3806 9.92536 15.3806C11.3439 15.3806 12.6387 14.8396 13.6145 13.9557H12.2737Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx72(
          "path",
          {
            d: "M8.89559 9.44462C8.92256 9.47635 8.95271 9.50492 8.98286 9.53189C9.14629 9.68104 9.34463 9.79053 9.5636 9.84924C9.67943 9.88097 9.80003 9.89684 9.92538 9.89684C10.0507 9.89684 10.1713 9.88097 10.2872 9.84924C10.5061 9.79053 10.7045 9.68104 10.8679 9.53189C10.898 9.50492 10.9282 9.47635 10.9568 9.44462C11.0551 9.33831 11.1376 9.21613 11.1995 9.08126V9.07808C11.2836 8.89878 11.3296 8.70361 11.3296 8.49258C11.3296 8.42911 11.3249 8.36564 11.3169 8.30376C11.2979 8.1546 11.2535 8.01338 11.1916 7.88327C10.9647 7.4136 10.4823 7.08832 9.92538 7.08832C9.36843 7.08832 8.88765 7.4136 8.65916 7.88327C8.59728 8.0118 8.55444 8.15302 8.53381 8.30058C8.52588 8.36405 8.52112 8.42752 8.52112 8.49258C8.52112 8.70361 8.56872 8.90513 8.65123 9.08443C8.7147 9.21772 8.79562 9.33831 8.89559 9.44462Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var ComplianceLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs8(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx82(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21943L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21943C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#FC542D"
          }
        ),
        /* @__PURE__ */ jsx82(
          "path",
          {
            d: "M14.2054 6.09784L10.5582 4.84607V4.85547C10.5676 4.88054 10.5755 4.9009 10.5833 4.92284L10.5896 4.93537L10.5927 4.94634C10.6037 4.9761 10.6146 5.00744 10.6287 5.04034C10.6663 5.12964 10.6992 5.2017 10.729 5.26594L10.7462 5.30197L10.7494 5.30824C10.7776 5.36777 10.8089 5.42574 10.8402 5.48214C10.8496 5.49937 10.8606 5.51817 10.87 5.5354C10.8841 5.56204 10.8982 5.5871 10.9139 5.61217L10.917 5.61687V5.62C10.9671 5.70147 11.0141 5.7751 11.0643 5.84717L13.9516 6.83887V9.91424C13.9375 10.4939 13.8169 11.2083 13.4926 11.9384C13.4174 12.1076 13.3312 12.2783 13.231 12.4491C13.1808 12.5353 13.1276 12.623 13.068 12.7107C13.0508 12.7374 13.032 12.7656 13.0148 12.7922C12.9819 12.8392 12.949 12.8878 12.9129 12.9348C12.5792 13.3938 12.1359 13.8466 11.5468 14.2429C11.5076 14.2696 11.4685 14.2946 11.4277 14.3213C11.4262 14.3213 11.4262 14.3213 11.4246 14.3213C10.9687 14.6205 10.4345 14.89 9.8125 15.114C9.19053 14.89 8.6563 14.6205 8.20197 14.3213C8.191 14.3134 8.18003 14.3072 8.16907 14.3009C7.53457 13.8889 7.063 13.4157 6.71364 12.9332H6.71207C6.65723 12.858 6.60554 12.7828 6.55697 12.7092C6.499 12.6214 6.44417 12.5337 6.39403 12.4475C6.29533 12.2768 6.2076 12.106 6.13397 11.9368C5.80967 11.2067 5.6906 10.4923 5.67493 9.91267V6.8373L8.54663 5.85187C8.5482 5.80644 8.5529 5.7657 8.55603 5.7328V5.7234C8.5623 5.67014 8.56857 5.61687 8.5764 5.56517V5.5448L8.58267 5.52444L8.5858 5.51347C8.59363 5.46334 8.60617 5.3944 8.62653 5.3192C8.63437 5.27534 8.64533 5.2393 8.6516 5.21424L8.6563 5.2017V5.19544L8.65943 5.19074C8.68293 5.11084 8.71113 5.0325 8.74247 4.95574L5.41957 6.09627C5.1031 6.20437 4.8916 6.50204 4.8916 6.8373V9.93304C4.9057 10.4579 4.99343 11.166 5.2864 11.9368C5.34907 12.1044 5.4227 12.2752 5.5073 12.4475C5.58563 12.6089 5.67337 12.7703 5.77207 12.9332C5.79713 12.9755 5.82377 13.0178 5.8504 13.0601C6.65567 14.3181 7.8996 15.2566 9.54774 15.8519C9.6339 15.8832 9.7232 15.8973 9.8125 15.8973C9.9018 15.8973 9.99267 15.8832 10.0788 15.8519C11.727 15.2566 12.9709 14.3181 13.7762 13.0601C13.8028 13.0178 13.8294 12.9755 13.8545 12.9332C13.9532 12.7703 14.0409 12.6089 14.1193 12.4475C14.2039 12.2752 14.2775 12.1044 14.3402 11.9368C14.6316 11.166 14.7209 10.4579 14.735 9.93304V6.8373C14.735 6.50204 14.5219 6.20437 14.2054 6.09627V6.09784Z",
            fill: "#FFA149"
          }
        ),
        /* @__PURE__ */ jsx82(
          "path",
          {
            d: "M9.8125 14.4137C10.8449 14.0409 11.5844 13.5145 12.1092 12.9348H7.51733C8.0406 13.5145 8.78007 14.0409 9.8125 14.4137Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx82(
          "path",
          {
            d: "M8.62808 11.9384H6.83112C6.91728 12.1092 7.01755 12.2799 7.13348 12.4491H12.493C12.6074 12.2799 12.7092 12.1092 12.7954 11.9384H8.62808Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx82(
          "path",
          {
            d: "M9.17488 11.4292C9.27358 11.4449 9.37385 11.4543 9.47412 11.4543C9.67935 11.4543 9.88615 11.4183 10.082 11.3321C10.2543 11.2585 10.4157 11.1707 10.5363 11.0203C10.5426 11.0125 10.5489 11.0031 10.5551 10.9953C10.7071 10.7932 10.7337 10.5707 10.6946 10.3451C10.6836 10.2793 10.6664 10.2135 10.646 10.1477C10.5363 9.79991 10.2998 9.52731 10.071 9.25158C10.0225 9.19205 9.97232 9.13408 9.92532 9.07298C9.48822 8.53561 9.09968 7.96065 8.80358 7.33085C8.71898 7.15851 8.65005 6.98304 8.58425 6.80288C8.57485 6.78408 8.55762 6.77155 8.54038 6.77155C8.52785 6.77155 8.51688 6.77625 8.50748 6.78721C8.47615 6.81698 8.44168 6.85771 8.41975 6.88435C8.40565 6.90001 8.39468 6.91411 8.38372 6.92978C8.15342 7.21335 8.01555 7.53608 7.99518 7.90895C7.97168 8.28025 8.06412 8.62491 8.22862 8.94921C8.35708 9.20615 8.51688 9.45211 8.68608 9.68868C8.74875 9.77641 8.80672 9.86571 8.83492 9.97695C8.87565 10.1508 8.83805 10.2276 8.69078 10.2276C8.66885 10.2276 8.64378 10.226 8.61245 10.2198C8.58895 10.2198 8.57172 10.2041 8.54978 10.1963C8.36648 10.1305 8.24585 9.98635 8.12522 9.84065C7.95288 9.63071 7.81815 9.39258 7.67558 9.15601C7.66462 9.14191 7.64895 9.13565 7.63642 9.13565C7.61292 9.13565 7.58942 9.15131 7.58942 9.17951C7.55965 9.69181 7.63798 10.179 7.91842 10.6193C8.21452 11.0767 8.64378 11.3509 9.17488 11.4292Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx82(
          "path",
          {
            d: "M9.20463 6.31093C9.22657 6.44096 9.26103 6.56943 9.3049 6.69476C9.32057 6.74019 9.3378 6.78563 9.3566 6.83106C9.49917 7.18513 9.70127 7.50786 9.91903 7.81963C9.9723 7.89639 10.0303 7.9716 10.0867 8.0468C10.1916 8.18936 10.3013 8.32566 10.4125 8.46196C10.53 8.60923 10.6491 8.75493 10.7666 8.90376C10.812 8.9633 10.8575 9.02126 10.9029 9.08236C11.1269 9.38316 11.2852 9.70433 11.3275 10.0882C11.3306 10.1383 11.3337 10.1853 11.3337 10.2323C11.3337 10.2715 11.3322 10.3122 11.3275 10.3498C11.3118 10.5174 11.2585 10.6741 11.1677 10.8245C11.1551 10.8433 11.1708 10.8621 11.188 10.8621C11.1943 10.8621 11.1974 10.8605 11.2037 10.859C11.2444 10.8276 11.282 10.7947 11.3196 10.7618C11.3431 10.7383 11.3682 10.7164 11.3917 10.6929C11.7771 10.342 12.0716 9.94246 12.1954 9.438C12.2126 9.3675 12.2283 9.29543 12.2377 9.21866C12.2502 9.11839 12.2549 9.0197 12.2502 8.92256C12.2455 8.71106 12.2032 8.51053 12.1296 8.31V8.30686C11.9996 7.96376 11.7896 7.67393 11.5421 7.4123C11.445 7.31046 11.3478 7.20706 11.2538 7.10053C11.0533 6.87649 10.8637 6.64619 10.6883 6.40336C10.6475 6.34853 10.6084 6.29213 10.5692 6.23416C10.5034 6.1386 10.4423 6.04303 10.3828 5.94433C10.3514 5.89419 10.3232 5.84093 10.2935 5.78923C10.2527 5.7156 10.2136 5.64039 10.176 5.56363C10.1728 5.55579 10.1681 5.54796 10.165 5.53856C10.1243 5.45396 10.0867 5.36779 10.0506 5.28163C10.0334 5.24089 10.0177 5.1986 10.0036 5.15943C9.9864 5.11713 9.9723 5.0764 9.95977 5.0341C9.94567 4.9918 9.93313 4.94949 9.92373 4.90719C9.90807 4.84923 9.8971 4.79126 9.88927 4.73329C9.88457 4.70196 9.87987 4.67063 9.87673 4.63773C9.8736 4.6111 9.87203 4.58446 9.87047 4.55783C9.8689 4.52649 9.8689 4.49203 9.8689 4.45756C9.8689 4.44033 9.85637 4.4325 9.84383 4.4325C9.836 4.4325 9.82973 4.43563 9.82503 4.44033C9.78273 4.49046 9.742 4.53903 9.70283 4.58916C9.6856 4.60953 9.66993 4.63146 9.65427 4.65183C9.48193 4.87273 9.33937 5.10303 9.25947 5.37093C9.25163 5.39913 9.24223 5.42889 9.23753 5.45866C9.22187 5.51506 9.2109 5.57146 9.2015 5.62786C9.19993 5.63569 9.19837 5.64353 9.1968 5.65136C9.19053 5.69679 9.18427 5.7438 9.17957 5.78923C9.17487 5.8425 9.17017 5.89733 9.17017 5.95059C9.17017 6.04616 9.178 6.14016 9.19053 6.23416C9.19367 6.25923 9.19837 6.28586 9.20463 6.31093Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var DigitalDisplaysLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs9(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx92(
          "path",
          {
            d: "M18.6228 13.8241V5.91342C18.6228 5.20851 18.2468 4.56626 17.6359 4.22163L10.7904 0.258467C10.1795 -0.0861558 9.44327 -0.0861558 8.83235 0.258467L1.98688 4.20597C1.37595 4.56626 1 5.20851 1 5.91342V13.8241C1 14.5133 1.37595 15.1713 1.98688 15.5159L8.83235 19.479C9.44327 19.8237 10.1795 19.8237 10.7904 19.479L17.6359 15.5159C18.2468 15.1713 18.6228 14.5133 18.6228 13.8241Z",
            fill: "#1A6AFF"
          }
        ),
        /* @__PURE__ */ jsx92(
          "path",
          {
            d: "M11.7616 9.97056L6.07534 9.51629C5.90303 9.51629 5.77771 9.32831 5.77771 9.14034V6.25803C5.77771 6.05439 5.91869 5.91341 6.07534 5.92907L11.7616 6.38335C11.9339 6.38335 12.0593 6.57133 12.0593 6.7593V9.64161C12.0593 9.84525 11.9183 9.98623 11.7616 9.97056Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx92(
          "path",
          {
            d: "M15.1295 12.7902L12.9052 12.6179C12.7798 12.6179 12.6859 12.4769 12.6859 12.3359V6.74365C12.6859 6.60266 12.7798 6.49301 12.9052 6.49301L15.1295 6.66532C15.2549 6.66532 15.3488 6.80631 15.3488 6.94729V12.5396C15.3488 12.6806 15.2549 12.7902 15.1295 12.7902Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx92(
          "path",
          {
            d: "M11.8242 12.5552L9.42748 12.3672C9.30216 12.3672 9.1925 12.2263 9.1925 12.0696V10.7538C9.1925 10.5971 9.30216 10.4875 9.42748 10.5031L11.8242 10.6911C11.9495 10.6911 12.0591 10.8321 12.0591 10.9887V12.3046C12.0591 12.4612 11.9495 12.5709 11.8242 12.5552Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx92(
          "path",
          {
            d: "M8.39369 12.2732L5.99699 12.0853C5.87168 12.0853 5.76202 11.9443 5.76202 11.7876V10.4718C5.76202 10.3151 5.87168 10.2055 5.99699 10.2212L8.39369 10.4091C8.51901 10.4091 8.62866 10.5501 8.62866 10.7068V12.0226C8.62866 12.1792 8.51901 12.2889 8.39369 12.2732Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx92(
          "path",
          {
            d: "M14.0801 14.247C14.0801 14.247 14.0644 14.247 14.0487 14.247L5.13552 13.5421C4.61859 13.4951 4.2113 13.0095 4.2113 12.4456V7.32324C4.2113 7.1196 4.36795 6.96295 4.57159 6.96295C4.77523 6.96295 4.93188 7.1196 4.93188 7.32324V12.4456C4.93188 12.6492 5.0572 12.8059 5.18251 12.8215L14.0957 13.5265C14.2994 13.5421 14.456 13.7144 14.4403 13.9181C14.4403 14.1061 14.268 14.2627 14.0801 14.2627V14.247Z",
            fill: "#34AFFF"
          }
        )
      ]
    })
  );
};
var HubLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs10(
    "svg",
    __spreadProps2(__spreadValues2({
      xmlns: "http://www.w3.org/2000/svg",
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      children: [
        /* @__PURE__ */ jsx102(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21942L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21942C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#1A6AFF"
          }
        ),
        /* @__PURE__ */ jsx102(
          "path",
          {
            d: "M9.80307 12.9144C9.64327 12.9144 9.48504 12.8737 9.34247 12.7922L7.4938 11.7253C7.21024 11.5624 7.0332 11.2569 7.0332 10.9294V8.79564C7.0332 8.4682 7.20867 8.1627 7.49224 7.99977L9.3409 6.93287C9.62447 6.76994 9.97697 6.76994 10.2605 6.93287L12.1092 7.99977C12.3928 8.16427 12.5698 8.4682 12.5698 8.79564V10.9294C12.5698 11.2569 12.3943 11.5624 12.1092 11.7253L10.2605 12.7922C10.118 12.8737 9.95974 12.9144 9.79994 12.9144H9.80307ZM9.80307 7.5893C9.77957 7.5893 9.75607 7.59557 9.73414 7.6081L7.88547 8.675C7.84317 8.70007 7.81654 8.74394 7.81654 8.7925V10.9263C7.81654 10.9749 7.84317 11.0203 7.8839 11.0438L9.73257 12.1107C9.77487 12.1358 9.82657 12.1358 9.86887 12.1107L11.7175 11.0438C11.7598 11.0187 11.7865 10.9749 11.7865 10.9263V8.7925C11.7865 8.74394 11.7598 8.6985 11.7175 8.675L9.86887 7.6081C9.8485 7.59557 9.825 7.5893 9.79994 7.5893H9.80307Z",
            fill: "#34AFFF"
          }
        ),
        /* @__PURE__ */ jsx102(
          "path",
          {
            d: "M9.8141 9.16696C9.5368 9.16696 9.2595 9.10586 8.99943 8.98366L5.81753 7.47339C5.65617 7.39662 5.55277 7.23526 5.54963 7.05666C5.5465 6.87806 5.6452 6.71356 5.80343 6.63052L8.9634 4.98866C9.4992 4.72232 10.1306 4.72232 10.6585 4.98552L13.8263 6.63209C13.9846 6.71512 14.0833 6.87962 14.0801 7.05822C14.077 7.23682 13.9736 7.39819 13.8122 7.47496L10.6319 8.98522C10.3734 9.10742 10.0961 9.17009 9.81723 9.17009L9.8141 9.16696ZM7.07557 7.02846L9.40363 8.13296C9.66527 8.25672 9.9645 8.25672 10.2261 8.13296L12.5526 7.02846L10.2324 5.82212C9.9739 5.69366 9.65587 5.69366 9.38953 5.82526L7.07713 7.02689L7.07557 7.02846Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx102(
          "path",
          {
            d: "M8.87091 14.9605C8.80041 14.9605 8.72991 14.9448 8.66567 14.9135L6.08067 13.6586C5.43207 13.3437 5.01221 12.6732 5.01221 11.9525V8.82229C5.01221 8.66249 5.09367 8.51365 5.22684 8.42749C5.36157 8.34132 5.52921 8.32879 5.67491 8.39302L8.53094 9.67612C9.02287 9.89702 9.34091 10.389 9.34091 10.9295V14.4921C9.34091 14.6534 9.25787 14.8038 9.12001 14.89C9.04481 14.937 8.95707 14.9621 8.87091 14.9621V14.9605ZM5.95221 9.54765V11.9509C5.95221 12.3144 6.16371 12.6528 6.49114 12.811L8.40091 13.7385V10.9263C8.40091 10.7556 8.30064 10.6005 8.14554 10.5315L5.95221 9.54609V9.54765Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx102(
          "path",
          {
            d: "M10.7541 14.9573C10.6679 14.9573 10.5802 14.9338 10.505 14.8853C10.3671 14.7991 10.2841 14.6487 10.2841 14.4873V10.9247C10.2841 10.3842 10.6021 9.89387 11.094 9.67141L13.9485 8.38831C14.0942 8.32251 14.2618 8.33504 14.3966 8.42277C14.5297 8.50894 14.6112 8.65777 14.6112 8.81757V11.9478C14.6112 12.67 14.1913 13.339 13.5427 13.6554L10.9577 14.9103C10.8919 14.9417 10.823 14.9573 10.7525 14.9573H10.7541ZM13.6728 9.54451L11.4794 10.5299C11.3243 10.6004 11.2241 10.7555 11.2241 10.9247V13.7369L13.1338 12.8094C13.4613 12.6496 13.6728 12.3128 13.6728 11.9478V9.54451Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var InflcrLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsx112(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsxs11(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          children: [
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21942L10.7917 0.262025C10.1854 -0.0873416 9.43963 -0.0873416 8.83333 0.262025L1.97917 4.21942C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
                fill: "#2CC3F2"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M13.3312 8.98679H6.60708C6.35484 8.98679 6.17467 8.74082 6.25301 8.49955L6.54599 7.60029C6.59613 7.44675 6.73869 7.34335 6.90006 7.34335H13.6242C13.8764 7.34335 14.0566 7.58932 13.9782 7.83059L13.6853 8.72985C13.6351 8.88339 13.4926 8.98679 13.3312 8.98679Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M12.4163 12.341H5.69218C5.43995 12.341 5.25982 12.095 5.33815 11.8538L5.6311 10.9545C5.68124 10.801 5.8238 10.6976 5.98517 10.6976H12.7093C12.9615 10.6976 13.1417 10.9435 13.0634 11.1848L12.7704 12.0841C12.7203 12.2376 12.5777 12.341 12.4163 12.341Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M9.89243 6.11664L7.56282 13.8466C7.51582 14.0032 7.37012 14.1113 7.20718 14.1113H6.34081C6.09171 14.1113 5.91311 13.8716 5.98518 13.6319L8.31483 5.902C8.36183 5.74534 8.50749 5.63724 8.67043 5.63724H9.5368C9.7859 5.63724 9.9645 5.87694 9.89243 6.11664Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M13.2388 6.11664L10.9092 13.8466C10.8622 14.0032 10.7165 14.1113 10.5535 14.1113H9.68715C9.43805 14.1113 9.25949 13.8716 9.33155 13.6319L11.6612 5.902C11.7082 5.74534 11.8539 5.63724 12.0168 5.63724H12.8832C13.1323 5.63724 13.3109 5.87694 13.2388 6.11664Z",
                fill: "white"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M12.0434 10.132L10.7462 8.98679H12.3881L12.0434 10.132Z",
                fill: "#74DFFF"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M8.68295 10.132L7.38574 8.98679H9.02761L8.68295 10.132Z",
                fill: "#74DFFF"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M11.0235 13.4862L9.72632 12.341H11.3682L11.0235 13.4862Z",
                fill: "#74DFFF"
              }
            ),
            /* @__PURE__ */ jsx112(
              "path",
              {
                d: "M7.68502 13.4862L6.38782 12.341H8.02968L7.68502 13.4862Z",
                fill: "#74DFFF"
              }
            )
          ]
        }
      )
    })
  );
};
var NutritionLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs13(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx13(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21943L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21943C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#009657"
          }
        ),
        /* @__PURE__ */ jsx13(
          "path",
          {
            d: "M5.32716 9.87352C5.32716 7.40132 7.33876 5.38972 9.81252 5.38972C9.90652 5.38972 10.0005 5.39285 10.093 5.39912L10.2496 5.26752L10.2559 5.26125L10.7494 4.84608L10.9014 4.71918C10.5504 4.64555 10.1854 4.60638 9.81252 4.60638C6.90322 4.60638 4.54382 6.96422 4.54382 9.87352C4.54382 11.5796 5.35536 13.0962 6.61339 14.0581H6.61496L6.64316 13.9813L6.71209 13.7949L6.87189 13.3703L6.90166 13.2889V13.2826C5.93972 12.4617 5.32716 11.2381 5.32716 9.87352Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx13(
          "path",
          {
            d: "M12.808 5.54169L12.7234 5.76729L12.7187 5.78139L12.714 5.79235L12.6544 5.95372L12.5228 6.30465C13.5991 7.12402 14.2963 8.41809 14.2963 9.87352C14.2963 12.3457 12.2847 14.3573 9.8125 14.3573C9.6386 14.3573 9.46783 14.3479 9.3002 14.3276L9.1122 14.4842L9.03387 14.55L8.61557 14.9025L8.52313 14.9809C8.93517 15.0858 9.36757 15.1407 9.8125 15.1407C12.7202 15.1407 15.0796 12.7828 15.0796 9.87352C15.0796 8.07812 14.1804 6.49109 12.808 5.54169Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx13(
          "path",
          {
            d: "M13.0132 10.3858L12.1343 11.1253L10.3483 10.7712C10.3483 10.7712 10.3358 10.7696 10.3326 10.7696C10.2637 10.7696 10.2324 10.8621 10.2935 10.9028L11.4951 11.6626L9.3566 13.4612L8.31007 13.2559C8.31007 13.2559 8.2991 13.2544 8.2944 13.2544C8.22547 13.2544 8.1957 13.3468 8.25837 13.386L8.93517 13.8137L8.70644 14.0064L8.62967 14.0722L8.51844 14.1662L8.2145 14.4215L8.03904 14.5688L7.96854 14.6283L7.82127 14.7521L7.31367 15.1767L7.26197 15.2205C7.21967 15.255 7.17424 15.2707 7.13037 15.2707C6.9972 15.2707 6.87814 15.1391 6.93454 14.9887L7.1476 14.4184L7.20087 14.2774L7.23064 14.2006L7.29957 14.0142L7.42804 13.6695L7.45937 13.5881L7.48914 13.5097L8.15027 11.7441L9.4036 11.9133C9.4036 11.9133 9.41144 11.9149 9.41457 11.9149C9.48507 11.9149 9.5164 11.8162 9.44904 11.7801L8.36177 11.1817L8.69547 10.2918L6.4614 9.80771C6.2546 9.76228 6.1888 9.49908 6.35174 9.36122L10.6507 5.74848L10.6585 5.74222L10.9139 5.52602L11.152 5.32548L11.3149 5.18918L11.3259 5.17978L11.6267 4.92755L12.0528 4.57035L12.1045 4.52805C12.1453 4.49202 12.1923 4.47635 12.2377 4.47635C12.3677 4.47635 12.4868 4.60952 12.432 4.75835L12.2628 5.21112L12.1374 5.54795L12.1327 5.55892L12.0669 5.73282L11.9855 5.95372L11.8774 6.24042L11.8742 6.24668L10.671 9.45678L12.902 9.93931C13.1103 9.98475 13.1746 10.2495 13.0132 10.3858Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx13(
          "path",
          {
            d: "M13.2717 8.81131L12.8252 9.12934L12.3896 9.43954L12.2972 9.50691L12.2862 9.51474L11.0862 9.25154V9.24371L11.8726 7.14908L11.9024 7.29008L12.0465 8.03268L12.1562 8.59668L11.6831 8.94134L13.2027 8.64055C13.2027 8.64055 13.2137 8.63898 13.2184 8.63898C13.3061 8.63898 13.35 8.75804 13.2732 8.81288L13.2717 8.81131Z",
            fill: "#5DD1A4"
          }
        )
      ]
    })
  );
};
var PathwaysLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs14(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), {
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx14(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57035 17.6458 4.21942L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21942C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#7B62D5"
          }
        ),
        /* @__PURE__ */ jsx14(
          "path",
          {
            d: "M15.3444 12.7812L9.91431 5.74376C9.88298 5.70459 9.84068 5.68579 9.79681 5.68579V6.44719C9.82501 6.44719 9.85478 6.46129 9.87044 6.49262L11.2193 9.01966C11.2554 9.08546 11.1958 9.16536 11.1253 9.14656L10.1728 8.90216V11.0203C10.1728 11.2193 10.2997 11.3947 10.4877 11.4574L15.1799 13.0256C15.3224 13.0742 15.4368 12.9003 15.3444 12.7812Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx14(
          "path",
          {
            d: "M9.7968 5.68579V6.44719C9.76704 6.44719 9.73884 6.46129 9.7216 6.49262L8.37428 9.01966C8.33824 9.08546 8.39621 9.16536 8.46827 9.14656L9.4208 8.90216V11.0203C9.4208 11.2193 9.2939 11.3947 9.1059 11.4574L4.41531 13.0256C4.27274 13.0742 4.1568 12.9003 4.2508 12.7812L9.68087 5.74376C9.71064 5.70459 9.7545 5.68579 9.79837 5.68579H9.7968Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var PulseLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs15(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M18.8125 14.0081V5.9919C18.8125 5.28263 18.4357 4.6289 17.8229 4.27348L10.8958 0.265381C10.2831 -0.0884605 9.52942 -0.0884605 8.91667 0.265381L1.98958 4.27348C1.37683 4.62732 1 5.28263 1 5.9919V14.0081C1 14.7174 1.37683 15.3711 1.98958 15.7265L8.91667 19.7346C9.52942 20.0885 10.2831 20.0885 10.8958 19.7346L17.8229 15.7265C18.4357 15.3727 18.8125 14.7174 18.8125 14.0081Z",
            fill: "#7B62D5"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M10.5504 5.01097V9.60029H9.26038V5.01097C9.26038 4.65981 9.54888 4.375 9.90622 4.375C10.0832 4.375 10.2455 4.4462 10.3619 4.56109C10.4783 4.67599 10.5504 4.83458 10.5504 5.01097Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M6.35252 8.51768V9.60028H5.0625V8.51768C5.0625 8.16652 5.351 7.88171 5.7067 7.88171C5.88373 7.88171 6.04601 7.95292 6.16239 8.06782C6.28041 8.18271 6.35252 8.34291 6.35252 8.51768Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M14.75 8.51768V9.60028H13.46V8.51768C13.46 8.16652 13.7484 7.88171 14.1041 7.88171C14.2828 7.88171 14.4435 7.95292 14.5598 8.06782C14.6779 8.18271 14.75 8.34291 14.75 8.51768Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M8.45054 6.93342V9.60028H7.16052V6.93342C7.16052 6.58065 7.45064 6.29584 7.80634 6.29584C7.98501 6.29584 8.14565 6.36703 8.26203 6.48193C8.37841 6.59844 8.45054 6.75704 8.45054 6.93342Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M12.6502 6.93342V9.60028H11.3602V6.93342C11.3602 6.75704 11.4323 6.59844 11.5487 6.48193C11.6651 6.36703 11.8273 6.29584 12.0044 6.29584C12.3617 6.29584 12.6502 6.58065 12.6502 6.93342Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M9.26202 14.989V10.3997H10.552V14.989C10.552 15.3402 10.2636 15.625 9.90622 15.625C9.72919 15.625 9.56691 15.5538 9.45053 15.4389C9.33415 15.324 9.26202 15.1654 9.26202 14.989Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M13.46 11.4823V10.3997H14.75V11.4823C14.75 11.8335 14.4615 12.1183 14.1058 12.1183C13.9288 12.1183 13.7665 12.0471 13.6501 11.9322C13.5321 11.8173 13.46 11.6571 13.46 11.4823Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M5.0625 11.4823V10.3997H6.35252V11.4823C6.35252 11.8335 6.06404 12.1183 5.70834 12.1183C5.52967 12.1183 5.36903 12.0471 5.25265 11.9322C5.13463 11.8173 5.0625 11.6571 5.0625 11.4823Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M11.3617 13.0666V10.3997H12.6517V13.0666C12.6517 13.4194 12.3616 13.7042 12.0059 13.7042C11.8272 13.7042 11.6666 13.633 11.5502 13.5181C11.4338 13.4016 11.3617 13.243 11.3617 13.0666Z",
            fill: "#9E9EE8"
          }
        ),
        /* @__PURE__ */ jsx15(
          "path",
          {
            d: "M7.16235 13.0666V10.3997H8.45237V13.0666C8.45237 13.243 8.38024 13.4016 8.26386 13.5181C8.14748 13.633 7.9852 13.7042 7.80817 13.7042C7.45084 13.7042 7.16235 13.4194 7.16235 13.0666Z",
            fill: "#9E9EE8"
          }
        )
      ]
    })
  );
};
var StrengthLogoColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs20(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M18.625 13.8309V5.91612C18.625 5.21582 18.2521 4.57036 17.6458 4.21943L10.7917 0.262025C10.1854 -0.0873417 9.43963 -0.0873417 8.83333 0.262025L1.97917 4.21943C1.37287 4.56879 1 5.21582 1 5.91612V13.8309C1 14.5312 1.37287 15.1767 1.97917 15.5276L8.83333 19.485C9.43963 19.8344 10.1854 19.8344 10.7917 19.485L17.6458 15.5276C18.2521 15.1783 18.625 14.5312 18.625 13.8309Z",
            fill: "#009657"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M10.201 11.1602C10.1556 11.1602 10.1101 11.1524 10.0663 11.1367C9.94251 11.0913 9.84851 10.9863 9.81874 10.8563L9.34404 8.79145L8.71581 10.0432C8.65001 10.1764 8.5137 10.2594 8.36644 10.2594H7.05671C6.84051 10.2594 6.66504 10.0839 6.66504 9.86775C6.66504 9.65155 6.84051 9.47608 7.05671 9.47608H8.12361L9.13097 7.46761C9.2046 7.32035 9.36598 7.23575 9.52734 7.25455C9.69184 7.27491 9.82501 7.39555 9.86261 7.55535L10.4454 10.0918L11.1598 9.55441C11.2272 9.50271 11.3102 9.47608 11.3948 9.47608H12.8095C13.0257 9.47608 13.2012 9.65155 13.2012 9.86775C13.2012 10.0839 13.0257 10.2594 12.8095 10.2594H11.5248L10.4329 11.0819C10.3639 11.1336 10.2809 11.1602 10.1979 11.1602H10.201Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M16.029 11.0234H15.3804V8.71573H16.029C16.1199 8.71573 16.1935 8.78936 16.1935 8.88023V10.8589C16.1935 10.9498 16.1199 11.0234 16.029 11.0234Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M15.1532 7.71973H14.2242C14.0979 7.71973 13.9955 7.82214 13.9955 7.94846V11.7915C13.9955 11.9178 14.0979 12.0202 14.2242 12.0202H15.1532C15.2796 12.0202 15.382 11.9178 15.382 11.7915V7.94846C15.382 7.82214 15.2796 7.71973 15.1532 7.71973Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M13.3735 6.96777H12.5196C12.3725 6.96777 12.2533 7.08702 12.2533 7.23411V12.5044C12.2533 12.6515 12.3725 12.7707 12.5196 12.7707H13.3735C13.5206 12.7707 13.6398 12.6515 13.6398 12.5044V7.23411C13.6398 7.08702 13.5206 6.96777 13.3735 6.96777Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M3.6053 8.71582H4.2539V11.0235H3.6053C3.51444 11.0235 3.4408 10.9499 3.4408 10.859V8.88033C3.4408 8.78946 3.51444 8.71582 3.6053 8.71582Z",
            fill: "#5DD1A4"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M4.48262 12.0186H5.41165C5.53798 12.0186 5.64038 11.9161 5.64038 11.7898L5.64038 7.94679C5.64038 7.82046 5.53798 7.71805 5.41165 7.71805H4.48262C4.3563 7.71805 4.25388 7.82046 4.25388 7.94679V11.7898C4.25388 11.9161 4.3563 12.0186 4.48262 12.0186Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx20(
          "path",
          {
            d: "M6.26082 12.7715H7.11466C7.26175 12.7715 7.38098 12.6522 7.38098 12.5051L7.38098 7.23488C7.38098 7.08779 7.26175 6.96855 7.11466 6.96855H6.26082C6.11373 6.96855 5.99449 7.08779 5.99449 7.23488L5.99449 12.5051C5.99449 12.6522 6.11373 12.7715 6.26082 12.7715Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var TracColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs21(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx222(
          "path",
          {
            d: "M18.5718 13.7892V5.89828C18.5718 5.20009 18.2001 4.55658 17.5956 4.2067L10.7621 0.261235C10.1577 -0.0870783 9.41418 -0.0870783 8.80971 0.261235L1.97621 4.2067C1.37174 4.55501 1 5.20009 1 5.89828V13.7892C1 14.4874 1.37174 15.1309 1.97621 15.4808L8.80971 19.4263C9.41418 19.7746 10.1577 19.7746 10.7621 19.4263L17.5956 15.4808C18.2001 15.1325 18.5718 14.4874 18.5718 13.7892Z",
            fill: "#1A6AFF"
          }
        ),
        /* @__PURE__ */ jsx222(
          "path",
          {
            d: "M14.3203 12.2585C14.3203 12.4834 14.2 12.6927 14.0063 12.8036L10.1015 15.0591C10.0031 15.1153 9.94061 15.2215 9.94061 15.3355C9.94061 15.5433 9.77348 15.712 9.56574 15.712C9.50483 15.712 9.44391 15.6964 9.38924 15.6667C8.78477 15.3402 7.53053 14.6295 7.51648 14.6217L5.52344 13.469C5.4797 13.4425 5.44222 13.4144 5.41098 13.3831C5.39848 13.3706 5.38599 13.3566 5.37505 13.3441L5.3688 13.3363L5.35631 13.3206L5.34225 13.2988L5.32819 13.2785L5.32507 13.2738V13.2691C5.27353 13.1847 5.24854 13.0926 5.24854 12.9958V12.2601C5.2501 12.0414 5.42816 11.8633 5.64683 11.8633C5.71556 11.8633 5.78272 11.8821 5.84364 11.9165L9.62666 14.1016C9.67508 14.1282 9.72975 14.1438 9.78442 14.1438C9.83908 14.1438 9.89531 14.1282 9.94217 14.1016L13.7268 11.9165C13.7877 11.8805 13.8548 11.8633 13.9251 11.8633C14.1438 11.8633 14.3203 12.0398 14.3203 12.2585Z",
            fill: "#34AFFF"
          }
        ),
        /* @__PURE__ */ jsx222(
          "path",
          {
            d: "M14.3218 9.84221C14.3218 10.0375 14.2155 10.2186 14.0484 10.3155L10.0592 12.6178C9.98737 12.66 9.94207 12.7381 9.94207 12.8224C9.94207 13.0458 9.76089 13.2269 9.53753 13.2269C9.47193 13.2269 9.40477 13.2098 9.34541 13.1785C8.72844 12.8427 7.53044 12.1648 7.51794 12.157L5.52178 11.0059C5.35465 10.9075 5.25 10.7247 5.25 10.531V9.6501C5.25 9.47828 5.38901 9.33771 5.56239 9.33771C5.61706 9.33771 5.67016 9.35333 5.71858 9.37988L9.6703 11.6603C9.70466 11.6806 9.74527 11.6916 9.78588 11.6916C9.82649 11.6916 9.86554 11.6806 9.90146 11.6603L13.686 9.47672C13.7517 9.43924 13.8235 9.41893 13.8969 9.41893C14.1312 9.41893 14.3218 9.60948 14.3218 9.84221Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx222(
          "path",
          {
            d: "M14.2484 6.86669C14.2374 6.84951 14.2265 6.83389 14.2171 6.81827L14.214 6.81359L14.2093 6.80733C14.1937 6.78703 14.1781 6.77298 14.1609 6.7558C14.1265 6.71987 14.0906 6.69176 14.0484 6.66833L10.0592 4.36446C9.97646 4.31604 9.88274 4.29105 9.7859 4.29105C9.68906 4.29105 9.59691 4.31604 9.51413 4.3629L5.52336 6.66833C5.48119 6.69176 5.44371 6.71987 5.41247 6.75423C5.39216 6.77141 5.37654 6.79171 5.36405 6.8089C5.33593 6.8417 5.31094 6.88544 5.2922 6.9323C5.26408 7.00102 5.25159 7.0713 5.25159 7.14159V8.06626C5.25159 8.16154 5.27658 8.25525 5.32344 8.3396C5.33437 8.35834 5.34843 8.38021 5.36405 8.40052V8.40364L5.36873 8.40676L5.37498 8.41458C5.38748 8.42863 5.39997 8.44269 5.41403 8.45519C5.44683 8.48799 5.48275 8.5161 5.52336 8.53953C5.55304 8.55515 8.34736 10.153 9.35169 10.7075C9.41104 10.7403 9.4782 10.7575 9.5438 10.7575C9.76404 10.7575 9.94366 10.5779 9.94366 10.3576C9.94366 10.2733 9.98896 10.1952 10.0608 10.153L14.05 7.85071C14.2062 7.76168 14.3077 7.6008 14.3202 7.42117C14.3218 7.40556 14.3233 7.39306 14.3233 7.37745V7.14159C14.3233 7.04475 14.2968 6.94947 14.2484 6.86669ZM9.6219 5.35005L9.62659 5.54684C9.62971 5.73584 9.73436 5.91234 9.89836 6.00762L12.5146 7.51958C12.5771 7.5555 12.6458 7.57893 12.7177 7.5883L9.78747 9.26271L6.31058 7.24936C6.34182 7.23843 6.37306 7.22437 6.40274 7.20719L9.6219 5.35005Z",
            fill: "white"
          }
        )
      ]
    })
  );
};
var WalletColor = (_a) => {
  var _b = _a, {
    width = 20,
    height = 20
  } = _b, props = __objRest2(_b, [
    "width",
    "height"
  ]);
  return /* @__PURE__ */ jsxs22(
    "svg",
    __spreadProps2(__spreadValues2({
      width,
      height,
      viewBox: "0 1 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx23(
          "path",
          {
            id: "Vector",
            d: "M18.8125 15.033V6.96701C18.8125 6.24826 18.4292 5.5934 17.8062 5.24201L10.8264 1.20104C10.2035 0.849653 9.45278 0.849653 8.82986 1.20104L1.85 5.22604C1.22708 5.5934 0.84375 6.24826 0.84375 6.96701V15.033C0.84375 15.7517 1.22708 16.4066 1.85 16.758L8.82986 20.799C9.45278 21.1503 10.2035 21.1503 10.8264 20.799L17.8062 16.758C18.4292 16.4066 18.8125 15.7358 18.8125 15.033Z",
            fill: "#EAA934"
          }
        ),
        /* @__PURE__ */ jsx23(
          "path",
          {
            id: "Vector_2",
            d: "M14.1965 6.55176H5.45968C4.6451 6.55176 3.99023 7.20662 3.99023 8.0212V10.0018C3.99023 10.1615 3.99023 10.3212 3.99023 10.4969V13.9948C3.99023 14.8094 4.6451 15.4643 5.45968 15.4643H14.1965C14.9951 15.4643 15.6659 14.8094 15.6659 13.9948V8.0212C15.6659 7.20662 15.0111 6.55176 14.1965 6.55176Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ jsx23(
          "path",
          {
            id: "Vector_3",
            d: "M14.484 8.10101L4.59722 9.29893H4.58125V9.26698C4.50139 8.64407 4.94861 8.06907 5.5875 7.9892L13.2222 7.06282C13.8451 6.98295 14.4201 7.43018 14.5 8.06907L14.484 8.10101Z",
            fill: "#EAA934"
          }
        ),
        /* @__PURE__ */ jsx23(
          "path",
          {
            id: "Vector_4",
            d: "M14.6597 9.44269L4.75696 10.6406L4.86876 11.5191L15.091 12.9725L14.6597 9.44269Z",
            fill: "#EAA934"
          }
        ),
        /* @__PURE__ */ jsx23(
          "path",
          {
            id: "Vector_5",
            d: "M14.6597 9.44262L4.74096 10.6405L4.58124 9.29887H4.59721L14.484 8.10095L14.6597 9.44262Z",
            fill: "#AD7C3B"
          }
        ),
        /* @__PURE__ */ jsx23(
          "path",
          {
            id: "Vector_6",
            d: "M13.909 11.535L12.6472 11.6947C12.5035 11.7107 12.3757 11.6149 12.3597 11.4711L12.2639 10.7204C12.2479 10.5767 12.3437 10.4649 12.4875 10.4329L13.7493 10.2732C13.893 10.2572 14.0208 10.3531 14.0368 10.4968L14.1326 11.2475C14.1486 11.4072 14.0528 11.5191 13.909 11.535Z",
            fill: "#AD7C3B"
          }
        )
      ]
    })
  );
};

// ../teamworks-style/dist/index.mjs
var colors = {
  white: "#ffffff",
  black: "#000000",
  gray: {
    DEFAULT: "#667085",
    25: "#FCFCFD",
    50: "#F9FAFB",
    100: "#F4F5F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#474567",
    700: "#344054",
    800: "#1D2939",
    900: "#101828"
  },
  primary: {
    DEFAULT: "#9E77ED",
    25: "#FCFAFF",
    50: "#F9F5FF",
    100: "#F4EBFF",
    200: "#E9D7FE",
    300: "#D6BBFB",
    400: "#B692F6",
    500: "#9E77ED",
    600: "#7F4ED9",
    700: "#6941C6",
    800: "#53389E",
    900: "#42307D"
  },
  error: {
    DEFAULT: "#F04438",
    25: "#FBECEB",
    50: "#FEF3F2",
    100: "#FEE4E2",
    200: "#EFB1AD",
    300: "#FDA29B",
    400: "#F97066",
    500: "#F04438",
    600: "#D92D20",
    700: "#D83D32",
    800: "#918018",
    900: "#7A271A"
  },
  warning: {
    DEFAULT: "#F79009",
    25: "#FEF4E6",
    200: "#FCD39D",
    700: "#F79009",
    800: "#EF6820"
  },
  success: {
    DEFAULT: "#12B76A",
    25: "#E7F3EC",
    50: "#ECFDF3",
    100: "#D1FADF",
    200: "#B6DCC5",
    300: "#6CE9A6",
    400: "#32D583",
    500: "#12B76A",
    600: "#039855",
    700: "#0A893C",
    800: "#05603A",
    900: "#054F31"
  },
  info: {
    DEFAULT: "#045DFF",
    25: "#E6EFFF",
    200: "#9BBEFF",
    700: "#045DFF"
  },
  light: {
    25: "#FCFCFC",
    50: "#F8FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828"
  },
  dark: {
    25: "#E7E8E8",
    50: "#D0D0D0",
    100: "#B8B9B9",
    200: "#A0A1A2",
    300: "#898A8B",
    400: "#717373",
    500: "#595B5C",
    600: "#414445",
    700: "#2A2C2D",
    800: "#121516",
    900: "#0B0D0D"
  },
  product: {
    operations: {
      DEFAULT: "#1A6AFF",
      tertiary: "#E8F0FF",
      secondary: "#BAD2FF",
      primary: "#1A6AFF"
    },
    branding: {
      DEFAULT: "#2CC3F2",
      tertiary: "#EAF9FE",
      secondary: "#C0EDFB",
      primary: "#2CC3F2"
    },
    performance: {
      DEFAULT: "#0A8560",
      tertiary: "#E7F3EF",
      secondary: "#B6DACF",
      primary: "#0A8560"
    },
    recruiting: {
      DEFAULT: "#A0D346",
      tertiary: "#F6FBED",
      secondary: "#E3F2C8",
      primary: "#A0D346"
    },
    development: {
      DEFAULT: "#8362CB",
      tertiary: "#F3EFFA",
      secondary: "#DAD0EF",
      primary: "#8362CB"
    },
    compliance: {
      DEFAULT: "#FC542D",
      tertiary: "#FECCC0",
      secondary: "#FFEEEA",
      primary: "#FC542D"
    },
    finance: {
      DEFAULT: "#EAA934",
      tertiary: "#FFEECE",
      secondary: "#FBDAA1",
      primary: "#EAA934"
    }
  }
};

// src/types.ts
var App = /* @__PURE__ */ ((App2) => {
  App2["ams"] = "ams";
  App2["arms"] = "arms";
  App2["academics"] = "academics";
  App2["axle"] = "axle";
  App2["camps"] = "camps";
  App2["collectives"] = "collectives";
  App2["communities"] = "communities";
  App2["displays"] = "tv";
  App2["hub"] = "hub";
  App2["inflcr"] = "inflcr";
  App2["trac"] = "trac";
  App2["nutrition"] = "nutrition";
  App2["pathways"] = "pathways";
  App2["pulse"] = "pulse";
  App2["strength"] = "strength";
  App2["wallet"] = "wallet";
  return App2;
})(App || {});

// src/appConfig.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var productColors = {
  primary: {
    operations: "#1A6AFF",
    nil_branding: "#2CC3F2",
    performance: "#0A8560",
    recruiting: "#A0D346",
    athlete_development: "#8362CB",
    compliance: "#FC542D",
    finance: "#EAA934"
  },
  secondary: {
    operations: "#BAD2FF",
    nil_branding: "#C0EDFB",
    performance: "#B6DACF",
    recruiting: "#E3F2C8",
    athlete_development: "#DAD0EF",
    compliance: "#FECCC0",
    finance: "#FBDAA1"
  },
  tertiary: {
    operations: "#E8F0FF",
    nil_branding: "#EAF9FE",
    performance: "#E7F3EF",
    recruiting: "#F6FBED",
    athlete_development: "#F3EFFA",
    compliance: "#FFEEEA",
    finance: "#FFEECE"
  }
};
var appMetadata = {
  ["hub" /* hub */]: {
    appId: "hub" /* hub */,
    name: "Hub",
    icon: /* @__PURE__ */ jsx25(HubLogoColor, {}),
    tertiary: productColors.tertiary.operations
  },
  ["camps" /* camps */]: {
    appId: "camps" /* camps */,
    name: "Camps",
    icon: /* @__PURE__ */ jsx25(CampsLogoColor, {}),
    tertiary: productColors.tertiary.operations
  },
  ["communities" /* communities */]: {
    appId: "communities" /* communities */,
    name: "Communities",
    icon: /* @__PURE__ */ jsx25(CommunitiesLogoColor, {}),
    tertiary: productColors.tertiary.athlete_development
  },
  ["tv" /* displays */]: {
    appId: "tv" /* displays */,
    name: "Digital Displays",
    icon: /* @__PURE__ */ jsx25(DigitalDisplaysLogoColor, {}),
    tertiary: productColors.tertiary.operations
  },
  ["arms" /* arms */]: {
    appId: "arms" /* arms */,
    name: "Compliance + Recruiting",
    icon: /* @__PURE__ */ jsx25(ComplianceLogoColor, {}),
    tertiary: productColors.tertiary.compliance
  },
  ["inflcr" /* inflcr */]: {
    appId: "inflcr" /* inflcr */,
    name: "Influencer",
    icon: /* @__PURE__ */ jsx25(InflcrLogoColor, {}),
    tertiary: productColors.tertiary.nil_branding
  },
  ["collectives" /* collectives */]: {
    appId: "collectives" /* collectives */,
    name: "Collectives",
    icon: /* @__PURE__ */ jsx25(CollectivesLogoColor, {}),
    tertiary: productColors.tertiary.nil_branding
  },
  ["ams" /* ams */]: {
    appId: "ams" /* ams */,
    name: "AMS",
    icon: /* @__PURE__ */ jsx25(AMSLogoColor, {}),
    tertiary: productColors.tertiary.performance
  },
  ["nutrition" /* nutrition */]: {
    appId: "nutrition" /* nutrition */,
    name: "Nutrition",
    icon: /* @__PURE__ */ jsx25(NutritionLogoColor, {}),
    tertiary: productColors.tertiary.performance
  },
  ["strength" /* strength */]: {
    appId: "strength" /* strength */,
    name: "Strength + Conditioning",
    icon: /* @__PURE__ */ jsx25(StrengthLogoColor, {}),
    tertiary: productColors.tertiary.performance
  },
  ["academics" /* academics */]: {
    appId: "academics" /* academics */,
    name: "Academics",
    icon: /* @__PURE__ */ jsx25(AcademicsLogoColor, {}),
    tertiary: productColors.tertiary.athlete_development
  },
  ["pathways" /* pathways */]: {
    appId: "pathways" /* pathways */,
    name: "Pathways",
    icon: /* @__PURE__ */ jsx25(PathwaysLogoColor, {}),
    tertiary: productColors.tertiary.athlete_development
  },
  ["pulse" /* pulse */]: {
    appId: "pulse" /* pulse */,
    name: "Pulse",
    icon: /* @__PURE__ */ jsx25(PulseLogoColor, {}),
    tertiary: productColors.tertiary.athlete_development
  },
  ["trac" /* trac */]: {
    appId: "trac" /* trac */,
    name: "Inventory Management",
    icon: /* @__PURE__ */ jsx25(TracColor, {}),
    tertiary: productColors.tertiary.operations
  },
  ["wallet" /* wallet */]: {
    appId: "wallet" /* wallet */,
    name: "Wallet",
    icon: /* @__PURE__ */ jsx25(WalletColor, {}),
    tertiary: productColors.tertiary.finance
  }
};

// src/utils/translation/dictionaries/de.ts
var de = {
  myProfile: "Mein Profil",
  accountSettings: "Einstellungen",
  closeMenu: "Men\xFC Schlie\xDFen",
  changeTeam: "Team Wechseln",
  chatWithSupport: "Chatten Sie mit dem Support",
  helpCenter: "Hilfezentrum",
  learningPortal: "Lernportal",
  logout: "Ausloggen",
  openMenu: "Men\xFC \xD6ffnen",
  requestError: "Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Versuchen Sie es erneut. Wenn der Fehler weiterhin besteht, wenden Sie sich an Ihren Teamworks-Administrator.",
  search: "Suchen",
  searchForTeam: "Team suchen...",
  settings: "Einstellungen",
  switchOrgs: "Organisationen Wechseln",
  teamworksApps: "Teamworks-Apps",
  teamworksHelp: "Teamworks-Hilfe",
  avatar: "Avatar"
};
var de_default = de;

// src/utils/translation/dictionaries/en.ts
var en = {
  closeMenu: "Close Menu",
  openMenu: "Open Menu",
  teamworksApps: "Teamworks Apps",
  teamworksHelp: "Teamworks Help",
  myProfile: "My Profile",
  accountSettings: "Account Settings",
  settings: "Settings",
  logout: "Logout",
  requestError: "An error occurred processing your request. Try again and if the error persists please contact your Teamworks administrator.",
  helpCenter: "Help Center",
  learningPortal: "Learning Portal",
  chatWithSupport: "Chat with Support",
  changeTeam: "Change Team",
  switchOrgs: "Switch Orgs",
  search: "Search",
  searchForTeam: "Search for team...",
  avatar: "Avatar"
};
var en_default = en;

// src/utils/translation/dictionaries/es.ts
var es = {
  accountSettings: "Configuraci\xF3n",
  changeTeam: "Cambiar Equipo",
  chatWithSupport: "Chatear con Soporte",
  closeMenu: "Cerrar Men\xFA",
  helpCenter: "Centro de Ayuda",
  learningPortal: "Portal de Aprendizaje",
  logout: "Cerrar Sesi\xF3n",
  myProfile: "Mi Perfil",
  openMenu: "Abrir Men\xFA",
  requestError: "Se produjo un error al procesar su solicitud. Intente nuevamente y, si el error persiste, comun\xEDquese con su administrador de Teamworks.",
  search: "Buscar",
  searchForTeam: "Buscar equipo...",
  settings: "Configuraci\xF3n",
  switchOrgs: "Cambiar Organizaci\xF3n",
  teamworksApps: "Teamworks Aplicaciones",
  teamworksHelp: "Ayuda de Teamworks",
  avatar: "Avatar"
};
var es_default = es;

// src/utils/translation/dictionaries/fr.ts
var fr = {
  accountSettings: "Param\xE8tres du Compte",
  changeTeam: "Changer d'\xC9quipe",
  chatWithSupport: "Discuter avec l'assistance",
  closeMenu: "Fermer le menu",
  helpCenter: "Centre d'aide",
  learningPortal: "Portail d'apprentissage",
  logout: "Se d\xE9connecter",
  myProfile: "Mon profil",
  openMenu: "Ouvrir le menu",
  requestError: "Une erreur s'est produite lors du traitement de votre demande. R\xE9essayez et si l'erreur persiste, contactez votre administrateur Teamworks.",
  search: "Recherche",
  searchForTeam: "Recherche d'\xE9quipe...",
  settings: "Param\xE8tres",
  switchOrgs: "Changer d'organisation",
  teamworksApps: "Applications de Teamworks",
  teamworksHelp: "Aide de Teamworks",
  avatar: "Avatar"
};
var fr_default = fr;

// src/utils/translation/dictionaries/it.ts
var it = {
  accountSettings: "Impostazioni dell'Account",
  changeTeam: "Cambia Squadra",
  chatWithSupport: "Chatta con il Supporto",
  closeMenu: "Chiudi Men\xF9",
  helpCenter: "Centro Assistenza",
  learningPortal: "Portale di Apprendimento",
  logout: "Esci",
  myProfile: "Il mio profilo",
  openMenu: "Apri Men\xF9",
  requestError: "Si \xE8 verificato un errore durante l'elaborazione della tua richiesta. Riprova e se l'errore persiste contatta il tuo amministratore di Teamworks.",
  search: "Ricerca",
  searchForTeam: "Ricerca...",
  settings: "Impostazioni",
  switchOrgs: "Cambia Organizzazione",
  teamworksApps: "App di Teamworks",
  teamworksHelp: "Aiuto di Teamworks",
  avatar: "Avatar"
};
var it_default = it;

// src/utils/translation/dictionaries/nl.ts
var nl = {
  accountSettings: "Account instellingen",
  changeTeam: "Verander van team",
  chatWithSupport: "Chatten met Ondersteuning",
  closeMenu: "Menu sluiten",
  helpCenter: "Helpcentrum",
  learningPortal: "Leerportaal",
  logout: "Uitloggen",
  myProfile: "Mijn profiel",
  openMenu: "Menu Openen",
  requestError: "Er is een fout opgetreden bij het verwerken van uw verzoek. Probeer het opnieuw en als de fout zich blijft voordoen, neem dan contact op met uw Teamworks-beheerder.",
  search: "Zoekopdracht",
  searchForTeam: "Zoek team...",
  settings: "Instellingen",
  switchOrgs: "Van Organisatie Wisselen",
  teamworksApps: "Teamworks-applicaties",
  teamworksHelp: "Teamwork-hulp",
  avatar: "Avatar"
};
var nl_default = nl;

// src/utils/translation/dictionaries/pt.ts
var pt = {
  accountSettings: "Configura\xE7\xF5es de Conta",
  changeTeam: "Alterar Equipe",
  chatWithSupport: "Converse com o Suporte",
  closeMenu: "Fechar Menu",
  helpCenter: "Centro de Ajuda",
  learningPortal: "Portal de Aprendizagem",
  logout: "Sair",
  myProfile: "Meu perfil",
  openMenu: "Menu Aberto",
  requestError: "Ocorreu um erro ao processar o pedido. Tente novamente e se o erro persistir, entre em contacto com o administrador do Teamworks.",
  search: "Procurar",
  searchForTeam: "Procurar equipa...",
  settings: "Configura\xE7\xF5es",
  switchOrgs: "Alternar Organiza\xE7\xF5es",
  teamworksApps: "Aplicativos do Teamworks",
  teamworksHelp: "Ajuda do Teamworks",
  avatar: "Avatar"
};
var pt_default = pt;

// src/utils/translation/dictionaries/pt-br.ts
var pt2 = {
  closeMenu: "Fechar Menu",
  openMenu: "Abrir Menu",
  teamworksApps: "Aplicativos do Teamworks",
  teamworksHelp: "Ajuda do Teamworks",
  myProfile: "Meu Perfil",
  accountSettings: "Configura\xE7\xF5es da Conta",
  settings: "Configura\xE7\xF5es",
  logout: "Sair",
  requestError: "Ocorreu um erro ao processar sua solicita\xE7\xE3o. Tente novamente e, se o erro persistir, entre em contato com o administrador do Teamworks.",
  helpCenter: "Central de Ajuda",
  learningPortal: "Portal de Aprendizagem",
  chatWithSupport: "Conversar com o Suporte",
  changeTeam: "Mudar de Equipe",
  switchOrgs: "Trocar de Organiza\xE7\xE3o",
  search: "Pesquisar",
  searchForTeam: "Pesquisar equipe...",
  avatar: "Avatar"
};
var pt_br_default = pt2;

// src/utils/translation/index.ts
var supportedLanguages = [
  "en",
  "es",
  "fr",
  "de",
  "it",
  "nl",
  "pt",
  "pt-BR"
];
var dictionary = {
  en: en_default,
  es: es_default,
  fr: fr_default,
  de: de_default,
  it: it_default,
  nl: nl_default,
  pt: pt_default,
  "pt-BR": pt_br_default
};
var _dictionary, _fallback;
var Translation = class {
  constructor() {
    __privateAdd(this, _dictionary, void 0);
    __privateAdd(this, _fallback, void 0);
    __privateSet(this, _dictionary, dictionary[getSupportedLanguage()]);
    __privateSet(this, _fallback, dictionary.en);
    this.locale = getLocale();
  }
  translate(key, args) {
    var _a, _b;
    const translation = (_b = (_a = __privateGet(this, _dictionary)[key]) != null ? _a : __privateGet(this, _fallback)[key]) != null ? _b : key;
    if (args) {
      return translation.replace(/%{(\w+)}/g, (match, arg) => {
        var _a2, _b2;
        return (_b2 = (_a2 = args[arg]) == null ? void 0 : _a2.toString()) != null ? _b2 : match;
      });
    }
    return translation;
  }
};
_dictionary = new WeakMap();
_fallback = new WeakMap();
var translator = new Translation();
var getTranslation = (key, args) => {
  return translator.translate(key, args);
};
function getLocale() {
  var _a, _b, _c;
  if (typeof window === "undefined")
    return "en-US";
  const preferredLocales = (
    // @ts-expect-error
    (_b = window.navigator.languages) != null ? _b : (_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userLanguage
  );
  return (_c = preferredLocales == null ? void 0 : preferredLocales[0]) != null ? _c : "en-US";
}
function getSupportedLanguage() {
  var _a, _b, _c;
  if (typeof window === "undefined")
    return "en";
  const supportedMatches = (
    // @ts-expect-error
    ((_b = window.navigator.languages) != null ? _b : (_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userLanguage).filter((language) => {
      return supportedLanguages.includes(
        language.slice(0, 2)
      );
    }).map((language) => {
      return language.slice(0, 2);
    })
  );
  return (_c = supportedMatches == null ? void 0 : supportedMatches[0]) != null ? _c : "en";
}

// ../../node_modules/@radix-ui/react-tooltip/dist/index.mjs
import * as React33 from "react";

// ../../node_modules/@radix-ui/react-tooltip/node_modules/@radix-ui/react-slot/dist/index.mjs
import * as React31 from "react";
import { Fragment as Fragment5, jsx as jsx26 } from "react/jsx-runtime";
var Slot3 = React31.forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  const childrenArray = React31.Children.toArray(children);
  const slottable = childrenArray.find(isSlottable3);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if (React31.Children.count(newElement) > 1)
          return React31.Children.only(null);
        return React31.isValidElement(newElement) ? newElement.props.children : null;
      } else {
        return child;
      }
    });
    return /* @__PURE__ */ jsx26(SlotClone3, __spreadProps(__spreadValues({}, slotProps), { ref: forwardedRef, children: React31.isValidElement(newElement) ? React31.cloneElement(newElement, void 0, newChildren) : null }));
  }
  return /* @__PURE__ */ jsx26(SlotClone3, __spreadProps(__spreadValues({}, slotProps), { ref: forwardedRef, children }));
});
Slot3.displayName = "Slot";
var SlotClone3 = React31.forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  if (React31.isValidElement(children)) {
    const childrenRef = getElementRef4(children);
    return React31.cloneElement(children, __spreadProps(__spreadValues({}, mergeProps3(slotProps, children.props)), {
      // @ts-ignore
      ref: forwardedRef ? composeRefs(forwardedRef, childrenRef) : childrenRef
    }));
  }
  return React31.Children.count(children) > 1 ? React31.Children.only(null) : null;
});
SlotClone3.displayName = "SlotClone";
var Slottable3 = ({ children }) => {
  return /* @__PURE__ */ jsx26(Fragment5, { children });
};
function isSlottable3(child) {
  return React31.isValidElement(child) && child.type === Slottable3;
}
function mergeProps3(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue) {
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      } else if (slotPropValue) {
        overrideProps[propName] = slotPropValue;
      }
    } else if (propName === "style") {
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    } else if (propName === "className") {
      overrideProps[propName] = [slotPropValue, childPropValue].filter(Boolean).join(" ");
    }
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}
function getElementRef4(element) {
  var _a, _b;
  let getter = (_a = Object.getOwnPropertyDescriptor(element.props, "ref")) == null ? void 0 : _a.get;
  let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.ref;
  }
  getter = (_b = Object.getOwnPropertyDescriptor(element, "ref")) == null ? void 0 : _b.get;
  mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
  if (mayWarn) {
    return element.props.ref;
  }
  return element.props.ref || element.ref;
}

// ../../node_modules/@radix-ui/react-visually-hidden/dist/index.mjs
import * as React32 from "react";
import { jsx as jsx27 } from "react/jsx-runtime";
var NAME2 = "VisuallyHidden";
var VisuallyHidden = React32.forwardRef(
  (props, forwardedRef) => {
    return /* @__PURE__ */ jsx27(
      Primitive.span,
      __spreadProps(__spreadValues({}, props), {
        ref: forwardedRef,
        style: __spreadValues({
          // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
          position: "absolute",
          border: 0,
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0, 0, 0, 0)",
          whiteSpace: "nowrap",
          wordWrap: "normal"
        }, props.style)
      })
    );
  }
);
VisuallyHidden.displayName = NAME2;
var Root3 = VisuallyHidden;

// ../../node_modules/@radix-ui/react-tooltip/dist/index.mjs
import { jsx as jsx28, jsxs as jsxs24 } from "react/jsx-runtime";
var [createTooltipContext, createTooltipScope] = createContextScope("Tooltip", [
  createPopperScope
]);
var usePopperScope2 = createPopperScope();
var PROVIDER_NAME = "TooltipProvider";
var DEFAULT_DELAY_DURATION = 700;
var TOOLTIP_OPEN = "tooltip.open";
var [TooltipProviderContextProvider, useTooltipProviderContext] = createTooltipContext(PROVIDER_NAME);
var TooltipProvider = (props) => {
  const {
    __scopeTooltip,
    delayDuration = DEFAULT_DELAY_DURATION,
    skipDelayDuration = 300,
    disableHoverableContent = false,
    children
  } = props;
  const [isOpenDelayed, setIsOpenDelayed] = React33.useState(true);
  const isPointerInTransitRef = React33.useRef(false);
  const skipDelayTimerRef = React33.useRef(0);
  React33.useEffect(() => {
    const skipDelayTimer = skipDelayTimerRef.current;
    return () => window.clearTimeout(skipDelayTimer);
  }, []);
  return /* @__PURE__ */ jsx28(
    TooltipProviderContextProvider,
    {
      scope: __scopeTooltip,
      isOpenDelayed,
      delayDuration,
      onOpen: React33.useCallback(() => {
        window.clearTimeout(skipDelayTimerRef.current);
        setIsOpenDelayed(false);
      }, []),
      onClose: React33.useCallback(() => {
        window.clearTimeout(skipDelayTimerRef.current);
        skipDelayTimerRef.current = window.setTimeout(
          () => setIsOpenDelayed(true),
          skipDelayDuration
        );
      }, [skipDelayDuration]),
      isPointerInTransitRef,
      onPointerInTransitChange: React33.useCallback((inTransit) => {
        isPointerInTransitRef.current = inTransit;
      }, []),
      disableHoverableContent,
      children
    }
  );
};
TooltipProvider.displayName = PROVIDER_NAME;
var TOOLTIP_NAME = "Tooltip";
var [TooltipContextProvider, useTooltipContext] = createTooltipContext(TOOLTIP_NAME);
var Tooltip = (props) => {
  const {
    __scopeTooltip,
    children,
    open: openProp,
    defaultOpen = false,
    onOpenChange,
    disableHoverableContent: disableHoverableContentProp,
    delayDuration: delayDurationProp
  } = props;
  const providerContext = useTooltipProviderContext(TOOLTIP_NAME, props.__scopeTooltip);
  const popperScope = usePopperScope2(__scopeTooltip);
  const [trigger, setTrigger] = React33.useState(null);
  const contentId = useId();
  const openTimerRef = React33.useRef(0);
  const disableHoverableContent = disableHoverableContentProp != null ? disableHoverableContentProp : providerContext.disableHoverableContent;
  const delayDuration = delayDurationProp != null ? delayDurationProp : providerContext.delayDuration;
  const wasOpenDelayedRef = React33.useRef(false);
  const [open = false, setOpen] = useControllableState({
    prop: openProp,
    defaultProp: defaultOpen,
    onChange: (open2) => {
      if (open2) {
        providerContext.onOpen();
        document.dispatchEvent(new CustomEvent(TOOLTIP_OPEN));
      } else {
        providerContext.onClose();
      }
      onOpenChange == null ? void 0 : onOpenChange(open2);
    }
  });
  const stateAttribute = React33.useMemo(() => {
    return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
  }, [open]);
  const handleOpen = React33.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    wasOpenDelayedRef.current = false;
    setOpen(true);
  }, [setOpen]);
  const handleClose = React33.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    setOpen(false);
  }, [setOpen]);
  const handleDelayedOpen = React33.useCallback(() => {
    window.clearTimeout(openTimerRef.current);
    openTimerRef.current = window.setTimeout(() => {
      wasOpenDelayedRef.current = true;
      setOpen(true);
    }, delayDuration);
  }, [delayDuration, setOpen]);
  React33.useEffect(() => {
    return () => window.clearTimeout(openTimerRef.current);
  }, []);
  return /* @__PURE__ */ jsx28(Root2, __spreadProps(__spreadValues({}, popperScope), { children: /* @__PURE__ */ jsx28(
    TooltipContextProvider,
    {
      scope: __scopeTooltip,
      contentId,
      open,
      stateAttribute,
      trigger,
      onTriggerChange: setTrigger,
      onTriggerEnter: React33.useCallback(() => {
        if (providerContext.isOpenDelayed)
          handleDelayedOpen();
        else
          handleOpen();
      }, [providerContext.isOpenDelayed, handleDelayedOpen, handleOpen]),
      onTriggerLeave: React33.useCallback(() => {
        if (disableHoverableContent) {
          handleClose();
        } else {
          window.clearTimeout(openTimerRef.current);
        }
      }, [handleClose, disableHoverableContent]),
      onOpen: handleOpen,
      onClose: handleClose,
      disableHoverableContent,
      children
    }
  ) }));
};
Tooltip.displayName = TOOLTIP_NAME;
var TRIGGER_NAME2 = "TooltipTrigger";
var TooltipTrigger = React33.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopeTooltip } = _a, triggerProps = __objRest(_a, ["__scopeTooltip"]);
    const context = useTooltipContext(TRIGGER_NAME2, __scopeTooltip);
    const providerContext = useTooltipProviderContext(TRIGGER_NAME2, __scopeTooltip);
    const popperScope = usePopperScope2(__scopeTooltip);
    const ref = React33.useRef(null);
    const composedRefs = useComposedRefs(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = React33.useRef(false);
    const hasPointerMoveOpenedRef = React33.useRef(false);
    const handlePointerUp = React33.useCallback(() => isPointerDownRef.current = false, []);
    React33.useEffect(() => {
      return () => document.removeEventListener("pointerup", handlePointerUp);
    }, [handlePointerUp]);
    return /* @__PURE__ */ jsx28(Anchor, __spreadProps(__spreadValues({ asChild: true }, popperScope), { children: /* @__PURE__ */ jsx28(
      Primitive.button,
      __spreadProps(__spreadValues({
        "aria-describedby": context.open ? context.contentId : void 0,
        "data-state": context.stateAttribute
      }, triggerProps), {
        ref: composedRefs,
        onPointerMove: composeEventHandlers(props.onPointerMove, (event) => {
          if (event.pointerType === "touch")
            return;
          if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
            context.onTriggerEnter();
            hasPointerMoveOpenedRef.current = true;
          }
        }),
        onPointerLeave: composeEventHandlers(props.onPointerLeave, () => {
          context.onTriggerLeave();
          hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: composeEventHandlers(props.onPointerDown, () => {
          isPointerDownRef.current = true;
          document.addEventListener("pointerup", handlePointerUp, { once: true });
        }),
        onFocus: composeEventHandlers(props.onFocus, () => {
          if (!isPointerDownRef.current)
            context.onOpen();
        }),
        onBlur: composeEventHandlers(props.onBlur, context.onClose),
        onClick: composeEventHandlers(props.onClick, context.onClose)
      })
    ) }));
  }
);
TooltipTrigger.displayName = TRIGGER_NAME2;
var PORTAL_NAME3 = "TooltipPortal";
var [PortalProvider2, usePortalContext2] = createTooltipContext(PORTAL_NAME3, {
  forceMount: void 0
});
var TooltipPortal = (props) => {
  const { __scopeTooltip, forceMount, children, container } = props;
  const context = useTooltipContext(PORTAL_NAME3, __scopeTooltip);
  return /* @__PURE__ */ jsx28(PortalProvider2, { scope: __scopeTooltip, forceMount, children: /* @__PURE__ */ jsx28(Presence, { present: forceMount || context.open, children: /* @__PURE__ */ jsx28(Portal, { asChild: true, container, children }) }) });
};
TooltipPortal.displayName = PORTAL_NAME3;
var CONTENT_NAME3 = "TooltipContent";
var TooltipContent = React33.forwardRef(
  (props, forwardedRef) => {
    const portalContext = usePortalContext2(CONTENT_NAME3, props.__scopeTooltip);
    const _a = props, { forceMount = portalContext.forceMount, side = "top" } = _a, contentProps = __objRest(_a, ["forceMount", "side"]);
    const context = useTooltipContext(CONTENT_NAME3, props.__scopeTooltip);
    return /* @__PURE__ */ jsx28(Presence, { present: forceMount || context.open, children: context.disableHoverableContent ? /* @__PURE__ */ jsx28(TooltipContentImpl, __spreadProps(__spreadValues({ side }, contentProps), { ref: forwardedRef })) : /* @__PURE__ */ jsx28(TooltipContentHoverable, __spreadProps(__spreadValues({ side }, contentProps), { ref: forwardedRef })) });
  }
);
var TooltipContentHoverable = React33.forwardRef((props, forwardedRef) => {
  const context = useTooltipContext(CONTENT_NAME3, props.__scopeTooltip);
  const providerContext = useTooltipProviderContext(CONTENT_NAME3, props.__scopeTooltip);
  const ref = React33.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const [pointerGraceArea, setPointerGraceArea] = React33.useState(null);
  const { trigger, onClose } = context;
  const content = ref.current;
  const { onPointerInTransitChange } = providerContext;
  const handleRemoveGraceArea = React33.useCallback(() => {
    setPointerGraceArea(null);
    onPointerInTransitChange(false);
  }, [onPointerInTransitChange]);
  const handleCreateGraceArea = React33.useCallback(
    (event, hoverTarget) => {
      const currentTarget = event.currentTarget;
      const exitPoint = { x: event.clientX, y: event.clientY };
      const exitSide = getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
      const paddedExitPoints = getPaddedExitPoints(exitPoint, exitSide);
      const hoverTargetPoints = getPointsFromRect(hoverTarget.getBoundingClientRect());
      const graceArea = getHull([...paddedExitPoints, ...hoverTargetPoints]);
      setPointerGraceArea(graceArea);
      onPointerInTransitChange(true);
    },
    [onPointerInTransitChange]
  );
  React33.useEffect(() => {
    return () => handleRemoveGraceArea();
  }, [handleRemoveGraceArea]);
  React33.useEffect(() => {
    if (trigger && content) {
      const handleTriggerLeave = (event) => handleCreateGraceArea(event, content);
      const handleContentLeave = (event) => handleCreateGraceArea(event, trigger);
      trigger.addEventListener("pointerleave", handleTriggerLeave);
      content.addEventListener("pointerleave", handleContentLeave);
      return () => {
        trigger.removeEventListener("pointerleave", handleTriggerLeave);
        content.removeEventListener("pointerleave", handleContentLeave);
      };
    }
  }, [trigger, content, handleCreateGraceArea, handleRemoveGraceArea]);
  React33.useEffect(() => {
    if (pointerGraceArea) {
      const handleTrackPointerGrace = (event) => {
        const target = event.target;
        const pointerPosition = { x: event.clientX, y: event.clientY };
        const hasEnteredTarget = (trigger == null ? void 0 : trigger.contains(target)) || (content == null ? void 0 : content.contains(target));
        const isPointerOutsideGraceArea = !isPointInPolygon(pointerPosition, pointerGraceArea);
        if (hasEnteredTarget) {
          handleRemoveGraceArea();
        } else if (isPointerOutsideGraceArea) {
          handleRemoveGraceArea();
          onClose();
        }
      };
      document.addEventListener("pointermove", handleTrackPointerGrace);
      return () => document.removeEventListener("pointermove", handleTrackPointerGrace);
    }
  }, [trigger, content, pointerGraceArea, onClose, handleRemoveGraceArea]);
  return /* @__PURE__ */ jsx28(TooltipContentImpl, __spreadProps(__spreadValues({}, props), { ref: composedRefs }));
});
var [VisuallyHiddenContentContextProvider, useVisuallyHiddenContentContext] = createTooltipContext(TOOLTIP_NAME, { isInside: false });
var TooltipContentImpl = React33.forwardRef(
  (props, forwardedRef) => {
    const _a = props, {
      __scopeTooltip,
      children,
      "aria-label": ariaLabel,
      onEscapeKeyDown,
      onPointerDownOutside
    } = _a, contentProps = __objRest(_a, [
      "__scopeTooltip",
      "children",
      "aria-label",
      "onEscapeKeyDown",
      "onPointerDownOutside"
    ]);
    const context = useTooltipContext(CONTENT_NAME3, __scopeTooltip);
    const popperScope = usePopperScope2(__scopeTooltip);
    const { onClose } = context;
    React33.useEffect(() => {
      document.addEventListener(TOOLTIP_OPEN, onClose);
      return () => document.removeEventListener(TOOLTIP_OPEN, onClose);
    }, [onClose]);
    React33.useEffect(() => {
      if (context.trigger) {
        const handleScroll2 = (event) => {
          const target = event.target;
          if (target == null ? void 0 : target.contains(context.trigger))
            onClose();
        };
        window.addEventListener("scroll", handleScroll2, { capture: true });
        return () => window.removeEventListener("scroll", handleScroll2, { capture: true });
      }
    }, [context.trigger, onClose]);
    return /* @__PURE__ */ jsx28(
      DismissableLayer,
      {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown,
        onPointerDownOutside,
        onFocusOutside: (event) => event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ jsxs24(
          Content,
          __spreadProps(__spreadValues(__spreadValues({
            "data-state": context.stateAttribute
          }, popperScope), contentProps), {
            ref: forwardedRef,
            style: __spreadValues(__spreadValues({}, contentProps.style), {
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            }),
            children: [
              /* @__PURE__ */ jsx28(Slottable3, { children }),
              /* @__PURE__ */ jsx28(VisuallyHiddenContentContextProvider, { scope: __scopeTooltip, isInside: true, children: /* @__PURE__ */ jsx28(Root3, { id: context.contentId, role: "tooltip", children: ariaLabel || children }) })
            ]
          })
        )
      }
    );
  }
);
TooltipContent.displayName = CONTENT_NAME3;
var ARROW_NAME3 = "TooltipArrow";
var TooltipArrow = React33.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopeTooltip } = _a, arrowProps = __objRest(_a, ["__scopeTooltip"]);
    const popperScope = usePopperScope2(__scopeTooltip);
    const visuallyHiddenContentContext = useVisuallyHiddenContentContext(
      ARROW_NAME3,
      __scopeTooltip
    );
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ jsx28(Arrow2, __spreadProps(__spreadValues(__spreadValues({}, popperScope), arrowProps), { ref: forwardedRef }));
  }
);
TooltipArrow.displayName = ARROW_NAME3;
function getExitSideFromRect(point, rect) {
  const top = Math.abs(rect.top - point.y);
  const bottom = Math.abs(rect.bottom - point.y);
  const right = Math.abs(rect.right - point.x);
  const left = Math.abs(rect.left - point.x);
  switch (Math.min(top, bottom, right, left)) {
    case left:
      return "left";
    case right:
      return "right";
    case top:
      return "top";
    case bottom:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
  const paddedExitPoints = [];
  switch (exitSide) {
    case "top":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y + padding },
        { x: exitPoint.x + padding, y: exitPoint.y + padding }
      );
      break;
    case "bottom":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y - padding },
        { x: exitPoint.x + padding, y: exitPoint.y - padding }
      );
      break;
    case "left":
      paddedExitPoints.push(
        { x: exitPoint.x + padding, y: exitPoint.y - padding },
        { x: exitPoint.x + padding, y: exitPoint.y + padding }
      );
      break;
    case "right":
      paddedExitPoints.push(
        { x: exitPoint.x - padding, y: exitPoint.y - padding },
        { x: exitPoint.x - padding, y: exitPoint.y + padding }
      );
      break;
  }
  return paddedExitPoints;
}
function getPointsFromRect(rect) {
  const { top, right, bottom, left } = rect;
  return [
    { x: left, y: top },
    { x: right, y: top },
    { x: right, y: bottom },
    { x: left, y: bottom }
  ];
}
function isPointInPolygon(point, polygon) {
  const { x, y } = point;
  let inside = false;
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].x;
    const yi = polygon[i].y;
    const xj = polygon[j].x;
    const yj = polygon[j].y;
    const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect)
      inside = !inside;
  }
  return inside;
}
function getHull(points) {
  const newPoints = points.slice();
  newPoints.sort((a, b) => {
    if (a.x < b.x)
      return -1;
    else if (a.x > b.x)
      return 1;
    else if (a.y < b.y)
      return -1;
    else if (a.y > b.y)
      return 1;
    else
      return 0;
  });
  return getHullPresorted(newPoints);
}
function getHullPresorted(points) {
  if (points.length <= 1)
    return points.slice();
  const upperHull = [];
  for (let i = 0; i < points.length; i++) {
    const p = points[i];
    while (upperHull.length >= 2) {
      const q = upperHull[upperHull.length - 1];
      const r2 = upperHull[upperHull.length - 2];
      if ((q.x - r2.x) * (p.y - r2.y) >= (q.y - r2.y) * (p.x - r2.x))
        upperHull.pop();
      else
        break;
    }
    upperHull.push(p);
  }
  upperHull.pop();
  const lowerHull = [];
  for (let i = points.length - 1; i >= 0; i--) {
    const p = points[i];
    while (lowerHull.length >= 2) {
      const q = lowerHull[lowerHull.length - 1];
      const r2 = lowerHull[lowerHull.length - 2];
      if ((q.x - r2.x) * (p.y - r2.y) >= (q.y - r2.y) * (p.x - r2.x))
        lowerHull.pop();
      else
        break;
    }
    lowerHull.push(p);
  }
  lowerHull.pop();
  if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) {
    return upperHull;
  } else {
    return upperHull.concat(lowerHull);
  }
}
var Provider = TooltipProvider;
var Root32 = Tooltip;
var Trigger2 = TooltipTrigger;
var Portal3 = TooltipPortal;
var Content22 = TooltipContent;
var Arrow22 = TooltipArrow;

// src/components/Tooltip/Tooltip.tsx
import { forwardRef as forwardRef15 } from "react";

// src/utils/tailwind.ts
import { extendTailwindMerge } from "tailwind-merge";
var twMerge = extendTailwindMerge({
  prefix: "tw-"
});
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/Tooltip/Tooltip.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var TooltipProvider2 = Provider;
var Tooltip2 = (_a) => {
  var _b = _a, {
    delayDuration = 0
  } = _b, props = __objRest(_b, [
    "delayDuration"
  ]);
  return /* @__PURE__ */ jsx29(Root32, __spreadValues({ delayDuration }, props));
};
Tooltip2.displayName = Root32.displayName;
var TooltipTrigger2 = Trigger2;
var TooltipPortal2 = Portal3;
var TooltipArrow2 = Arrow22;
var TooltipContent2 = forwardRef15((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ jsx29(
    Content22,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "tw-z-50 tw-overflow-hidden tw-rounded-md tw-bg-dark-900 tw-px-3 tw-py-1.5 tw-text-xs tw-text-white tw-animate-in tw-fade-in-0 tw-zoom-in-95 data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=closed]:tw-zoom-out-95 data-[side=bottom]:tw-slide-in-from-top-2 data-[side=left]:tw-slide-in-from-right-2 data-[side=right]:tw-slide-in-from-left-2 data-[side=top]:tw-slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
TooltipContent2.displayName = Content22.displayName;

// src/components/MenuItem.tsx
import { jsx as jsx30, jsxs as jsxs25 } from "react/jsx-runtime";
var MenuItem = ({
  children,
  isExpanded,
  tooltip,
  onClick
}) => {
  return isExpanded || !tooltip ? /* @__PURE__ */ jsx30("div", { onClick, children }) : /* @__PURE__ */ jsxs25(Tooltip2, { delayDuration: 0, children: [
    /* @__PURE__ */ jsx30(TooltipTrigger2, { asChild: true, children: /* @__PURE__ */ jsx30("div", { onClick, children }) }),
    /* @__PURE__ */ jsx30(TooltipPortal2, { children: /* @__PURE__ */ jsxs25(TooltipContent2, { className: "tw-bg-dark-700", side: "right", children: [
      /* @__PURE__ */ jsx30(TooltipArrow2, { className: "tw-fill-dark-700" }),
      /* @__PURE__ */ jsx30("span", { children: tooltip })
    ] }) })
  ] });
};
var MenuItem_default = MenuItem;

// src/components/AppSwitcher.tsx
import { jsx as jsx31, jsxs as jsxs26 } from "react/jsx-runtime";
var APP_ORDER = [
  "hub" /* hub */,
  "camps" /* camps */,
  "trac" /* trac */,
  "tv" /* displays */,
  "arms" /* arms */,
  "inflcr" /* inflcr */,
  "collectives" /* collectives */,
  "ams" /* ams */,
  "nutrition" /* nutrition */,
  "strength" /* strength */,
  "academics" /* academics */,
  "communities" /* communities */,
  "pathways" /* pathways */,
  "pulse" /* pulse */
];
var AppSwitcher = ({
  app,
  apps,
  isAnimatedOut,
  isExpanded,
  onAppChange
}) => {
  const availableAppsOrdered = useMemo6(() => {
    return APP_ORDER.reduce((acc, key) => {
      if (apps && key in apps) {
        const app2 = {
          slug: key,
          name: appMetadata[key].name,
          icon: appMetadata[key].icon,
          url: apps[key]
        };
        return acc.concat(app2);
      }
      return acc;
    }, []);
  }, [apps]);
  if (availableAppsOrdered.length <= 1)
    return null;
  return /* @__PURE__ */ jsx31(MenuItem_default, { tooltip: "Teamworks Apps", isExpanded, children: /* @__PURE__ */ jsxs26(Root22, { children: [
    /* @__PURE__ */ jsx31(Trigger, { asChild: true, children: /* @__PURE__ */ jsxs26(
      "button",
      {
        "data-testid": "app-switcher",
        className: clsx(
          "apps-popover-trigger",
          "tw-group tw-flex tw-justify-start tw-items-center",
          "tw-rounded-md tw-p-2 tw-text-lg tw-font-medium",
          "tw-text-white hover:tw-bg-white/[0.15]",
          "tw-h-9 tw-w-full tw-cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ jsx31(AppSwitcherIcon, { color: colors.white }),
          isAnimatedOut && /* @__PURE__ */ jsx31("span", { className: "tw-ml-2 tw-text-sm tw-font-sans", children: getTranslation("teamworksApps") })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx31(Portal2, { children: /* @__PURE__ */ jsx31(
      Content2,
      {
        align: "start",
        side: "top",
        sideOffset: 10,
        className: "tw-reset tw-min-w-[240px] tw-z-[1500]",
        children: /* @__PURE__ */ jsx31("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx31("div", { className: "tw-relative tw-bg-white tw-space-y-2 tw-py-2", children: /* @__PURE__ */ jsx31("div", { className: "tw-max-h-[calc(100vh-147px)] tw-overflow-y-auto tw-py-1 tw-px-2", children: availableAppsOrdered.map(({ icon, name, url, slug }) => {
          const isSelected = app === slug || window.location.href.includes(url);
          return /* @__PURE__ */ jsxs26(
            "div",
            {
              onClick: isSelected ? void 0 : () => onAppChange(slug, url),
              className: "tw-flex tw-space-x-3 tw-items-center tw-font-sans tw-px-3 tw-py-2 tw-rounded-md hover:tw-bg-black/10 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent tw-w-full",
              children: [
                /* @__PURE__ */ jsx31("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: icon }),
                /* @__PURE__ */ jsx31("div", { className: "tw-flex-auto tw-text-sm tw-font-semibold tw-text-black tw-text-left", children: name }),
                isSelected && /* @__PURE__ */ jsx31("div", { className: "tw-flex-none tw-text-xl tw-font-medium tw-text-black tw-text-right", children: /* @__PURE__ */ jsx31(CheckIcon, {}) })
              ]
            },
            url
          );
        }) }) }) })
      }
    ) })
  ] }) });
};

// src/components/AvatarMenu.tsx
import { useRef as useRef13 } from "react";

// ../../node_modules/class-variance-authority/dist/index.mjs
var falsyToString = (value) => typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
var cx = clsx_m_default;
var cva = (base3, config) => {
  return (props) => {
    var ref;
    if ((config === null || config === void 0 ? void 0 : config.variants) == null)
      return cx(base3, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    const { variants, defaultVariants } = config;
    const getVariantClassNames = Object.keys(variants).map((variant) => {
      const variantProp = props === null || props === void 0 ? void 0 : props[variant];
      const defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
      if (variantProp === null)
        return null;
      const variantKey = falsyToString(variantProp) || falsyToString(defaultVariantProp);
      return variants[variant][variantKey];
    });
    const propsWithoutUndefined = props && Object.entries(props).reduce((acc, param) => {
      let [key, value] = param;
      if (value === void 0) {
        return acc;
      }
      acc[key] = value;
      return acc;
    }, {});
    const getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (ref = config.compoundVariants) === null || ref === void 0 ? void 0 : ref.reduce((acc, param1) => {
      let _a = param1, { class: cvClass, className: cvClassName } = _a, compoundVariantOptions = __objRest(_a, ["class", "className"]);
      return Object.entries(compoundVariantOptions).every((param) => {
        let [key, value] = param;
        return Array.isArray(value) ? value.includes(__spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key]) : __spreadValues(__spreadValues({}, defaultVariants), propsWithoutUndefined)[key] === value;
      }) ? [
        ...acc,
        cvClass,
        cvClassName
      ] : acc;
    }, []);
    return cx(base3, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
  };
};

// src/components/Avatar/Avatar.tsx
import {
  Children as Children6,
  createContext as createContext3,
  forwardRef as forwardRef16,
  useContext as useContext3,
  useEffect as useEffect16,
  useState as useState15
} from "react";
import { Fragment as Fragment6, jsx as jsx33 } from "react/jsx-runtime";
var avatarVariants = cva(
  "tw-inline-flex tw-overflow-hidden tw-rounded-full tw-items-center tw-justify-center tw-text-white",
  {
    variants: {
      size: {
        64: "tw-h-16 tw-w-16 tw-text-2xl tw-leading-[64px]",
        48: "tw-h-12 tw-w-12 tw-text-base tw-leading-[48px]",
        40: "tw-h-10 tw-w-10 tw-text-base tw-leading-10",
        32: "tw-h-8 tw-w-8 tw-text-xs tw-leading-8",
        24: "tw-h-6 tw-w-6 tw-text-[11px] tw-leading-6",
        20: "tw-h-5 tw-w-5 tw-text-[10px] tw-leading-5",
        16: "tw-h-4 tw-w-4 tw-text-[8px] tw-leading-4",
        12: "tw-h-3 tw-w-3 tw-text-[8px] tw-leading-3"
      },
      isGroup: {
        true: "tw-ring-1 tw-ring-white"
      }
    },
    defaultVariants: {
      size: 40,
      isGroup: false
    }
  }
);
var iconSizes = {
  64: 32,
  48: 24,
  40: 24,
  32: 16,
  24: 12,
  20: 12,
  16: 8,
  12: 8
};
var Avatar = forwardRef16(
  (_a, ref) => {
    var _b = _a, { className, name, src, size: size4, children } = _b, props = __objRest(_b, ["className", "name", "src", "size", "children"]);
    var _a2, _b2;
    const isGroup = !!((_a2 = useAvatarGroupContext()) == null ? void 0 : _a2.limit);
    const avatarGroupSize = (_b2 = useAvatarGroupContext()) == null ? void 0 : _b2.size;
    const avatarSize = size4 != null ? size4 : avatarGroupSize;
    let avatarInitials = getInitials(name != null ? name : "", avatarSize);
    const [hasError, setHasError] = useState15(false);
    return src && !hasError ? /* @__PURE__ */ jsx33(
      "img",
      {
        className: cn(
          avatarVariants({ size: size4, className, isGroup }),
          "tw-object-cover tw-bg-black/10"
        ),
        alt: name != null ? name : getTranslation("avatar"),
        src,
        onError: () => setHasError(true)
      }
    ) : /* @__PURE__ */ jsx33(
      "span",
      __spreadProps(__spreadValues({
        className: cn(
          avatarVariants({
            size: avatarSize,
            className,
            isGroup
          }),
          "tw-bg-light-500"
        )
      }, props), {
        ref,
        children: /* @__PURE__ */ jsx33(Fragment6, { children: avatarInitials ? /* @__PURE__ */ jsx33("span", { className: "tw-font-semibold", children: avatarInitials }) : isGroup ? /* @__PURE__ */ jsx33(MdPeople, { size: iconSizes[avatarSize != null ? avatarSize : 40] }) : /* @__PURE__ */ jsx33(MdPerson, { size: iconSizes[avatarSize != null ? avatarSize : 40] }) })
      })
    );
  }
);
Avatar.displayName = "Avatar";
function getInitials(name, size4) {
  var _a;
  const names = name.split(" ");
  const firstName = (_a = names[0]) != null ? _a : "";
  const lastName = names.length > 1 ? names[names.length - 1] : "";
  const initials = firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
  return (size4 && size4 < 16 ? initials.slice(0, 1) : initials).toLocaleUpperCase();
}
var AvatarGroupContext = createContext3({
  size: 40
});
var AvatarGroupProvider = ({
  children,
  limit,
  size: size4
}) => {
  const [count3, setCount] = useState15(0);
  return /* @__PURE__ */ jsx33(
    AvatarGroupContext.Provider,
    {
      value: {
        count: count3,
        setCount,
        limit,
        size: size4
      },
      children
    }
  );
};
var useAvatarGroupContext = () => useContext3(AvatarGroupContext);
var AvatarGroup = forwardRef16(
  (_a, ref) => {
    var _b = _a, { children, className, limit, size: size4 = 40 } = _b, props = __objRest(_b, ["children", "className", "limit", "size"]);
    return /* @__PURE__ */ jsx33(AvatarGroupProvider, { limit, size: size4, children: /* @__PURE__ */ jsx33(
      "div",
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          "tw-flex tw-items-center tw-justify-start tw--space-x-[.375lh]",
          className
        )
      }, props), {
        children
      })
    ) });
  }
);
AvatarGroup.displayName = "AvatarGroup";
var AvatarOverflowIndicator = forwardRef16((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { limit, count: count3, size: size4 } = useAvatarGroupContext();
  if (!limit || !count3 || count3 <= limit)
    return null;
  return /* @__PURE__ */ jsx33(
    "span",
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        avatarVariants({ size: size4, isGroup: true }),
        "tw-relative tw-flex tw-bg-light-500 tw-font-semibold",
        className
      )
    }, props), {
      children: count3 - limit
    })
  );
});
AvatarOverflowIndicator.displayName = "AvatarOverflowIndicator";

// src/components/VerticalNav/VerticalNav.tsx
import { cloneElement as cloneElement6, forwardRef as forwardRef18, useState as useState17 } from "react";

// src/utils/react.tsx
import { Children as Children7, isValidElement as isValidElement4 } from "react";
function getValidChildren(children) {
  return Children7.toArray(children).filter(
    (child) => isValidElement4(child)
  );
}

// ../../node_modules/@radix-ui/react-collapsible/dist/index.mjs
import * as React34 from "react";
import { jsx as jsx34 } from "react/jsx-runtime";
var COLLAPSIBLE_NAME = "Collapsible";
var [createCollapsibleContext, createCollapsibleScope] = createContextScope(COLLAPSIBLE_NAME);
var [CollapsibleProvider, useCollapsibleContext] = createCollapsibleContext(COLLAPSIBLE_NAME);
var Collapsible = React34.forwardRef(
  (props, forwardedRef) => {
    const _a = props, {
      __scopeCollapsible,
      open: openProp,
      defaultOpen,
      disabled,
      onOpenChange
    } = _a, collapsibleProps = __objRest(_a, [
      "__scopeCollapsible",
      "open",
      "defaultOpen",
      "disabled",
      "onOpenChange"
    ]);
    const [open = false, setOpen] = useControllableState({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChange
    });
    return /* @__PURE__ */ jsx34(
      CollapsibleProvider,
      {
        scope: __scopeCollapsible,
        disabled,
        contentId: useId(),
        open,
        onOpenToggle: React34.useCallback(() => setOpen((prevOpen) => !prevOpen), [setOpen]),
        children: /* @__PURE__ */ jsx34(
          Primitive.div,
          __spreadProps(__spreadValues({
            "data-state": getState2(open),
            "data-disabled": disabled ? "" : void 0
          }, collapsibleProps), {
            ref: forwardedRef
          })
        )
      }
    );
  }
);
Collapsible.displayName = COLLAPSIBLE_NAME;
var TRIGGER_NAME3 = "CollapsibleTrigger";
var CollapsibleTrigger = React34.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { __scopeCollapsible } = _a, triggerProps = __objRest(_a, ["__scopeCollapsible"]);
    const context = useCollapsibleContext(TRIGGER_NAME3, __scopeCollapsible);
    return /* @__PURE__ */ jsx34(
      Primitive.button,
      __spreadProps(__spreadValues({
        type: "button",
        "aria-controls": context.contentId,
        "aria-expanded": context.open || false,
        "data-state": getState2(context.open),
        "data-disabled": context.disabled ? "" : void 0,
        disabled: context.disabled
      }, triggerProps), {
        ref: forwardedRef,
        onClick: composeEventHandlers(props.onClick, context.onOpenToggle)
      })
    );
  }
);
CollapsibleTrigger.displayName = TRIGGER_NAME3;
var CONTENT_NAME4 = "CollapsibleContent";
var CollapsibleContent = React34.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { forceMount } = _a, contentProps = __objRest(_a, ["forceMount"]);
    const context = useCollapsibleContext(CONTENT_NAME4, props.__scopeCollapsible);
    return /* @__PURE__ */ jsx34(Presence, { present: forceMount || context.open, children: ({ present }) => /* @__PURE__ */ jsx34(CollapsibleContentImpl, __spreadProps(__spreadValues({}, contentProps), { ref: forwardedRef, present })) });
  }
);
CollapsibleContent.displayName = CONTENT_NAME4;
var CollapsibleContentImpl = React34.forwardRef((props, forwardedRef) => {
  const _a = props, { __scopeCollapsible, present, children } = _a, contentProps = __objRest(_a, ["__scopeCollapsible", "present", "children"]);
  const context = useCollapsibleContext(CONTENT_NAME4, __scopeCollapsible);
  const [isPresent, setIsPresent] = React34.useState(present);
  const ref = React34.useRef(null);
  const composedRefs = useComposedRefs(forwardedRef, ref);
  const heightRef = React34.useRef(0);
  const height = heightRef.current;
  const widthRef = React34.useRef(0);
  const width = widthRef.current;
  const isOpen = context.open || isPresent;
  const isMountAnimationPreventedRef = React34.useRef(isOpen);
  const originalStylesRef = React34.useRef();
  React34.useEffect(() => {
    const rAF = requestAnimationFrame(() => isMountAnimationPreventedRef.current = false);
    return () => cancelAnimationFrame(rAF);
  }, []);
  useLayoutEffect2(() => {
    const node = ref.current;
    if (node) {
      originalStylesRef.current = originalStylesRef.current || {
        transitionDuration: node.style.transitionDuration,
        animationName: node.style.animationName
      };
      node.style.transitionDuration = "0s";
      node.style.animationName = "none";
      const rect = node.getBoundingClientRect();
      heightRef.current = rect.height;
      widthRef.current = rect.width;
      if (!isMountAnimationPreventedRef.current) {
        node.style.transitionDuration = originalStylesRef.current.transitionDuration;
        node.style.animationName = originalStylesRef.current.animationName;
      }
      setIsPresent(present);
    }
  }, [context.open, present]);
  return /* @__PURE__ */ jsx34(
    Primitive.div,
    __spreadProps(__spreadValues({
      "data-state": getState2(context.open),
      "data-disabled": context.disabled ? "" : void 0,
      id: context.contentId,
      hidden: !isOpen
    }, contentProps), {
      ref: composedRefs,
      style: __spreadValues({
        [`--radix-collapsible-content-height`]: height ? `${height}px` : void 0,
        [`--radix-collapsible-content-width`]: width ? `${width}px` : void 0
      }, props.style),
      children: isOpen && children
    })
  );
});
function getState2(open) {
  return open ? "open" : "closed";
}
var Root4 = Collapsible;

// src/components/Collapsible/Collapsible.tsx
var Collapsible2 = Root4;
var CollapsibleTrigger2 = CollapsibleTrigger;
var CollapsibleContent2 = CollapsibleContent;

// src/components/NavProvider/NavProvider.tsx
import { createContext as createContext4, useContext as useContext4 } from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var defaultNavState = {
  colors: {
    bottom: "#000",
    top: "#000"
  },
  Link: AbstractLink
};
var NavContext = createContext4(defaultNavState);
var useNav = () => useContext4(NavContext);
function NavProvider(props) {
  const { children, colors: colors2, Link } = props;
  return /* @__PURE__ */ jsx35(
    NavContext.Provider,
    {
      value: {
        colors: colors2 != null ? colors2 : defaultNavState.colors,
        Link: Link != null ? Link : AbstractLink
      },
      children
    }
  );
}
var NavProvider_default = NavProvider;

// src/components/VerticalNav/VerticalNav.tsx
import { jsx as jsx36, jsxs as jsxs27 } from "react/jsx-runtime";
var VerticalNav = forwardRef18(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    const validChildren = getValidChildren(children);
    return /* @__PURE__ */ jsx36("nav", __spreadProps(__spreadValues({ ref, className: cn(" tw-w-full", className) }, props), { children: /* @__PURE__ */ jsx36("ul", { className: "tw-flex-row tw-items-left tw-list-none tw-text-sm tw-space-y-1", children: validChildren }) }));
  }
);
VerticalNav.displayName = "VerticalNav";
var VerticalNavGroup = forwardRef18(
  (_a, ref) => {
    var _b = _a, {
      title = "",
      isCollapsible = false,
      isDefaultOpen = true,
      className,
      children
    } = _b, props = __objRest(_b, [
      "title",
      "isCollapsible",
      "isDefaultOpen",
      "className",
      "children"
    ]);
    return isCollapsible ? /* @__PURE__ */ jsx36(
      CollapsibleNavGroup,
      {
        title,
        className,
        isDefaultOpen,
        children
      }
    ) : /* @__PURE__ */ jsxs27("li", { className: "tw-w-full", children: [
      /* @__PURE__ */ jsx36("span", { className: "tw-font-semibold tw-text-black dark:tw-text-white tw-p-2 tw-select-none tw-line-clamp-1", children: title }),
      /* @__PURE__ */ jsx36(
        "ul",
        __spreadProps(__spreadValues({
          ref,
          className: cn("tw-pl-1 tw-list-none tw-space-y-1", className)
        }, props), {
          children
        })
      )
    ] });
  }
);
VerticalNavGroup.displayName = "VerticalNavGroup";
var CollapsibleNavGroup = forwardRef18(
  (_a, ref) => {
    var _b = _a, { title = "", className, isDefaultOpen = true, children } = _b, props = __objRest(_b, ["title", "className", "isDefaultOpen", "children"]);
    const [isOpen, setIsOpen] = useState17(isDefaultOpen);
    return /* @__PURE__ */ jsxs27(Collapsible2, { open: isOpen, onOpenChange: setIsOpen, className: "tw-w-full", children: [
      /* @__PURE__ */ jsx36(CollapsibleTrigger2, { asChild: true, children: /* @__PURE__ */ jsxs27("div", { className: "tw-cursor-pointer tw-flex tw-items-center tw-justify-between tw-text-black dark:tw-text-white tw-p-2 select-none", children: [
        /* @__PURE__ */ jsx36("span", { className: "tw-font-semibold tw-line-clamp-1", children: title }),
        /* @__PURE__ */ jsx36(
          MdExpandMore,
          {
            className: clsx("tw-text-xl", {
              "tw-rotate-180": isOpen
            })
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx36(CollapsibleContent2, { children: /* @__PURE__ */ jsx36(
        "ul",
        __spreadProps(__spreadValues({
          ref,
          className: cn("tw-list-none tw-pl-1 tw-space-y-1", className)
        }, props), {
          children
        })
      ) })
    ] });
  }
);
CollapsibleNavGroup.displayName = "CollapsibleNavGroup";
var VerticalNavItem = forwardRef18(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    return /* @__PURE__ */ jsx36("li", __spreadProps(__spreadValues({ ref, className }, props), { children }));
  }
);
VerticalNavItem.displayName = "VerticalNavItem";
var VerticalNavSeparator = forwardRef18(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx36(
      "li",
      __spreadValues({
        ref,
        className: cn(
          "tw--mx-1 tw-my-1 tw-h-px tw-bg-light-200 dark:tw-bg-white/10",
          className
        )
      }, props)
    );
  }
);
VerticalNavSeparator.displayName = "VerticalNavSeparator";
var VerticalNavButton = forwardRef18((_a, ref) => {
  var _b = _a, { active = false, className, children } = _b, props = __objRest(_b, ["active", "className", "children"]);
  return /* @__PURE__ */ jsx36(
    "button",
    __spreadProps(__spreadValues({
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.currentTarget.click();
        }
      },
      ref,
      className: cn(
        clsx(
          "tw-flex tw-items-center tw-cursor-pointer tw-rounded-md tw-p-2 tw-border-b-2 tw-border-transparent tw-transition-colors tw-select-none tw-line-clamp-1 tw-w-full tw-h-full",
          "hover:tw-bg-light-200 hover:tw-text-black tw-text-black",
          "dark:hover:tw-bg-white/10 dark:hover:tw-text-white dark:tw-text-white",
          {
            "tw-bg-light-200 dark:tw-bg-white/10": active
          }
        ),
        className
      )
    }, props), {
      children
    })
  );
});
VerticalNavButton.displayName = "VerticalNavButton";
var VerticalNavIcon = (_a) => {
  var _b = _a, {
    icon,
    className
  } = _b, props = __objRest(_b, [
    "icon",
    "className"
  ]);
  return cloneElement6(icon, {
    className: cn("tw-mr-2 tw-h-4 tw-w-4 tw-text-dark-300", className)
  });
};
VerticalNavIcon.displayName = "VerticalNavIcon";
var VerticalNavLink = forwardRef18((_a, ref) => {
  var _b = _a, { active, className, children } = _b, props = __objRest(_b, ["active", "className", "children"]);
  const { Link } = useNav();
  if (!Link)
    return null;
  return /* @__PURE__ */ jsx36(
    Link,
    __spreadProps(__spreadValues({
      ref,
      "aria-current": active ? "page" : void 0,
      className: cn(
        clsx(
          "tw-flex tw-items-center tw-rounded-md tw-p-2 tw-border-b-2 tw-border-transparent tw-transition-colors tw-select-none tw-line-clamp-1",
          "hover:tw-bg-light-200 hover:tw-text-black tw-text-black",
          "dark:hover:tw-bg-white/10 dark:hover:tw-text-white dark:tw-text-white",
          {
            "tw-bg-light-200 dark:tw-bg-white/10": active
          }
        ),
        className
      ),
      activeClassName: "tw-bg-light-200 dark:tw-bg-white/10"
    }, props), {
      children
    })
  );
});
VerticalNavLink.displayName = "VerticalNavLink";

// src/components/AvatarMenu.tsx
import { Fragment as Fragment7, jsx as jsx37, jsxs as jsxs28 } from "react/jsx-runtime";
var AvatarMenu = ({
  collapseOnItemClick = true,
  isAnimatedOut,
  isExpanded,
  additionalSettingsLinks = [],
  toggleMenu,
  innerProps
}) => {
  const { urlAccount, urlSettings, onLogout, user } = innerProps;
  const closeButtonRef = useRef13(null);
  const innerCloseButtonRef = useRef13(null);
  const onClick = () => {
    var _a, _b;
    (_a = closeButtonRef.current) == null ? void 0 : _a.click();
    (_b = innerCloseButtonRef.current) == null ? void 0 : _b.click();
    if (isExpanded && collapseOnItemClick)
      toggleMenu();
  };
  const links = [...additionalSettingsLinks];
  if (urlAccount) {
    links.push({ name: getTranslation("myProfile"), to: urlAccount });
  }
  if (urlSettings) {
    links.push({ name: getTranslation("accountSettings"), to: urlSettings });
  }
  return /* @__PURE__ */ jsxs28(Root22, { modal: false, children: [
    /* @__PURE__ */ jsx37(Trigger, { asChild: true, children: /* @__PURE__ */ jsx37("button", { className: "tw-group tw-block tw-flex-shrink-0 tw--mx-4 tw-px-0 tw-w-[calc(100%+1rem)]", children: /* @__PURE__ */ jsx37(
      "div",
      {
        className: clsx(
          "teams-popover-trigger",
          "tw-rounded-md tw-p-2 hover:tw-bg-white/[0.15]",
          "tw-transition-all tw-duration-300 tw-ease-in-out tw-cursor-pointer"
        ),
        children: /* @__PURE__ */ jsxs28("div", { className: "tw-flex tw-items-center", children: [
          /* @__PURE__ */ jsx37("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx37(Avatar, { name: user.name, src: user.avatar, size: 32 }) }),
          isAnimatedOut && /* @__PURE__ */ jsx37(Fragment7, { children: /* @__PURE__ */ jsxs28("div", { className: "tw-text-left tw-ml-3 tw-flex-auto tw-font-medium tw-font-sans tw-truncate", children: [
            /* @__PURE__ */ jsx37("div", { className: "tw-text-white tw-text-sm tw-truncate", children: user.name }),
            user.title && /* @__PURE__ */ jsx37("div", { className: "tw-text-white/60 tw-text-[11px] tw-truncate", children: user.title })
          ] }) })
        ] })
      }
    ) }) }),
    /* @__PURE__ */ jsx37(
      Close,
      {
        ref: closeButtonRef,
        tabIndex: -1,
        className: "tw-sr-only"
      }
    ),
    /* @__PURE__ */ jsx37(Portal2, { children: /* @__PURE__ */ jsx37(
      Content2,
      {
        align: "start",
        side: "top",
        sideOffset: 10,
        className: "tw-reset tw-min-w-[256px] tw-z-[1500]",
        children: /* @__PURE__ */ jsx37("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx37("div", { className: "tw-relative tw-bg-white tw-space-y-1 tw-py-2", children: /* @__PURE__ */ jsxs28(VerticalNav, { className: "tw-max-h-[350px] tw-overflow-y-auto tw-space-y-1", children: [
          links.length > 0 && /* @__PURE__ */ jsxs28(Fragment7, { children: [
            /* @__PURE__ */ jsx37("div", { className: "tw-flex tw-px-5 tw-py-2 tw-text-xs tw-text-light-500 tw-w-full", children: getTranslation("settings") }),
            links.map(({ name, to, children }, index2) => {
              if (children) {
                return /* @__PURE__ */ jsxs28(Root22, { children: [
                  /* @__PURE__ */ jsx37(Trigger, { asChild: true, children: /* @__PURE__ */ jsxs28(
                    "button",
                    {
                      className: "tw-flex tw-text-sm tw-font-sans tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black hover:tw-text-black tw-cursor-pointer focus-visible:tw-outline-offset-[-1px] tw-w-full tw-justify-between",
                      children: [
                        /* @__PURE__ */ jsx37("span", { children: name }),
                        /* @__PURE__ */ jsx37(ChevronRightIcon, { className: "tw-h-4" })
                      ]
                    },
                    index2
                  ) }),
                  /* @__PURE__ */ jsx37(
                    Close,
                    {
                      ref: innerCloseButtonRef,
                      tabIndex: -1,
                      className: "tw-sr-only"
                    }
                  ),
                  /* @__PURE__ */ jsx37(Portal2, { children: /* @__PURE__ */ jsx37(
                    Content2,
                    {
                      align: "start",
                      side: "right",
                      sideOffset: 2,
                      className: "tw-reset tw-min-w-[256px]",
                      children: /* @__PURE__ */ jsx37("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx37("div", { className: "tw-relative tw-bg-white tw-space-y-1 tw-py-2", children: /* @__PURE__ */ jsx37("div", { className: "tw-max-h-[350px] tw-overflow-y-auto tw-space-y-1", children: children.map(({ name: name2, to: to2 }, index3) => /* @__PURE__ */ jsx37(
                        VerticalNavLink,
                        {
                          to: to2,
                          onClick,
                          className: "tw-flex tw-text-sm tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black hover:tw-text-black tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus-visible:tw-outline-offset-[-1px] tw-w-full",
                          children: name2
                        },
                        index3
                      )) }) }) })
                    }
                  ) })
                ] }, index2);
              } else {
                return /* @__PURE__ */ jsx37(
                  VerticalNavLink,
                  {
                    to,
                    onClick,
                    className: "tw-flex tw-text-sm tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black hover:tw-text-black tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus-visible:tw-outline-offset-[-1px] tw-w-full",
                    children: name
                  },
                  index2
                );
              }
            }),
            /* @__PURE__ */ jsx37("div", { className: "tw-border-b" })
          ] }),
          /* @__PURE__ */ jsxs28(
            "button",
            {
              type: "button",
              onClick: onLogout,
              className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-items-center tw-px-5 tw-py-2 tw-text-error-700 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
              children: [
                /* @__PURE__ */ jsx37("span", { className: "tw-font-sans", children: getTranslation("logout") }),
                /* @__PURE__ */ jsx37("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx37(LogoutIcon, {}) })
              ]
            }
          )
        ] }) }) })
      }
    ) })
  ] });
};

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { cloneElement as cloneElement8, forwardRef as forwardRef20 } from "react";

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends2() {
  return _extends2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r2 in t)
        ({}).hasOwnProperty.call(t, r2) && (n[r2] = t[r2]);
    }
    return n;
  }, _extends2.apply(null, arguments);
}

// ../../node_modules/@radix-ui/react-slot/dist/index.mjs
import { forwardRef as $9IrjX$forwardRef, Children as $9IrjX$Children, isValidElement as $9IrjX$isValidElement, createElement as $9IrjX$createElement, cloneElement as $9IrjX$cloneElement, Fragment as $9IrjX$Fragment } from "react";

// ../../node_modules/@radix-ui/react-slot/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
import { useCallback as $3vqmr$useCallback } from "react";
function $6ed0406888f73fc4$var$setRef(ref, value) {
  if (typeof ref === "function")
    ref(value);
  else if (ref !== null && ref !== void 0)
    ref.current = value;
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
  return (node) => refs.forEach(
    (ref) => $6ed0406888f73fc4$var$setRef(ref, node)
  );
}

// ../../node_modules/@radix-ui/react-slot/dist/index.mjs
var $5e63c961fc1ce211$export$8c6ed5c666ac1360 = /* @__PURE__ */ $9IrjX$forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  const childrenArray = $9IrjX$Children.toArray(children);
  const slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
  if (slottable) {
    const newElement = slottable.props.children;
    const newChildren = childrenArray.map((child) => {
      if (child === slottable) {
        if ($9IrjX$Children.count(newElement) > 1)
          return $9IrjX$Children.only(null);
        return /* @__PURE__ */ $9IrjX$isValidElement(newElement) ? newElement.props.children : null;
      } else
        return child;
    });
    return /* @__PURE__ */ $9IrjX$createElement($5e63c961fc1ce211$var$SlotClone, _extends2({}, slotProps, {
      ref: forwardedRef
    }), /* @__PURE__ */ $9IrjX$isValidElement(newElement) ? /* @__PURE__ */ $9IrjX$cloneElement(newElement, void 0, newChildren) : null);
  }
  return /* @__PURE__ */ $9IrjX$createElement($5e63c961fc1ce211$var$SlotClone, _extends2({}, slotProps, {
    ref: forwardedRef
  }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
var $5e63c961fc1ce211$var$SlotClone = /* @__PURE__ */ $9IrjX$forwardRef((props, forwardedRef) => {
  const _a = props, { children } = _a, slotProps = __objRest(_a, ["children"]);
  if (/* @__PURE__ */ $9IrjX$isValidElement(children))
    return /* @__PURE__ */ $9IrjX$cloneElement(children, __spreadProps(__spreadValues({}, $5e63c961fc1ce211$var$mergeProps(slotProps, children.props)), {
      ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    }));
  return $9IrjX$Children.count(children) > 1 ? $9IrjX$Children.only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
var $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children }) => {
  return /* @__PURE__ */ $9IrjX$createElement($9IrjX$Fragment, null, children);
};
function $5e63c961fc1ce211$var$isSlottable(child) {
  return /* @__PURE__ */ $9IrjX$isValidElement(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
  const overrideProps = __spreadValues({}, childProps);
  for (const propName in childProps) {
    const slotPropValue = slotProps[propName];
    const childPropValue = childProps[propName];
    const isHandler = /^on[A-Z]/.test(propName);
    if (isHandler) {
      if (slotPropValue && childPropValue)
        overrideProps[propName] = (...args) => {
          childPropValue(...args);
          slotPropValue(...args);
        };
      else if (slotPropValue)
        overrideProps[propName] = slotPropValue;
    } else if (propName === "style")
      overrideProps[propName] = __spreadValues(__spreadValues({}, slotPropValue), childPropValue);
    else if (propName === "className")
      overrideProps[propName] = [
        slotPropValue,
        childPropValue
      ].filter(Boolean).join(" ");
  }
  return __spreadValues(__spreadValues({}, slotProps), overrideProps);
}

// src/components/Button/Button.tsx
import { cloneElement as cloneElement7, forwardRef as forwardRef19 } from "react";
import { jsx as jsx38, jsxs as jsxs29 } from "react/jsx-runtime";
var base = [
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap",
  // layout
  "tw-font-semibold tw-transition-all tw-cursor-pointer",
  // appearance
  "tw-focus tw-ring-offset-white ",
  // focus
  "disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
  // disabled
].join(" ");
var buttonVariants = cva(base, {
  variants: {
    colorScheme: {
      default: "",
      destructive: "",
      info: "",
      warning: "",
      success: ""
    },
    variant: {
      primary: "tw-shadow",
      secondary: "tw-border tw-shadow",
      ghost: "tw-shadow-none",
      link: "tw-underline-offset-4 hover:tw-underline"
    },
    size: {
      sm: "tw-h-7 tw-px-2 tw-py-0.5 tw-rounded-md tw-text-xs",
      md: "tw-h-9 tw-px-3 tw-py-2 tw-text-sm",
      lg: "tw-h-11 tw-px-4 tw-py-2.5 tw-rounded-md tw-text-base"
    },
    isDisabled: {
      true: "tw-opacity-50 disabled:tw-cursor-not-allowed"
    },
    isLoading: {
      true: "tw-opacity-50 tw-pointer-events-none"
    },
    isRound: {
      true: "tw-rounded-full",
      false: "tw-rounded-md"
    }
  },
  compoundVariants: [
    {
      colorScheme: "default",
      variant: "primary",
      class: "tw-bg-black tw-text-white hover:tw-bg-black/90 hover:tw-text-white"
    },
    {
      colorScheme: "default",
      variant: "secondary",
      class: "tw-border-light-300 tw-text-black tw-bg-white hover:tw-bg-light-100 hover:tw-text-black"
    },
    {
      colorScheme: "default",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-light-200 tw-text-black hover:tw-text-black"
    },
    {
      colorScheme: "default",
      variant: "link",
      class: "tw-text-black hover:tw-text-black"
    },
    {
      colorScheme: "destructive",
      variant: "primary",
      class: "tw-bg-error-700 tw-text-white hover:tw-bg-error-700/90 hover:tw-text-white"
    },
    {
      colorScheme: "destructive",
      variant: "secondary",
      class: "tw-border-error-200 tw-text-error-700 tw-bg-white hover:tw-bg-error-100 hover:tw-text-error-700"
    },
    {
      colorScheme: "destructive",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-error-200 tw-text-error-700 hover:tw-text-error-700"
    },
    {
      colorScheme: "destructive",
      variant: "link",
      class: "tw-text-error-700 hover:tw-text-error-700"
    },
    {
      colorScheme: "info",
      variant: "primary",
      class: "tw-bg-info-700 tw-text-white hover:tw-bg-info-700/90 hover:tw-text-white"
    },
    {
      colorScheme: "info",
      variant: "secondary",
      class: "tw-border-info-200 tw-text-info-700 tw-bg-white hover:tw-bg-info-25 hover:tw-text-info-700"
    },
    {
      colorScheme: "info",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-info-25 tw-text-info-700 hover:tw-text-info-700"
    },
    {
      colorScheme: "info",
      variant: "link",
      class: "tw-text-info-700 hover:tw-text-info-700"
    },
    {
      colorScheme: "warning",
      variant: "primary",
      class: "tw-bg-warning-800 tw-text-white hover:tw-bg-warning-800/90 hover:tw-text-white"
    },
    {
      colorScheme: "warning",
      variant: "secondary",
      class: "tw-border-warning-200 tw-text-warning-800 tw-bg-white hover:tw-bg-warning-200 hover:tw-text-warning-800"
    },
    {
      colorScheme: "warning",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-warning-25 tw-text-warning-800 hover:tw-text-warning-800"
    },
    {
      colorScheme: "warning",
      variant: "link",
      class: "tw-text-warning-800 hover:tw-text-warning-800"
    },
    {
      colorScheme: "success",
      variant: "primary",
      class: "tw-bg-success-700 tw-text-white hover:tw-bg-success-700/90 hover:tw-text-white"
    },
    {
      colorScheme: "success",
      variant: "secondary",
      class: "tw-border-success-200 tw-text-success-700 tw-bg-white hover:tw-bg-success-25 hover:tw-text-success-700"
    },
    {
      colorScheme: "success",
      variant: "ghost",
      class: "tw-bg-transparent hover:tw-bg-success-25 tw-text-success-700 hover:tw-text-success-700"
    },
    {
      colorScheme: "success",
      variant: "link",
      class: "tw-text-success-700 hover:tw-text-success-700"
    }
  ],
  defaultVariants: {
    variant: "primary",
    colorScheme: "default",
    size: "md",
    isRound: false
  }
});
var Button = forwardRef19(
  (_a, ref) => {
    var _b = _a, {
      asChild = false,
      className,
      colorScheme,
      disableAnimation,
      variant,
      size: size4,
      isDisabled,
      isIcon = false,
      isLoading,
      isRound = false,
      leftIcon,
      rightIcon,
      children
    } = _b, props = __objRest(_b, [
      "asChild",
      "className",
      "colorScheme",
      "disableAnimation",
      "variant",
      "size",
      "isDisabled",
      "isIcon",
      "isLoading",
      "isRound",
      "leftIcon",
      "rightIcon",
      "children"
    ]);
    var _a2, _b2, _c;
    const Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : "button";
    return /* @__PURE__ */ jsxs29(
      Comp,
      __spreadProps(__spreadValues({}, props), {
        className: cn([
          buttonVariants({
            colorScheme,
            variant,
            size: size4,
            isDisabled,
            isLoading,
            isRound,
            className
          }),
          { "tw-button-transform": !disableAnimation }
          // on press animation
        ]),
        type: asChild ? void 0 : (_a2 = props.type) != null ? _a2 : "button",
        disabled: isDisabled || props.disabled,
        role: asChild ? void 0 : "button",
        ref,
        children: [
          isLoading && /* @__PURE__ */ jsx38(Loader, {}),
          !isLoading && leftIcon && cloneElement7(leftIcon, {
            className: !((_b2 = leftIcon.props) == null ? void 0 : _b2.size) ? cn("tw-mr-2 tw-h-4 tw-w-4", leftIcon.props.className) : cn("tw-mr-2", leftIcon.props.className)
          }),
          /* @__PURE__ */ jsx38($5e63c961fc1ce211$export$d9f1ccf0bdb05d45, { children }),
          rightIcon && cloneElement7(rightIcon, {
            className: !((_c = rightIcon.props) == null ? void 0 : _c.size) ? cn("tw-ml-2 tw-h-4 tw-w-4", rightIcon.props.className) : cn("tw-ml-2", rightIcon.props.className)
          })
        ]
      })
    );
  }
);
Button.displayName = "Button";
function Loader() {
  return /* @__PURE__ */ jsx38(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin",
      children: /* @__PURE__ */ jsx38("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
    }
  );
}

// src/components/Breadcrumbs/Breadcrumbs.tsx
import { jsx as jsx39, jsxs as jsxs30 } from "react/jsx-runtime";
var Breadcrumbs = forwardRef20(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    const validChildren = getValidChildren(children);
    const count3 = validChildren.length;
    const clones = validChildren.map(
      (child, index2) => cloneElement8(child, {
        isFirstChild: index2 === 0,
        isLastChild: index2 === count3 - 1
      })
    );
    return /* @__PURE__ */ jsx39(
      "nav",
      __spreadProps(__spreadValues({
        "aria-label": "Breadcrumb",
        ref,
        className: cn("tw-reset tw-flex", className)
      }, props), {
        children: /* @__PURE__ */ jsx39("ol", { className: "tw-inline-flex tw-items-center tw-space-x-1 tw-md:space-x-3", children: clones })
      })
    );
  }
);
Breadcrumbs.displayName = "Breadcrumbs";
var BreadcrumbItem = forwardRef20((_a, ref) => {
  var _b = _a, { className, children, isFirstChild, isLastChild } = _b, props = __objRest(_b, ["className", "children", "isFirstChild", "isLastChild"]);
  return /* @__PURE__ */ jsxs30(
    "li",
    __spreadProps(__spreadValues({
      ref,
      className: cn("tw-inline-flex tw-items-center", className)
    }, props), {
      children: [
        !isFirstChild && /* @__PURE__ */ jsx39(ChevronRightIcon, { className: "tw-text-black/60 tw-h-3 tw-w-3" }),
        children
      ]
    })
  );
});
BreadcrumbItem.displayName = "BreadcrumbItem";
var BreadcrumbLink = forwardRef20((_a, ref) => {
  var _b = _a, { className, children, isCurrentPage } = _b, props = __objRest(_b, ["className", "children", "isCurrentPage"]);
  const { Link } = useNav();
  if (!Link)
    return null;
  return /* @__PURE__ */ jsx39(Button, { variant: "ghost", className: cn("tw-px-2", className), asChild: true, children: isCurrentPage ? /* @__PURE__ */ jsx39("span", __spreadProps(__spreadValues({ "aria-current": "page", ref }, props), { children })) : /* @__PURE__ */ jsx39(Link, __spreadProps(__spreadValues({ ref }, props), { children })) });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/components/HelpLinks.tsx
import { useMemo as useMemo7, useRef as useRef14 } from "react";
import { Fragment as Fragment8, jsx as jsx40, jsxs as jsxs31 } from "react/jsx-runtime";
var helpLinks = {
  academics: "https://help.teamworks.com/academics",
  ams: "https://help.teamworks.com/ams",
  arms: "http://help.armssoftware.com/en/",
  camps: "https://help.teamworks.com/camps",
  communities: "https://help.teamworks.com/communities",
  hub: "https://help.teamworks.com/hub",
  inflcr: "https://help.teamworks.com/influencer",
  inventory: "https://help.teamworks.com/inventorymanagement",
  notemeal: "https://help.teamworks.com/nutrition",
  nutrition: "https://help.teamworks.com/nutrition",
  pathways: "https://help.teamworks.com/pathways",
  pulse: "https://help.teamworks.com/pulse",
  retain: "https://help.teamworks.com/academics",
  trac: "https://help.teamworks.com/inventorymanagement",
  whistle: "https://help.teamworks.com/recruitingcommunication",
  smartabase: "https://help.teamworks.com/ams"
};
var HelpLinks = ({
  app,
  appSpecificHelpSubmenu,
  hasHelpCenter,
  hasLearningPortal,
  isAnimatedOut,
  isExpanded,
  onChatWithSupport,
  Link
}) => {
  const closeButtonRef = useRef14(null);
  const onClick = () => {
    var _a;
    (_a = closeButtonRef.current) == null ? void 0 : _a.click();
  };
  const externalLinks = useMemo7(() => {
    const result = [];
    if (hasHelpCenter) {
      result.push({
        name: getTranslation("helpCenter"),
        to: app && app in helpLinks ? helpLinks[app] : helpLinks["hub"]
      });
    }
    if (hasLearningPortal) {
      result.push({
        name: getTranslation("learningPortal"),
        to: "https://learn.teamworks.com/"
      });
    }
    return result;
  }, [app, hasHelpCenter, hasLearningPortal]);
  return /* @__PURE__ */ jsx40(MenuItem_default, { tooltip: getTranslation("teamworksHelp"), isExpanded, children: /* @__PURE__ */ jsxs31(Root22, { modal: false, children: [
    /* @__PURE__ */ jsx40(Trigger, { asChild: true, children: /* @__PURE__ */ jsxs31(
      "button",
      {
        className: clsx(
          "apps-popover-trigger",
          "tw-group tw-flex tw-justify-start tw-items-center",
          "tw-rounded-md tw-p-2 tw-text-lg tw-font-medium tw-font-sans",
          "tw-text-white hover:tw-bg-white/[0.15]",
          "tw-h-9 tw-w-full tw-cursor-pointer"
        ),
        children: [
          /* @__PURE__ */ jsx40(SupportIcon, {}),
          isAnimatedOut && /* @__PURE__ */ jsx40("span", { className: "tw-ml-2 tw-text-sm", children: getTranslation("teamworksHelp") })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx40(Portal2, { children: /* @__PURE__ */ jsxs31(
      Content2,
      {
        align: "start",
        side: "top",
        sideOffset: 10,
        className: "tw-w-[240px] tw-z-[1500]",
        children: [
          /* @__PURE__ */ jsx40(
            Close,
            {
              ref: closeButtonRef,
              className: "tw-sr-only",
              tabIndex: -1
            }
          ),
          /* @__PURE__ */ jsx40("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg rounded-md tw-border tw-border-light-200", children: /* @__PURE__ */ jsx40("div", { className: "tw-relative tw-bg-white tw-space-y-1 tw-py-2", children: /* @__PURE__ */ jsxs31("div", { className: "tw-max-h-[350px] tw-overflow-y-auto tw-space-y-1", children: [
            /* @__PURE__ */ jsx40("div", { className: "tw-flex tw-px-5 tw-py-2 tw-text-xs tw-text-light-500 tw-w-full", children: "Teamworks Help" }),
            onChatWithSupport && /* @__PURE__ */ jsx40(
              "button",
              {
                onClick: () => {
                  onChatWithSupport();
                  onClick();
                },
                className: "tw-flex tw-font-sans tw-text-sm tw-items-center hover:tw-bg-light-50 tw-px-5 tw-py-2 tw-text-black tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                children: getTranslation("chatWithSupport")
              }
            ),
            externalLinks.map((link) => {
              return /* @__PURE__ */ jsxs31(
                "a",
                {
                  href: link.to,
                  target: "_blank",
                  onClick,
                  className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-text-black hover:tw-text-black tw-items-center tw-px-5 tw-py-2 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                  rel: "noreferrer",
                  children: [
                    /* @__PURE__ */ jsx40("span", { children: link.name }),
                    /* @__PURE__ */ jsx40("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx40(ExternalLinkIcon, {}) })
                  ]
                },
                link.to
              );
            }),
            appSpecificHelpSubmenu && /* @__PURE__ */ jsxs31(Fragment8, { children: [
              !appSpecificHelpSubmenu.hideDivider && /* @__PURE__ */ jsx40(
                "div",
                {
                  "data-testid": "help-center-divider",
                  className: "tw-mx-3 tw-my-1 tw-h-px tw-bg-light-200"
                }
              ),
              appSpecificHelpSubmenu.label && /* @__PURE__ */ jsx40("div", { className: "tw-flex tw-px-5 tw-py-2 tw-text-xs tw-text-light-500 tw-w-full", children: appSpecificHelpSubmenu.label }),
              appSpecificHelpSubmenu.links.map((link) => {
                return link.to && Link ? /* @__PURE__ */ jsxs31(
                  Link,
                  {
                    to: link.to,
                    target: link.target,
                    onClick: () => {
                      var _a;
                      (_a = link.onClick) == null ? void 0 : _a.call(link);
                      onClick();
                    },
                    className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-text-black hover:tw-text-black tw-items-center tw-px-5 tw-py-2 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                    rel: "noreferrer",
                    children: [
                      link.icon && /* @__PURE__ */ jsx40("span", { className: "tw-mr-2 tw-text-lg", children: link.icon }),
                      /* @__PURE__ */ jsx40("span", { className: "tw-flex-1", children: link.name }),
                      !link.icon && /* @__PURE__ */ jsx40("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx40(ExternalLinkIcon, {}) })
                    ]
                  },
                  link.to
                ) : /* @__PURE__ */ jsxs31(
                  "button",
                  {
                    onClick: () => {
                      var _a;
                      (_a = link.onClick) == null ? void 0 : _a.call(link);
                      onClick();
                    },
                    className: "tw-flex tw-justify-between hover:tw-bg-light-50 tw-text-sm tw-text-black hover:tw-text-black tw-items-center tw-px-5 tw-py-2 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent focus:tw-outline-offset-[-1px] tw-w-full",
                    children: [
                      link.icon && /* @__PURE__ */ jsx40("span", { className: "tw-mr-2 tw-text-lg", children: link.icon }),
                      /* @__PURE__ */ jsx40("span", { className: cn(link.icon && "tw-flex-1"), children: link.name })
                    ]
                  },
                  link.name.toString()
                );
              })
            ] })
          ] }) }) })
        ]
      }
    ) })
  ] }) });
};
var HelpLinks_default = HelpLinks;

// src/components/HorizontalNav/HorizontalNav.tsx
import { forwardRef as forwardRef21 } from "react";
import { jsx as jsx41 } from "react/jsx-runtime";
var HorizontalNav = forwardRef21(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    const validChildren = getValidChildren(children);
    return /* @__PURE__ */ jsx41("nav", __spreadProps(__spreadValues({ ref, className: cn("tw-reset tw-w-full", className) }, props), { children: /* @__PURE__ */ jsx41("ul", { className: "tw-flex tw-items-center tw-border-b tw-border-light-300 tw-list-none", children: validChildren }) }));
  }
);
HorizontalNav.displayName = "HorizontalNav";
var HorizontalNavItem = forwardRef21(
  (_a, ref) => {
    var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
    return /* @__PURE__ */ jsx41("li", __spreadProps(__spreadValues({ ref, className }, props), { children }));
  }
);
HorizontalNavItem.displayName = "HorizontalNavItem";
var HorizontalNavLink = forwardRef21((_a, ref) => {
  var _b = _a, { active, className, children } = _b, props = __objRest(_b, ["active", "className", "children"]);
  const { Link } = useNav();
  if (!Link)
    return null;
  const focusStyle = "focus-visible:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-info-25 focus-visible:tw-ring-offset-info-700 focus-visible:tw-ring-offset-1 focus-visible:tw-rounded-md";
  return /* @__PURE__ */ jsx41(
    Link,
    __spreadProps(__spreadValues({
      ref,
      "aria-current": active ? "page" : void 0,
      className: cn(
        clsx(
          "tw-block tw-px-2 tw-py-4 tw-border-b-2 tw-text-black/60 tw-border-transparent hover:tw-text-black tw-transition-colors tw-rounded-none",
          {
            "tw-text-black tw-border-black hover:tw-text-black/90 tw-font-semibold": !!active
          }
        ),
        focusStyle,
        className
      ),
      activeClassName: "tw-text-black tw-border-black hover:tw-text-black/90 tw-font-semibold"
    }, props), {
      children
    })
  );
});
HorizontalNavLink.displayName = "HorizontalNavLink";

// src/components/Logo.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var Logo = ({ src, alt }) => {
  return /* @__PURE__ */ jsx43(
    "img",
    {
      alt,
      src,
      className: "tw-inline-flex tw-overflow-hidden tw-items-center tw-justify-center tw-h-10 tw-w-10 tw-text-xl tw-object-contain"
    }
  );
};
var Logo_default = Logo;

// src/components/PrimaryNavProvider/PrimaryNavProvider.tsx
import {
  createContext as createContext5,
  useCallback as useCallback10,
  useContext as useContext5,
  useEffect as useEffect18,
  useState as useState18
} from "react";

// src/utils/styles.ts
var getColorGradientCSS = (colors2) => {
  var _a;
  const gradient = `url("data:image/svg+xml,${encodeURIComponent(
    getBackgroundSvg(colors2.bottom)
  )}")`;
  const background = `${gradient} ${(_a = colors2.top) != null ? _a : "#000000"} no-repeat bottom left/470px 329px`;
  return {
    background
  };
};
var getBackgroundSvg = (fill) => `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 470 329"><g filter="url(#a)"><ellipse cx="88.1083" cy="332.133" fill="${fill}" rx="200.953" ry="119.038" transform="rotate(25 88.1083 332.133)"/></g><g filter="url(#b)"><path fill="${fill}" d="M230.6 121.045-22.7215 243.377l.0001 11.156L230.6 121.045Z"/></g><g filter="url(#c)"><ellipse cx="16.9442" cy="328.846" fill="${fill}" rx="87.7375" ry="85.4141" transform="rotate(25 16.9442 328.846)"/></g><defs><filter id="a" width="764.946" height="663.671" x="-294.365" y=".297455" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_2861_19880" stdDeviation="96.9609"/></filter><filter id="b" width="328.554" height="208.72" x="-60.3376" y="83.4292" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_2861_19880" stdDeviation="18.8081"/></filter><filter id="c" width="347.561" height="344.63" x="-156.836" y="156.531" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"/><feGaussianBlur result="effect1_foregroundBlur_2861_19880" stdDeviation="43.2235"/></filter></defs></svg>`;

// src/components/PrimaryNavProvider/PrimaryNavProvider.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var defaultNavState2 = {
  navState: { expanded: true },
  updateNavState: () => {
  }
};
var PrimaryNavContext = createContext5(defaultNavState2);
var usePrimaryNav = () => useContext5(PrimaryNavContext);
function PrimaryNavProvider(props) {
  const { colors: colors2 } = useNav();
  const { children, defaultOpen, onNavStateChanged } = props;
  const [navState, setNavState] = useState18({
    expanded: defaultOpen != null ? defaultOpen : defaultNavState2.navState.expanded
  });
  useEffect18(() => {
    onNavStateChanged == null ? void 0 : onNavStateChanged(navState);
  }, [onNavStateChanged, navState]);
  const updateNavState = useCallback10((toUpdate) => {
    setNavState((prevState) => {
      const nextState = __spreadValues(__spreadValues({}, prevState), toUpdate);
      return nextState;
    });
  }, []);
  return /* @__PURE__ */ jsx44(
    PrimaryNavContext.Provider,
    {
      value: {
        navState,
        updateNavState
      },
      children: /* @__PURE__ */ jsx44(
        "div",
        {
          id: "tw-shared-nav-provider",
          className: "tw-flex tw-h-screen",
          style: getColorGradientCSS(colors2),
          children
        }
      )
    }
  );
}
var PrimaryNavProvider_default = PrimaryNavProvider;

// src/components/SecondaryNav/SecondaryNav.tsx
import { forwardRef as forwardRef24, useMemo as useMemo10 } from "react";

// src/PrimaryNav.tsx
import { useCallback as useCallback11, useEffect as useEffect19, useMemo as useMemo9, useRef as useRef15, useState as useState20 } from "react";

// ../../node_modules/react-error-boundary/dist/react-error-boundary.esm.js
import { createContext as createContext6, Component, createElement as createElement6, isValidElement as isValidElement5, useContext as useContext6, useState as useState19, useMemo as useMemo8, forwardRef as forwardRef22 } from "react";
var ErrorBoundaryContext = createContext6(null);
var initialState = {
  didCatch: false,
  error: null
};
var ErrorBoundary = class extends Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;
    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = createElement6(FallbackComponent, props);
      } else if (fallback === null || isValidElement5(fallback)) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return createElement6(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
};
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index2) => !Object.is(item, b[index2]));
}

// src/components/Badge/Badge.tsx
import { jsx as jsx45 } from "react/jsx-runtime";
var base2 = [
  "tw-flex tw-items-center tw-justify-center tw-text-xs tw-rounded-full tw-px-2 tw-py-0.5"
];
var badgeVariants = cva(base2, {
  variants: {
    colorScheme: {
      count: "tw-bg-info-25 tw-text-info-700",
      default: "tw-bg-light-600 tw-text-white",
      destructive: "tw-bg-error-700 tw-text-white",
      info: "tw-bg-info-700 tw-text-white",
      success: "tw-bg-success-700 tw-text-white",
      warning: "tw-bg-warning-800 tw-text-white"
    }
  }
});
var Badge = (props) => {
  const { value, className, colorScheme, maxValue = 99 } = props;
  if (!value)
    return null;
  return /* @__PURE__ */ jsx45(
    "span",
    {
      className: cn(
        badgeVariants({
          colorScheme
        }),
        className
      ),
      children: value > maxValue ? `${maxValue}+` : value
    }
  );
};

// src/components/FriendlyError.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
function FriendlyError() {
  return /* @__PURE__ */ jsx46("div", { className: "tw-flex tw-h-screen tw-bg-gray-700 tw-items-center tw-justify-center tw-text-center tw-px-4", children: /* @__PURE__ */ jsx46("div", { className: "tw-text-red-400", children: getTranslation("requestError") }) });
}

// src/PrimaryNav.tsx
import { Fragment as Fragment9, jsx as jsx47, jsxs as jsxs32 } from "react/jsx-runtime";
var PRIMARY_NAV_COLLAPSED_WIDTH = 80;
var PRIMARY_NAV_EXPANDED_WIDTH = 270;
var PRIMARY_NAV_TRANSITION_DURATION = 300;
var PrimaryNav = (props) => {
  return /* @__PURE__ */ jsx47("div", { style: { maxWidth: PRIMARY_NAV_EXPANDED_WIDTH }, children: /* @__PURE__ */ jsx47(
    ErrorBoundary,
    {
      FallbackComponent: FriendlyError,
      onError: () => console.warn("There is an error with the PrimaryNav component."),
      children: /* @__PURE__ */ jsx47(PrimaryNavigation, __spreadValues({}, props))
    }
  ) });
};
var PrimaryNavigation = (_a) => {
  var innerProps = __objRest(_a, []);
  var _a2;
  const {
    additionalSettingsLinks,
    appSpecificHelpSubmenu,
    app,
    apps,
    collapseOnItemClick = true,
    colors: colors2,
    defaultOpen = true,
    hasAppSwitcher = true,
    hasTeamSwitcher = true,
    hasHelpCenter = true,
    hasLearningPortal = true,
    location = window == null ? void 0 : window.location,
    logo,
    links,
    team,
    onAppChange,
    onChatWithSupport,
    TeamSwitcher: TeamSwitcher2
  } = innerProps;
  const currentPath = (_a2 = location == null ? void 0 : location.pathname) != null ? _a2 : "";
  const [isExpanded, setIsExpanded] = useState20(defaultOpen);
  const { Link, colors: sharedNavColors } = useNav();
  const { navState: sharedNavState, updateNavState } = usePrimaryNav();
  const finalColors = useMemo9(
    () => colors2 != null ? colors2 : sharedNavColors,
    [colors2, sharedNavColors]
  );
  const gradient = useMemo9(
    () => finalColors ? getColorGradientCSS(finalColors) : {},
    [finalColors]
  );
  useEffect19(() => {
    if (sharedNavState.expanded !== isExpanded)
      updateNavState({ expanded: isExpanded });
  }, [isExpanded, sharedNavState, updateNavState]);
  const [isAnimatedOut, setIsAnimatedOut] = useState20(defaultOpen);
  const animationOutTimer = useRef15();
  const toggleMenu = useCallback11(() => {
    if (!isExpanded) {
      setIsExpanded(true);
      animationOutTimer.current = setTimeout(() => {
        setIsAnimatedOut(true);
      }, PRIMARY_NAV_TRANSITION_DURATION);
    } else {
      setIsExpanded(false);
      setIsAnimatedOut(false);
      clearTimeout(animationOutTimer.current);
    }
    updateNavState({ expanded: !isExpanded });
  }, [isExpanded, updateNavState]);
  const closeMenu = useCallback11(() => {
    isExpanded && toggleMenu();
  }, [isExpanded, toggleMenu]);
  const onItemClick = useCallback11(
    (_onClick) => (event) => {
      _onClick == null ? void 0 : _onClick(event);
      if (!event.defaultPrevented && collapseOnItemClick) {
        closeMenu();
      }
    },
    [closeMenu, collapseOnItemClick]
  );
  const account = {
    id: team.id,
    avatar: team.avatar
  };
  if (team.name) {
    account.name = team.name;
    account.organization = team.organization;
  } else {
    account.name = team.organization;
  }
  const TeamSwitcherComponent = TeamSwitcher2 != null ? TeamSwitcher2 : TeamSwitcher;
  return /* @__PURE__ */ jsx47(TooltipProvider2, { children: /* @__PURE__ */ jsx47(
    "div",
    {
      id: "tw-shared-nav",
      className: "tw-reset tw-flex tw-h-screen",
      style: gradient,
      children: /* @__PURE__ */ jsx47(
        "div",
        {
          className: clsx(
            `tw-inset-y-0 tw-flex tw-flex-col tw-transition-all tw-ease-in-out`,
            {
              "tw-collapsed": !isExpanded,
              "tw-expanded": isExpanded
            }
          ),
          style: {
            width: isExpanded ? PRIMARY_NAV_EXPANDED_WIDTH : PRIMARY_NAV_COLLAPSED_WIDTH,
            transitionDuration: `${PRIMARY_NAV_TRANSITION_DURATION}ms`
          },
          children: /* @__PURE__ */ jsxs32("div", { className: "tw-flex tw-flex-1 tw-flex-col tw-min-h-0 tw-relative", children: [
            /* @__PURE__ */ jsx47("div", { className: "tw-flex tw-flex-shrink-0 tw-flex-col tw-pt-4 tw-mb-4", children: /* @__PURE__ */ jsxs32("div", { className: "tw-flex tw-flex-col tw-flex-shrink-0 tw-items-center tw-px-[1.375rem] tw-space-y-1", children: [
              /* @__PURE__ */ jsx47("div", { className: "tw-flex tw-w-full tw-items-start", children: /* @__PURE__ */ jsx47("div", { className: "tw-flex tw-flex-col tw-w-18 tw-h-[60px] tw-items-center tw-justify-center tw-logo-wrapper", children: logo }) }),
              hasTeamSwitcher && /* @__PURE__ */ jsx47(
                TeamSwitcherComponent,
                {
                  isAnimatedOut,
                  isExpanded,
                  innerProps: __spreadProps(__spreadValues({}, innerProps), {
                    team: account
                  })
                }
              )
            ] }) }),
            /* @__PURE__ */ jsxs32("div", { className: "tw-flex tw-flex-1 tw-flex-col tw-justify-between tw-overflow-y-auto", children: [
              /* @__PURE__ */ jsxs32("nav", { className: "tw-flex tw-flex-col tw-space-y-1 tw-px-[1.375rem]", children: [
                /* @__PURE__ */ jsx47(
                  MenuItem_default,
                  {
                    tooltip: isExpanded ? getTranslation("closeMenu") : getTranslation("openMenu"),
                    isExpanded,
                    children: /* @__PURE__ */ jsx47(
                      "button",
                      {
                        type: "button",
                        className: "tw-text-white hover:tw-bg-white/[0.15] tw-group tw-flex tw-justify-start tw-items-center tw-rounded-md tw-p-2 tw-text-lg tw-font-medium tw-font-sans tw-w-full tw-h-9",
                        onClick: toggleMenu,
                        children: isExpanded ? /* @__PURE__ */ jsxs32(
                          "div",
                          {
                            id: "tw-collapse-nav",
                            className: "tw-flex tw-items-center",
                            children: [
                              /* @__PURE__ */ jsx47(CloseMenuIcon, {}),
                              isAnimatedOut && /* @__PURE__ */ jsx47("span", { className: "tw-ml-2 tw-text-sm", children: getTranslation("closeMenu") })
                            ]
                          }
                        ) : /* @__PURE__ */ jsxs32(Fragment9, { children: [
                          /* @__PURE__ */ jsx47(OpenMenuIcon, {}),
                          /* @__PURE__ */ jsx47("span", { className: "tw-sr-only", children: getTranslation("openMenu") })
                        ] })
                      }
                    )
                  }
                ),
                links.map((link, index2) => {
                  var _a3, _b, _c;
                  let isActive = link.isActive || (link.exact ? currentPath === link.to : currentPath.startsWith(link.to));
                  return /* @__PURE__ */ jsx47(
                    MenuItem_default,
                    {
                      tooltip: (_b = link.tooltip) != null ? _b : link.name,
                      isExpanded,
                      children: /* @__PURE__ */ jsx47(
                        Link,
                        {
                          target: link.target,
                          to: link.to,
                          onClick: onItemClick(link.onClick),
                          className: clsx(
                            "tw-cursor-pointer tw-text-white hover:tw-text-white tw-group tw-flex tw-justify-start tw-items-center tw-rounded-md tw-p-2 tw-text-lg tw-font-medium tw-h-9",
                            {
                              "tw-bg-white/[0.15]": isActive,
                              "hover:tw-bg-white/[0.15]": !isActive,
                              "tw-border tw-border-white/[0.15] tw-mx-[-1px]": link.isHighlighted
                            }
                          ),
                          linkid: index2,
                          children: /* @__PURE__ */ jsxs32("div", { className: "tw-flex tw-flex-row tw-items-center tw-w-full", children: [
                            (_c = link.icon) != null ? _c : /* @__PURE__ */ jsx47(DefaultIcon, {}),
                            /* @__PURE__ */ jsx47(
                              "span",
                              {
                                className: clsx(
                                  "tw-flex-1",
                                  isAnimatedOut ? "tw-ml-2 tw-text-sm tw-truncate" : "tw-sr-only"
                                ),
                                children: link.name
                              }
                            ),
                            /* @__PURE__ */ jsx47(
                              "span",
                              {
                                className: clsx({
                                  "tw-sr-only": !isAnimatedOut
                                }),
                                children: link.badgeValue ? /* @__PURE__ */ jsx47(Badge, { value: link.badgeValue }) : null
                              }
                            )
                          ] })
                        }
                      )
                    },
                    (_a3 = link.name) == null ? void 0 : _a3.toString()
                  );
                })
              ] }),
              /* @__PURE__ */ jsxs32("nav", { className: "tw-flex tw-flex-col tw-space-y-1 tw-px-[1.375rem] tw-pt-1 tw-pb-4", children: [
                (onChatWithSupport || hasHelpCenter || hasLearningPortal || appSpecificHelpSubmenu) && /* @__PURE__ */ jsx47(
                  HelpLinks_default,
                  {
                    app,
                    hasHelpCenter,
                    hasLearningPortal,
                    isAnimatedOut,
                    isExpanded,
                    onChatWithSupport,
                    appSpecificHelpSubmenu,
                    Link
                  }
                ),
                hasAppSwitcher && typeof onAppChange === "function" && /* @__PURE__ */ jsx47(
                  AppSwitcher,
                  {
                    app,
                    apps,
                    isExpanded,
                    isAnimatedOut,
                    onAppChange
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ jsx47("div", { className: "tw-flex tw-flex-shrink-0 tw-flex-col tw-pt-4 tw-mb-4", children: /* @__PURE__ */ jsx47("div", { className: "tw-flex tw-flex-col tw-flex-shrink-0 tw-items-center tw-px-[1.375rem] tw-space-y-1", children: /* @__PURE__ */ jsx47(
              AvatarMenu,
              {
                collapseOnItemClick,
                isAnimatedOut,
                isExpanded,
                additionalSettingsLinks,
                innerProps,
                toggleMenu
              }
            ) }) })
          ] })
        }
      )
    }
  ) });
};

// src/components/Heading/Heading.tsx
import { forwardRef as forwardRef23 } from "react";
import { jsx as jsx48 } from "react/jsx-runtime";
var headingVariants = cva("tw-text-black tw-font-semibold", {
  variants: {
    size: {
      display: "md:tw-text-5xl tw-text-4xl",
      h1: "tw-text-2xl",
      h2: "tw-text-xl",
      h3: "tw-text-base",
      h4: "tw-text-sm"
    },
    noOfLines: {
      1: "tw-line-clamp-1",
      2: "tw-line-clamp-2",
      3: "tw-line-clamp-3",
      4: "tw-line-clamp-4",
      5: "tw-line-clamp-5",
      6: "tw-line-clamp-6",
      7: "tw-line-clamp-7",
      8: "tw-line-clamp-8",
      9: "tw-line-clamp-9",
      10: "tw-line-clamp-10"
    }
  },
  defaultVariants: {
    size: "h2"
  }
});
var Heading = forwardRef23(
  (_a, ref) => {
    var _b = _a, { as = "h2", className, noOfLines, size: size4, children } = _b, props = __objRest(_b, ["as", "className", "noOfLines", "size", "children"]);
    const Component2 = as;
    return /* @__PURE__ */ jsx48(
      Component2,
      __spreadProps(__spreadValues({
        className: cn(
          headingVariants({
            size: size4,
            noOfLines,
            className
          })
        ),
        ref
      }, props), {
        children
      })
    );
  }
);
Heading.displayName = "Heading";

// src/components/SecondaryNav/SecondaryNav.tsx
import { jsx as jsx49, jsxs as jsxs33 } from "react/jsx-runtime";
var SecondaryNavContent = forwardRef24(
  ({ children, className }, ref) => /* @__PURE__ */ jsx49(
    "div",
    {
      className: cn(
        "tw-flex tw-flex-1 tw-flex-col tw-overflow-y-auto tw-pr-4 tw-mb-4 -tw-mr-4",
        className
      ),
      ref,
      children
    }
  )
);
SecondaryNavContent.displayName = "SecondaryNavContent";
var SecondaryNav = forwardRef24((_a, ref) => {
  var _b = _a, { className, children, colors: colors2, width = 200 } = _b, props = __objRest(_b, ["className", "children", "colors", "width"]);
  var _a2;
  const validChildren = getValidChildren(children);
  const { colors: sharedNavColors } = useNav();
  const { navState: sharedNavState } = usePrimaryNav();
  const finalColors = useMemo10(
    () => colors2 != null ? colors2 : sharedNavColors,
    [colors2, sharedNavColors]
  );
  const gradient = useMemo10(
    () => finalColors ? getColorGradientCSS(finalColors) : {},
    [finalColors]
  );
  const leftEdgeX = sharedNavState.expanded ? PRIMARY_NAV_EXPANDED_WIDTH : PRIMARY_NAV_COLLAPSED_WIDTH;
  return /* @__PURE__ */ jsx49(
    "div",
    {
      id: "tw-secondary-nav",
      className: cn("tw-reset tw-flex tw-h-full tw-dark", className),
      children: /* @__PURE__ */ jsx49(
        "div",
        {
          className: "tw-inset-y-0 tw-flex tw-flex-col",
          style: {
            width,
            background: (_a2 = finalColors == null ? void 0 : finalColors.top) != null ? _a2 : "transparent"
          },
          children: /* @__PURE__ */ jsx49(
            "div",
            {
              className: "tw-flex tw-flex-1 tw-flex-col tw-min-h-0 tw-relative tw-px-4 tw-border tw-border-b-0 tw-border-r-0 tw-border-white/[0.24] tw-rounded-tl-2xl tw-transition-all tw-ease-in-out",
              style: __spreadProps(__spreadValues({}, gradient), {
                transitionDuration: `${PRIMARY_NAV_TRANSITION_DURATION}ms`,
                backgroundPositionX: -leftEdgeX
              }),
              children: validChildren
            }
          )
        }
      )
    }
  );
});
SecondaryNav.displayName = "SecondaryNav";
var SecondaryNavTitle = forwardRef24(({ className, children, icon }, ref) => {
  return /* @__PURE__ */ jsx49("div", { className: "tw-mb-4 tw-pt-8 tw-pb-4 tw-border-b tw-border-white/[0.24]", children: /* @__PURE__ */ jsxs33(
    Heading,
    {
      size: "h4",
      as: "h2",
      noOfLines: 1,
      className: cn(
        "tw-flex tw-items-center tw-justify-start tw-text-white",
        className
      ),
      ref,
      children: [
        icon && /* @__PURE__ */ jsx49("span", { className: "tw-text-xl tw-mr-2", children: icon }),
        children
      ]
    }
  ) });
});
SecondaryNavTitle.displayName = "SecondaryNavTitle";

// src/components/TeamSwitcher.tsx
import { useMemo as useMemo11, useRef as useRef16, useState as useState21 } from "react";
import { Fragment as Fragment10, jsx as jsx50, jsxs as jsxs34 } from "react/jsx-runtime";
var TeamSwitcher = ({
  innerProps,
  isAnimatedOut,
  isExpanded
}) => {
  const [search, setSearch] = useState21("");
  const closeButtonRef = useRef16(null);
  const {
    team: {
      avatar: currentAvatar,
      name: currentTeamName,
      organization: currentOrganization
    },
    teams,
    onTeamChange,
    onOrgChange
  } = innerProps;
  const requiresSearch = !!teams && teams.length >= 10;
  const filteredTeams = useMemo11(() => {
    if (!teams)
      return [];
    if (!requiresSearch || !search)
      return teams != null ? teams : [];
    return teams.filter(
      (team) => {
        var _a;
        return (_a = team.name) == null ? void 0 : _a.toLowerCase().includes(search.toLowerCase());
      }
    );
  }, [requiresSearch, search, teams]);
  const showTeamSwitcher = teams && teams.length > 1 || typeof onOrgChange === "function";
  return /* @__PURE__ */ jsxs34(Root22, { children: [
    /* @__PURE__ */ jsx50(Trigger, { asChild: true, children: /* @__PURE__ */ jsx50("button", { className: "tw-group tw-block tw-flex-shrink-0 tw--mx-4 tw-px-0 tw-w-[calc(100%+1.25rem)]", children: /* @__PURE__ */ jsx50(MenuItem_default, { tooltip: currentTeamName, isExpanded, children: /* @__PURE__ */ jsx50(
      "div",
      {
        className: clsx(
          "teams-popover-trigger",
          "tw-rounded-md tw-p-2 hover:tw-bg-white/[0.15] hover:tw-border-white/10",
          "tw-transition-all tw-duration-300 tw-ease-in-out tw-border",
          {
            "tw-bg-white/[0.15] tw-border-white/10": isExpanded,
            "tw-border-opacity-0 tw-border-black": !isExpanded,
            "tw-cursor-pointer": teams && teams.length > 1
          }
        ),
        children: /* @__PURE__ */ jsxs34("div", { className: "tw-flex tw-items-center", children: [
          /* @__PURE__ */ jsx50("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: currentAvatar ? /* @__PURE__ */ jsx50(Logo_default, { alt: currentTeamName != null ? currentTeamName : "Logo", src: currentAvatar }) : /* @__PURE__ */ jsx50(Avatar, { size: 40, name: currentTeamName }) }),
          isAnimatedOut && /* @__PURE__ */ jsxs34(Fragment10, { children: [
            /* @__PURE__ */ jsxs34("div", { className: "tw-text-left tw-ml-3 tw-flex-auto tw-font-medium tw-font-sans tw-truncate", children: [
              /* @__PURE__ */ jsx50("div", { className: "tw-text-white tw-text-sm tw-truncate", children: currentTeamName }),
              currentOrganization && /* @__PURE__ */ jsx50("div", { className: "tw-text-white/60 tw-text-[11px] tw-leading-3 tw-truncate", children: currentOrganization })
            ] }),
            /* @__PURE__ */ jsx50("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: showTeamSwitcher && /* @__PURE__ */ jsxs34("div", { className: "tw-text-white tw-p-2 tw-font-medium tw-rounded-md", children: [
              /* @__PURE__ */ jsx50("span", { className: "tw-sr-only", children: getTranslation("changeTeam") }),
              /* @__PURE__ */ jsx50(SwitchIcon, {})
            ] }) })
          ] })
        ] })
      }
    ) }) }) }),
    /* @__PURE__ */ jsx50(Close, { ref: closeButtonRef, tabIndex: -1 }),
    /* @__PURE__ */ jsx50(Portal2, { children: showTeamSwitcher && /* @__PURE__ */ jsx50(
      Content2,
      {
        align: "start",
        side: "bottom",
        sideOffset: 10,
        className: "tw-reset tw-min-w-[256px] tw-z-[1500]",
        children: /* @__PURE__ */ jsx50("div", { className: "tw-overflow-hidden tw-rounded-md tw-shadow-lg tw-border tw-border-light-200", children: /* @__PURE__ */ jsxs34("div", { className: "tw-relative tw-bg-white tw-space-y-2 tw-py-2", children: [
          onOrgChange && typeof onOrgChange === "function" && /* @__PURE__ */ jsx50("div", { className: "tw-flex tw-items-center tw-justify-end tw-px-2 ", children: /* @__PURE__ */ jsxs34(
            "button",
            {
              className: "tw-flex tw-space-x-2 tw-py-1 tw-text-blue-500 tw-font-semibold tw-text-sm tw-rounded-sm tw-border-none",
              onClick: () => {
                var _a;
                (_a = closeButtonRef.current) == null ? void 0 : _a.click();
                onOrgChange == null ? void 0 : onOrgChange();
                setSearch("");
              },
              children: [
                /* @__PURE__ */ jsx50("span", { children: getTranslation("switchOrgs") }),
                /* @__PURE__ */ jsx50("span", { className: "tw-text-lg", children: /* @__PURE__ */ jsx50(SwitchIcon, {}) })
              ]
            }
          ) }),
          requiresSearch && /* @__PURE__ */ jsxs34("div", { className: "tw-px-2", children: [
            /* @__PURE__ */ jsx50("label", { htmlFor: "team-search", className: "tw-sr-only", children: getTranslation("search") }),
            /* @__PURE__ */ jsx50(
              "input",
              {
                type: "text",
                name: "team-search",
                id: "team-search",
                className: "tw-block tw-w-full tw-rounded-md tw-border-0 tw-py-2 tw-px-4 tw-text-gray-900 tw-text-sm tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-light-300 tw-placeholder:text-light-400 focus:tw-ring-inset tw-sm:leading-6",
                placeholder: getTranslation("searchForTeam"),
                value: search,
                onChange: (e) => setSearch(e.target.value)
              }
            )
          ] }),
          /* @__PURE__ */ jsx50("div", { className: "tw-space-y-1 tw-max-h-[350px] tw-overflow-y-auto tw-py-1 tw-px-2", children: filteredTeams.map((team) => /* @__PURE__ */ jsxs34(
            "button",
            {
              "aria-label": team.name,
              type: "button",
              className: "tw-flex tw-items-center tw-px-3 tw-py-2 tw-rounded-md tw-bg-white hover:tw-bg-light-50 focus:tw-bg-light-50 tw-cursor-pointer tw-border-transparent focus:tw-border-transparent tw-w-full",
              onClick: () => {
                var _a;
                (_a = closeButtonRef.current) == null ? void 0 : _a.click();
                onTeamChange == null ? void 0 : onTeamChange(team.id);
                setSearch("");
              },
              children: [
                /* @__PURE__ */ jsx50("div", { className: "tw-flex tw-flex-none tw-items-center tw-justify-center", children: /* @__PURE__ */ jsx50(Avatar, { src: team.avatar, name: team.name, size: 40 }) }),
                /* @__PURE__ */ jsx50("div", { className: "tw-ml-3", children: /* @__PURE__ */ jsx50("span", { className: "tw-text-sm tw-font-sans tw-font-medium tw-text-gray-900 tw-text-left tw-truncate", children: team.name }) })
              ]
            },
            team.id
          )) })
        ] }) })
      }
    ) })
  ] });
};
export {
  AbstractLink,
  App,
  AppSwitcher,
  BreadcrumbItem,
  BreadcrumbLink,
  Breadcrumbs,
  HelpLinks_default as HelpLinks,
  HorizontalNav,
  HorizontalNavItem,
  HorizontalNavLink,
  Logo_default as Logo,
  MenuItem_default as MenuItem,
  NavProvider_default as NavProvider,
  PRIMARY_NAV_COLLAPSED_WIDTH,
  PRIMARY_NAV_EXPANDED_WIDTH,
  PRIMARY_NAV_TRANSITION_DURATION,
  PrimaryNav,
  PrimaryNavProvider_default as PrimaryNavProvider,
  SecondaryNav,
  SecondaryNavContent,
  SecondaryNavTitle,
  TeamSwitcher,
  VerticalNav,
  VerticalNavButton,
  VerticalNavGroup,
  VerticalNavIcon,
  VerticalNavItem,
  VerticalNavLink,
  VerticalNavSeparator,
  getColorGradientCSS,
  useNav,
  usePrimaryNav
};
